/**
 * 銀行代碼資料
 */
export const BankCodes = [
  {"code": "000", "name": "中央銀行國庫局　　　　　　　　　　　　　"},
  {"code": "004", "name": "臺灣銀行　　　　　　　　　　　　　　　　"},
  {"code": "005", "name": "臺灣土地銀行　　　　　　　　　　　　　　"},
  {"code": "006", "name": "合作金庫商業銀行　　　　　　　　　　　　"},
  {"code": "007", "name": "第一商業銀行　　　　　　　　　　　　　　"},
  {"code": "008", "name": "華南商業銀行　　　　　　　　　　　　　　"},
  {"code": "009", "name": "彰化商業銀行　　　　　　　　　　　　　　"},
  {"code": "011", "name": "上海商業儲蓄銀行　　　　　　　　　　　　"},
  {"code": "012", "name": "台北富邦商業銀行　　　　　　　　　　　　"},
  {"code": "013", "name": "國泰世華商業銀行　　　　　　　　　　　　"},
  {"code": "016", "name": "高雄銀行　　　　　　　　　　　　　　　　"},
  {"code": "017", "name": "兆豐國際商業銀行　　　　　　　　　　　　"},
  {"code": "018", "name": "全國農業金庫　　　　　　　　　　　　　　"},
  {"code": "020", "name": "日商瑞穗銀行台北分行　　　　　　　　　　"},
  {"code": "021", "name": "花旗（台灣）商業銀行　　　　　　　　　　"},
  {"code": "022", "name": "美國銀行台北分行　　　　　　　　　　　　"},
  {"code": "023", "name": "泰國盤谷銀行台北分行　　　　　　　　　　"},
  {"code": "025", "name": "菲律賓首都銀行台北分行　　　　　　　　　"},
  {"code": "029", "name": "新加坡商大華銀行台北分行　　　　　　　　"},
  {"code": "030", "name": "美商道富銀行台北分行　　　　　　　　　　"},
  {"code": "037", "name": "法商法國興業銀行台北分行　　　　　　　　"},
  {"code": "039", "name": "澳商澳盛銀行台北分行　　　　　　　　　　"},
  {"code": "048", "name": "王道商業銀行　　　　　　　　　　　　　　"},
  {"code": "050", "name": "臺灣中小企業銀行　　　　　　　　　　　　"},
  {"code": "052", "name": "渣打國際商業銀行　　　　　　　　　　　　"},
  {"code": "053", "name": "台中商業銀行　　　　　　　　　　　　　　"},
  {"code": "054", "name": "京城商業銀行　　　　　　　　　　　　　　"},
  {"code": "060", "name": "兆豐票券金融股份有限公司　　　　　　　　"},
  {"code": "061", "name": "中華票券金融股份有限公司　　　　　　　　"},
  {"code": "062", "name": "國際票券金融股份有限公司　　　　　　　　"},
  {"code": "066", "name": "萬通票券金融股份有限公司　　　　　　　　"},
  {"code": "072", "name": "德商德意志銀行台北分行　　　　　　　　　"},
  {"code": "075", "name": "香港商東亞銀行台北分行　　　　　　　　　"},
  {"code": "076", "name": "美商摩根大通銀行台北分行　　　　　　　　"},
  {"code": "081", "name": "匯豐（台灣）商業銀行　　　　　　　　　　"},
  {"code": "082", "name": "法國巴黎銀行台北分行　　　　　　　　　　"},
  {"code": "085", "name": "新加坡商新加坡華僑銀行台北分行　　　　　"},
  {"code": "086", "name": "法商東方匯理銀行台北分行　　　　　　　　"},
  {"code": "092", "name": "瑞士商瑞士銀行台北分行　　　　　　　　　"},
  {"code": "093", "name": "荷商安智銀行台北分行　　　　　　　　　　"},
  {"code": "098", "name": "日商三菱日聯銀行台北分行　　　　　　　　"},
  {"code": "101", "name": "瑞興商業銀行　　　　　　　　　　　　　　"},
  {"code": "102", "name": "華泰商業銀行　　　　　　　　　　　　　　"},
  {"code": "103", "name": "臺灣新光商業銀行　　　　　　　　　　　　"},
  {"code": "104", "name": "台北市第五信用合作社　　　　　　　　　　"},
  {"code": "108", "name": "陽信商業銀行　　　　　　　　　　　　　　"},
  {"code": "114", "name": "基隆第一信用合作社　　　　　　　　　　　"},
  {"code": "115", "name": "基隆市第二信用合作社　　　　　　　　　　"},
  {"code": "118", "name": "板信商業銀行　　　　　　　　　　　　　　"},
  {"code": "119", "name": "淡水第一信用合作社　　　　　　　　　　　"},
  {"code": "120", "name": "新北市淡水信用合作社　　　　　　　　　　"},
  {"code": "124", "name": "宜蘭信用合作社　　　　　　　　　　　　　"},
  {"code": "127", "name": "桃園信用合作社　　　　　　　　　　　　　"},
  {"code": "130", "name": "新竹第一信用合作社　　　　　　　　　　　"},
  {"code": "132", "name": "新竹第三信用合作社　　　　　　　　　　　"},
  {"code": "146", "name": "台中市第二信用合作社　　　　　　　　　　"},
  {"code": "147", "name": "三信商業銀行　　　　　　　　　　　　　　"},
  {"code": "158", "name": "彰化第一信用合作社　　　　　　　　　　　"},
  {"code": "161", "name": "彰化第五信用合作社　　　　　　　　　　　"},
  {"code": "162", "name": "彰化第六信用合作社　　　　　　　　　　　"},
  {"code": "163", "name": "彰化第十信用合作社　　　　　　　　　　　"},
  {"code": "165", "name": "彰化縣鹿港信用合作社　　　　　　　　　　"},
  {"code": "178", "name": "嘉義市第三信用合作社　　　　　　　　　　"},
  {"code": "188", "name": "台南第三信用合作社　　　　　　　　　　　"},
  {"code": "204", "name": "高雄市第三信用合作社　　　　　　　　　　"},
  {"code": "215", "name": "花蓮第一信用合作社　　　　　　　　　　　"},
  {"code": "216", "name": "花蓮第二信用合作社　　　　　　　　　　　"},
  {"code": "222", "name": "澎湖縣第一信用合作社　　　　　　　　　　"},
  {"code": "223", "name": "澎湖第二信用合作社　　　　　　　　　　　"},
  {"code": "224", "name": "金門縣信用合作社　　　　　　　　　　　　"},
  {"code": "321", "name": "日商三井住友銀行台北分行　　　　　　　　"},
  {"code": "326", "name": "西班牙商西班牙對外銀行臺北分行　　　　　"},
  {"code": "372", "name": "大慶票券金融股份有限公司　　　　　　　　"},
  {"code": "380", "name": "大陸商中國銀行臺北分行　　　　　　　　　"},
  {"code": "381", "name": "大陸商交通銀行臺北分行　　　　　　　　　"},
  {"code": "382", "name": "大陸商中國建設銀行臺北分行　　　　　　　"},
  {"code": "501", "name": "宜蘭縣蘇澳區漁會（農金資訊所屬會員）　　"},
  {"code": "502", "name": "宜蘭縣頭城區漁會（農金資訊所屬會員）　　"},
  {"code": "506", "name": "桃園區漁會（農金資訊所屬會員）　　　　　"},
  {"code": "507", "name": "新竹區漁會（農金資訊所屬會員）　　　　　"},
  {"code": "508", "name": "通苑區漁會（農金資訊所屬會員）　　　　　"},
  {"code": "510", "name": "南龍區漁會（農金資訊所屬會員）　　　　　"},
  {"code": "511", "name": "彰化區漁會（農金資訊所屬會員）　　　　　"},
  {"code": "512", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "513", "name": "新北市瑞芳區漁會（農金資訊所屬會員）　　"},
  {"code": "514", "name": "萬里區漁會（農金資訊所屬會員）　　　　　"},
  {"code": "515", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "516", "name": "基隆區漁會（農金資訊所屬會員）　　　　　"},
  {"code": "517", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "518", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "519", "name": "新化區農會（農金資訊所屬會員）　　　　　"},
  {"code": "520", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "521", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "523", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "524", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "525", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "526", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "538", "name": "宜蘭市農會（農金資訊所屬會員）　　　　　"},
  {"code": "541", "name": "白河區農會（農金資訊所屬會員）　　　　　"},
  {"code": "542", "name": "麻豆區農會（農金資訊所屬會員）　　　　　"},
  {"code": "547", "name": "後壁區農會（農金資訊所屬會員）　　　　　"},
  {"code": "549", "name": "下營區農會（農金資訊所屬會員）　　　　　"},
  {"code": "551", "name": "官田區農會（農金資訊所屬會員）　　　　　"},
  {"code": "552", "name": "大內區農會（農金資訊所屬會員）　　　　　"},
  {"code": "556", "name": "學甲區農會（農金資訊所屬會員）　　　　　"},
  {"code": "557", "name": "新市區農會（農金資訊所屬會員）　　　　　"},
  {"code": "558", "name": "安定區農會（農金資訊所屬會員）　　　　　"},
  {"code": "559", "name": "山上區農會（農金資訊所屬會員）　　　　　"},
  {"code": "561", "name": "左鎮區農會（農金資訊所屬會員）　　　　　"},
  {"code": "562", "name": "仁德區農會（農金資訊所屬會員）　　　　　"},
  {"code": "564", "name": "關廟區農會（農金資訊所屬會員）　　　　　"},
  {"code": "565", "name": "龍崎區農會（農金資訊所屬會員）　　　　　"},
  {"code": "567", "name": "南化區農會（農金資訊所屬會員）　　　　　"},
  {"code": "568", "name": "七股區農會（農金資訊所屬會員）　　　　　"},
  {"code": "570", "name": "南投市農會（農金資訊所屬會員）　　　　　"},
  {"code": "573", "name": "埔里鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "574", "name": "竹山鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "575", "name": "中寮鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "577", "name": "魚池鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "578", "name": "水里鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "579", "name": "國姓鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "580", "name": "鹿谷鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "581", "name": "信義鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "582", "name": "仁愛鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "583", "name": "東山區農會（農金資訊所屬會員）　　　　　"},
  {"code": "585", "name": "頭城鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "586", "name": "羅東鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "587", "name": "礁溪鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "588", "name": "壯圍鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "589", "name": "員山鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "596", "name": "五結鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "598", "name": "蘇澳地區農會（農金資訊所屬會員）　　　　"},
  {"code": "599", "name": "三星地區農會（農金資訊所屬會員）　　　　"},
  {"code": "600", "name": "農金資訊股份有限公司　　　　　　　　　　"},
  {"code": "602", "name": "中華民國農會中壢辦事處信用部（農金資訊所"},
  {"code": "605", "name": "高雄市高雄地區農會（農金資訊所屬會員）　"},
  {"code": "612", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "613", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "614", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "615", "name": "基隆市農會（農金資訊所屬會員）　　　　　"},
  {"code": "616", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "617", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "618", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "619", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "620", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "621", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "622", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "624", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "625", "name": "臺中市臺中地區農會（農金資訊所屬會員）　"},
  {"code": "627", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "628", "name": "鹿港鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "629", "name": "和美鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "631", "name": "溪湖鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "632", "name": "田中鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "633", "name": "北斗鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "635", "name": "線西鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "636", "name": "伸港鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "638", "name": "花壇鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "639", "name": "大村鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "642", "name": "社頭鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "643", "name": "二水鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "646", "name": "大城鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "647", "name": "溪州鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "649", "name": "埔鹽鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "650", "name": "福興鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "651", "name": "彰化市農會（農金資訊所屬會員）　　　　　"},
  {"code": "683", "name": "北港鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "685", "name": "土庫鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "693", "name": "東勢鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "696", "name": "水林鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "697", "name": "元長鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "698", "name": "麥寮鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "699", "name": "林內鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "700", "name": "中華郵政股份有限公司　　　　　　　　　　"},
  {"code": "749", "name": "內埔地區農會（農金資訊所屬會員）　　　　"},
  {"code": "762", "name": "大溪區農會（農金資訊所屬會員）　　　　　"},
  {"code": "763", "name": "桃園區農會（農金資訊所屬會員）　　　　　"},
  {"code": "764", "name": "平鎮區農會（農金資訊所屬會員）　　　　　"},
  {"code": "765", "name": "楊梅區農會（農金資訊所屬會員）　　　　　"},
  {"code": "766", "name": "大園區農會（農金資訊所屬會員）　　　　　"},
  {"code": "767", "name": "蘆竹區農會（農金資訊所屬會員）　　　　　"},
  {"code": "768", "name": "龜山區農會（農金資訊所屬會員）　　　　　"},
  {"code": "769", "name": "八德區農會（農金資訊所屬會員）　　　　　"},
  {"code": "770", "name": "新屋區農會（農金資訊所屬會員）　　　　　"},
  {"code": "771", "name": "龍潭區農會（農金資訊所屬會員）　　　　　"},
  {"code": "772", "name": "復興區農會（農金資訊所屬會員）　　　　　"},
  {"code": "773", "name": "觀音區農會（農金資訊所屬會員）　　　　　"},
  {"code": "775", "name": "土城區農會（農金資訊所屬會員）　　　　　"},
  {"code": "776", "name": "三重區農會（農金資訊所屬會員）　　　　　"},
  {"code": "777", "name": "中和地區農會（農金資訊所屬會員）　　　　"},
  {"code": "778", "name": "淡水區農會（農金資訊所屬會員）　　　　　"},
  {"code": "779", "name": "樹林區農會（農金資訊所屬會員）　　　　　"},
  {"code": "780", "name": "鶯歌區農會（農金資訊所屬會員）　　　　　"},
  {"code": "781", "name": "三峽區農會（農金資訊所屬會員）　　　　　"},
  {"code": "785", "name": "蘆洲區農會（農金資訊所屬會員）　　　　　"},
  {"code": "786", "name": "五股區農會（農金資訊所屬會員）　　　　　"},
  {"code": "787", "name": "林口區農會（農金資訊所屬會員）　　　　　"},
  {"code": "788", "name": "泰山區農會（農金資訊所屬會員）　　　　　"},
  {"code": "789", "name": "坪林區農會（農金資訊所屬會員）　　　　　"},
  {"code": "790", "name": "八里區農會（農金資訊所屬會員）　　　　　"},
  {"code": "791", "name": "金山地區農會（農金資訊所屬會員）　　　　"},
  {"code": "792", "name": "瑞芳地區農會（農金資訊所屬會員）　　　　"},
  {"code": "793", "name": "新店地區農會（農金資訊所屬會員）　　　　"},
  {"code": "795", "name": "深坑區農會（農金資訊所屬會員）　　　　　"},
  {"code": "796", "name": "石碇區農會（農金資訊所屬會員）　　　　　"},
  {"code": "797", "name": "平溪區農會（農金資訊所屬會員）　　　　　"},
  {"code": "798", "name": "石門區農會（農金資訊所屬會員）　　　　　"},
  {"code": "799", "name": "三芝區農會（農金資訊所屬會員）　　　　　"},
  {"code": "803", "name": "聯邦商業銀行　　　　　　　　　　　　　　"},
  {"code": "805", "name": "遠東國際商業銀行　　　　　　　　　　　　"},
  {"code": "806", "name": "元大商業銀行　　　　　　　　　　　　　　"},
  {"code": "807", "name": "永豐商業銀行　　　　　　　　　　　　　　"},
  {"code": "808", "name": "玉山商業銀行　　　　　　　　　　　　　　"},
  {"code": "809", "name": "凱基商業銀行　　　　　　　　　　　　　　"},
  {"code": "810", "name": "星展（台灣）商業銀行　　　　　　　　　　"},
  {"code": "812", "name": "台新國際商業銀行　　　　　　　　　　　　"},
  {"code": "815", "name": "日盛國際商業銀行　　　　　　　　　　　　"},
  {"code": "816", "name": "安泰商業銀行　　　　　　　　　　　　　　"},
  {"code": "822", "name": "中國信託商業銀行　　　　　　　　　　　　"},
  {"code": "860", "name": "中埔鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "866", "name": "阿里山鄉農會（農金資訊所屬會員）　　　　"},
  {"code": "868", "name": "東勢區農會（農金資訊所屬會員）　　　　　"},
  {"code": "869", "name": "清水區農會（農金資訊所屬會員）　　　　　"},
  {"code": "870", "name": "梧棲區農會（農金資訊所屬會員）　　　　　"},
  {"code": "871", "name": "大甲區農會（農金資訊所屬會員）　　　　　"},
  {"code": "872", "name": "沙鹿區農會（農金資訊所屬會員）　　　　　"},
  {"code": "874", "name": "霧峰區農會（農金資訊所屬會員）　　　　　"},
  {"code": "875", "name": "太平區農會（農金資訊所屬會員）　　　　　"},
  {"code": "876", "name": "烏日區農會（農金資訊所屬會員）　　　　　"},
  {"code": "877", "name": "后里區農會（農金資訊所屬會員）　　　　　"},
  {"code": "878", "name": "大雅區農會（農金資訊所屬會員）　　　　　"},
  {"code": "879", "name": "潭子區農會（農金資訊所屬會員）　　　　　"},
  {"code": "880", "name": "石岡區農會（農金資訊所屬會員）　　　　　"},
  {"code": "881", "name": "新社區農會（農金資訊所屬會員）　　　　　"},
  {"code": "882", "name": "大肚區農會（農金資訊所屬會員）　　　　　"},
  {"code": "883", "name": "外埔區農會（農金資訊所屬會員）　　　　　"},
  {"code": "884", "name": "大安區農會（農金資訊所屬會員）　　　　　"},
  {"code": "885", "name": "龍井區農會（農金資訊所屬會員）　　　　　"},
  {"code": "886", "name": "和平區農會（農金資訊所屬會員）　　　　　"},
  {"code": "891", "name": "花蓮市農會（農金資訊所屬會員）　　　　　"},
  {"code": "895", "name": "瑞穗鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "896", "name": "玉溪地區農會（農金資訊所屬會員）　　　　"},
  {"code": "897", "name": "鳳榮地區農會（農金資訊所屬會員）　　　　"},
  {"code": "898", "name": "光豐地區農會（農金資訊所屬會員）　　　　"},
  {"code": "901", "name": "大里區農會（農金資訊所屬會員）　　　　　"},
  {"code": "902", "name": "苗栗市農會（農金資訊所屬會員）　　　　　"},
  {"code": "903", "name": "汐止區農會（農金資訊所屬會員）　　　　　"},
  {"code": "904", "name": "新莊區農會（農金資訊所屬會員）　　　　　"},
  {"code": "906", "name": "頭份市農會（農金資訊所屬會員）　　　　　"},
  {"code": "907", "name": "竹南鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "908", "name": "通霄鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "909", "name": "苑裡鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "912", "name": "冬山鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "913", "name": "後龍鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "914", "name": "卓蘭鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "915", "name": "西湖鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "916", "name": "草屯鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "917", "name": "公館鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "918", "name": "銅鑼鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "919", "name": "三義鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "920", "name": "造橋鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "921", "name": "南庄鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "922", "name": "臺南市臺南地區農會（農金資訊所屬會員）　"},
  {"code": "923", "name": "獅潭鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "924", "name": "頭屋鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "925", "name": "三灣鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "926", "name": "大湖地區農會（農金資訊所屬會員）　　　　"},
  {"code": "928", "name": "板橋區農會（農金資訊所屬會員）　　　　　"},
  {"code": "929", "name": "關西鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "930", "name": "新埔鎮農會（農金資訊所屬會員）　　　　　"},
  {"code": "931", "name": "竹北市農會（農金資訊所屬會員）　　　　　"},
  {"code": "932", "name": "湖口鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "933", "name": "芎林鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "934", "name": "寶山鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "935", "name": "峨眉鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "936", "name": "北埔鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "937", "name": "竹東地區農會（農金資訊所屬會員）　　　　"},
  {"code": "938", "name": "橫山地區農會（農金資訊所屬會員）　　　　"},
  {"code": "939", "name": "新豐鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "940", "name": "新竹市農會信用部（農金資訊所屬會員）　　"},
  {"code": "952", "name": "財團法人農漁會南區資訊中心　　　　　　　"},
  {"code": "952", "name": "南農中心所屬會員　　　　　　　　　　　　"},
  {"code": "953", "name": "田尾鄉農會（農金資訊所屬會員）　　　　　"},
  {"code": "984", "name": "北投區農會（農金資訊所屬會員）　　　　　"},
  {"code": "985", "name": "士林區農會（農金資訊所屬會員）　　　　　"},
  {"code": "986", "name": "內湖區農會（農金資訊所屬會員）　　　　　"},
  {"code": "987", "name": "南港區農會（農金資訊所屬會員）　　　　　"},
  {"code": "988", "name": "木柵區農會（農金資訊所屬會員）　　　　　"},
  {"code": "989", "name": "景美區農會（農金資訊所屬會員）　　　　　"},
  {"code": "995", "name": "關貿網路股份有限公司　　　　　　　　　　"},
  {"code": "996", "name": "財政部國庫署　　　　　　　　　　　　　　"}
  //,{"code": "997", "name": "中華民國信用合作社聯合社南區聯合資訊處理"}
];

/**
 * 分行代碼資料
 */
export const BranchCodes = {
  "000": [
  {"code": "0000022", "name": "國庫局　　　　　　　　　　　　　　　　　"}
  ],
  "004": [
  {"code": "0040037", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0040059", "name": "公庫部　　　　　　　　　　　　　　　　　"},
  {"code": "0040071", "name": "館前分行　　　　　　　　　　　　　　　　"},
  {"code": "0040093", "name": "臺南分行　　　　　　　　　　　　　　　　"},
  {"code": "0040107", "name": "臺中分行　　　　　　　　　　　　　　　　"},
  {"code": "0040118", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0040129", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0040130", "name": "中興新村分行　　　　　　　　　　　　　　"},
  {"code": "0040141", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "0040152", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0040163", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "0040174", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "0040185", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "0040196", "name": "延平分行　　　　　　　　　　　　　　　　"},
  {"code": "0040200", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "0040211", "name": "高雄加工出口區分行　　　　　　　　　　　"},
  {"code": "0040222", "name": "宜蘭分行　　　　　　　　　　　　　　　　"},
  {"code": "0040233", "name": "臺東分行　　　　　　　　　　　　　　　　"},
  {"code": "0040244", "name": "澎湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0040255", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "0040266", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0040277", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0040288", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "0040299", "name": "苗栗分行　　　　　　　　　　　　　　　　"},
  {"code": "0040303", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "0040314", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "0040325", "name": "南投分行　　　　　　　　　　　　　　　　"},
  {"code": "0040336", "name": "南門分行　　　　　　　　　　　　　　　　"},
  {"code": "0040347", "name": "公館分行　　　　　　　　　　　　　　　　"},
  {"code": "0040358", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "0040369", "name": "北投分行　　　　　　　　　　　　　　　　"},
  {"code": "0040370", "name": "霧峰分行　　　　　　　　　　　　　　　　"},
  {"code": "0040381", "name": "金門分行　　　　　　　　　　　　　　　　"},
  {"code": "0040392", "name": "馬祖分行　　　　　　　　　　　　　　　　"},
  {"code": "0040406", "name": "安平分行　　　　　　　　　　　　　　　　"},
  {"code": "0040417", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0040428", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "0040439", "name": "頭份分行　　　　　　　　　　　　　　　　"},
  {"code": "0040440", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0040451", "name": "城中分行　　　　　　　　　　　　　　　　"},
  {"code": "0040462", "name": "民權分行　　　　　　　　　　　　　　　　"},
  {"code": "0040473", "name": "潭子分行　　　　　　　　　　　　　　　　"},
  {"code": "0040484", "name": "連城分行　　　　　　　　　　　　　　　　"},
  {"code": "0040495", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "0040509", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "0040510", "name": "鼓山分行　　　　　　　　　　　　　　　　"},
  {"code": "0040521", "name": "龍山分行　　　　　　　　　　　　　　　　"},
  {"code": "0040532", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "0040543", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "0040554", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "0040565", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "0040576", "name": "臺中港分行　　　　　　　　　　　　　　　"},
  {"code": "0040587", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "0040598", "name": "埔里分行　　　　　　　　　　　　　　　　"},
  {"code": "0040602", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "0040613", "name": "新興分行　　　　　　　　　　　　　　　　"},
  {"code": "0040624", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0040646", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "0040657", "name": "健行分行　　　　　　　　　　　　　　　　"},
  {"code": "0040668", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "0040679", "name": "太保分行　　　　　　　　　　　　　　　　"},
  {"code": "0040680", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "0040705", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "0040716", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "0040727", "name": "大甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0040738", "name": "新竹科學園區分行　　　　　　　　　　　　"},
  {"code": "0040749", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "0040750", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "0040794", "name": "黎明分行　　　　　　　　　　　　　　　　"},
  {"code": "0040808", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "0040819", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "0040820", "name": "三多分行　　　　　　　　　　　　　　　　"},
  {"code": "0040853", "name": "臺北世貿中心分行　　　　　　　　　　　　"},
  {"code": "0040864", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "0040875", "name": "華江分行　　　　　　　　　　　　　　　　"},
  {"code": "0040886", "name": "潮州分行　　　　　　　　　　　　　　　　"},
  {"code": "0040897", "name": "蘇澳分行　　　　　　　　　　　　　　　　"},
  {"code": "0040901", "name": "大雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0040912", "name": "楠梓分行　　　　　　　　　　　　　　　　"},
  {"code": "0040923", "name": "臺中工業區分行　　　　　　　　　　　　　"},
  {"code": "0041067", "name": "敦化分行　　　　　　　　　　　　　　　　"},
  {"code": "0041078", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "0041089", "name": "和平分行　　　　　　　　　　　　　　　　"},
  {"code": "0041090", "name": "水湳分行　　　　　　　　　　　　　　　　"},
  {"code": "0041104", "name": "中崙分行　　　　　　　　　　　　　　　　"},
  {"code": "0041115", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "0041159", "name": "桃園國際機場分行　　　　　　　　　　　　"},
  {"code": "0041160", "name": "大昌分行　　　　　　　　　　　　　　　　"},
  {"code": "0041182", "name": "五甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0041193", "name": "博愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0041207", "name": "中庄分行　　　　　　　　　　　　　　　　"},
  {"code": "0041218", "name": "平鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0041229", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0041230", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0041241", "name": "圓山分行　　　　　　　　　　　　　　　　"},
  {"code": "0041355", "name": "五股分行　　　　　　　　　　　　　　　　"},
  {"code": "0041366", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "0041377", "name": "安南分行　　　　　　　　　　　　　　　　"},
  {"code": "0041414", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0041425", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "0041436", "name": "鹿港分行　　　　　　　　　　　　　　　　"},
  {"code": "0041447", "name": "內壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0041469", "name": "臺南科學園區分行　　　　　　　　　　　　"},
  {"code": "0041470", "name": "虎尾分行　　　　　　　　　　　　　　　　"},
  {"code": "0041481", "name": "淡水分行　　　　　　　　　　　　　　　　"},
  {"code": "0041539", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0041540", "name": "嘉北分行　　　　　　　　　　　　　　　　"},
  {"code": "0041551", "name": "東港分行　　　　　　　　　　　　　　　　"},
  {"code": "0041562", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "0041573", "name": "梧棲分行　　　　　　　　　　　　　　　　"},
  {"code": "0041595", "name": "小港分行　　　　　　　　　　　　　　　　"},
  {"code": "0041609", "name": "中屏分行　　　　　　　　　　　　　　　　"},
  {"code": "0041621", "name": "群賢分行　　　　　　　　　　　　　　　　"},
  {"code": "0041643", "name": "北大路分行　　　　　　　　　　　　　　　"},
  {"code": "0041654", "name": "文山分行　　　　　　　　　　　　　　　　"},
  {"code": "0041702", "name": "太平分行　　　　　　　　　　　　　　　　"},
  {"code": "0041713", "name": "德芳分行　　　　　　　　　　　　　　　　"},
  {"code": "0041724", "name": "建國分行　　　　　　　　　　　　　　　　"},
  {"code": "0041768", "name": "屏東農科園區分行　　　　　　　　　　　　"},
  {"code": "0041861", "name": "東桃園分行　　　　　　　　　　　　　　　"},
  {"code": "0041872", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "0041919", "name": "高雄國際機場分行　　　　　　　　　　　　"},
  {"code": "0041931", "name": "永吉簡易型分行　　　　　　　　　　　　　"},
  {"code": "0041942", "name": "東門簡易型分行　　　　　　　　　　　　　"},
  {"code": "0041953", "name": "愛國簡易型分行　　　　　　　　　　　　　"},
  {"code": "0041986", "name": "臺電簡易型分行　　　　　　　　　　　　　"},
  {"code": "0042053", "name": "北府簡易型分行　　　　　　　　　　　　　"},
  {"code": "0042189", "name": "臺北港分行　　　　　　　　　　　　　　　"},
  {"code": "0042204", "name": "臺中科學園區分行　　　　　　　　　　　　"},
  {"code": "0042215", "name": "高雄科學園區分行　　　　　　　　　　　　"},
  {"code": "0042237", "name": "東湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0042248", "name": "高榮分行　　　　　　　　　　　　　　　　"},
  {"code": "0042259", "name": "南港軟體園區分行　　　　　　　　　　　　"},
  {"code": "0042260", "name": "龍潭分行　　　　　　　　　　　　　　　　"},
  {"code": "0042271", "name": "仁德分行　　　　　　　　　　　　　　　　"},
  {"code": "0042282", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "0042293", "name": "木柵分行　　　　　　　　　　　　　　　　"},
  {"code": "0042307", "name": "臺南創新園區分行　　　　　　　　　　　　"},
  {"code": "0042363", "name": "武昌分行　　　　　　　　　　　　　　　　"},
  {"code": "0042385", "name": "臺北分行　　　　　　　　　　　　　　　　"},
  {"code": "0042396", "name": "金山分行　　　　　　　　　　　　　　　　"},
  {"code": "0042400", "name": "信安分行　　　　　　　　　　　　　　　　"},
  {"code": "0042411", "name": "劍潭分行　　　　　　　　　　　　　　　　"},
  {"code": "0042422", "name": "萬華分行　　　　　　　　　　　　　　　　"},
  {"code": "0042433", "name": "板新分行　　　　　　　　　　　　　　　　"},
  {"code": "0042444", "name": "新永和分行　　　　　　　　　　　　　　　"},
  {"code": "0042455", "name": "南新莊分行　　　　　　　　　　　　　　　"},
  {"code": "0042477", "name": "新明分行　　　　　　　　　　　　　　　　"},
  {"code": "0042488", "name": "六家分行　　　　　　　　　　　　　　　　"},
  {"code": "0042499", "name": "北臺中分行　　　　　　　　　　　　　　　"},
  {"code": "0042525", "name": "嘉南分行　　　　　　　　　　　　　　　　"},
  {"code": "0042536", "name": "南都分行　　　　　　　　　　　　　　　　"},
  {"code": "0042558", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0042569", "name": "成功分行　　　　　　　　　　　　　　　　"},
  {"code": "0042570", "name": "北花蓮分行　　　　　　　　　　　　　　　"},
  {"code": "0042709", "name": "新湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0042710", "name": "五福分行　　　　　　　　　　　　　　　　"},
  {"code": "0042721", "name": "六甲頂分行　　　　　　　　　　　　　　　"},
  {"code": "0042787", "name": "中都分行　　　　　　　　　　　　　　　　"},
  {"code": "0042798", "name": "臺北國際機場分行　　　　　　　　　　　　"},
  {"code": "0042802", "name": "新莊副都心分行　　　　　　　　　　　　　"},
  {"code": "0042835", "name": "仁武分行　　　　　　　　　　　　　　　　"},
  {"code": "0042891", "name": "臺中國際機場分行　　　　　　　　　　　　"},
  {"code": "0042905", "name": "臺中精密園區分行　　　　　　　　　　　　"},
  {"code": "0042972", "name": "亞矽創新分行　　　　　　　　　　　　　　"}
  ],
  "005": [
  {"code": "0050027", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0050038", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "0050049", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "0050050", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "0050061", "name": "民權分行　　　　　　　　　　　　　　　　"},
  {"code": "0050072", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "0050083", "name": "長安分行　　　　　　　　　　　　　　　　"},
  {"code": "0050094", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "0050108", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "0050119", "name": "宜蘭分行　　　　　　　　　　　　　　　　"},
  {"code": "0050120", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "0050131", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0050142", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0050153", "name": "石門分行　　　　　　　　　　　　　　　　"},
  {"code": "0050164", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0050175", "name": "竹東分行　　　　　　　　　　　　　　　　"},
  {"code": "0050186", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "0050197", "name": "玉里分行　　　　　　　　　　　　　　　　"},
  {"code": "0050201", "name": "苗栗分行　　　　　　　　　　　　　　　　"},
  {"code": "0050212", "name": "頭份分行　　　　　　　　　　　　　　　　"},
  {"code": "0050223", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "0050234", "name": "大甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0050245", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0050256", "name": "南投分行　　　　　　　　　　　　　　　　"},
  {"code": "0050267", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "0050278", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "0050289", "name": "北港分行　　　　　　　　　　　　　　　　"},
  {"code": "0050290", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "0050304", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "0050315", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "0050326", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0050337", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0050348", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "0050359", "name": "美濃分行　　　　　　　　　　　　　　　　"},
  {"code": "0050360", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "0050371", "name": "台東分行　　　　　　　　　　　　　　　　"},
  {"code": "0050382", "name": "青年分行　　　　　　　　　　　　　　　　"},
  {"code": "0050393", "name": "金門分行　　　　　　　　　　　　　　　　"},
  {"code": "0050407", "name": "澎湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0050418", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0050452", "name": "和平分行　　　　　　　　　　　　　　　　"},
  {"code": "0050463", "name": "潮州分行　　　　　　　　　　　　　　　　"},
  {"code": "0050474", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "0050485", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "0050496", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "0050500", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0050511", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "0050522", "name": "湖口分行　　　　　　　　　　　　　　　　"},
  {"code": "0050533", "name": "蘇澳分行　　　　　　　　　　　　　　　　"},
  {"code": "0050544", "name": "新興分行　　　　　　　　　　　　　　　　"},
  {"code": "0050555", "name": "西台中分行　　　　　　　　　　　　　　　"},
  {"code": "0050566", "name": "虎尾分行　　　　　　　　　　　　　　　　"},
  {"code": "0050577", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0050588", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "0050599", "name": "中正分行　　　　　　　　　　　　　　　　"},
  {"code": "0050614", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "0050625", "name": "北台南分行　　　　　　　　　　　　　　　"},
  {"code": "0050636", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "0050647", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0050658", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "0050669", "name": "民雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0050670", "name": "大社分行　　　　　　　　　　　　　　　　"},
  {"code": "0050692", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0050706", "name": "路竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0050717", "name": "五甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0050728", "name": "太平分行　　　　　　　　　　　　　　　　"},
  {"code": "0050739", "name": "正濱分行　　　　　　　　　　　　　　　　"},
  {"code": "0050740", "name": "敦化分行　　　　　　　　　　　　　　　　"},
  {"code": "0050762", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "0050773", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "0050784", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0050795", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "0050809", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "0050810", "name": "淡水分行　　　　　　　　　　　　　　　　"},
  {"code": "0050821", "name": "草屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0050832", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "0050843", "name": "通霄分行　　　　　　　　　　　　　　　　"},
  {"code": "0050854", "name": "學甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0050865", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "0050876", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "0050898", "name": "白河分行　　　　　　　　　　　　　　　　"},
  {"code": "0050902", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "0050913", "name": "平鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0050935", "name": "文山分行　　　　　　　　　　　　　　　　"},
  {"code": "0050946", "name": "中港分行　　　　　　　　　　　　　　　　"},
  {"code": "0050957", "name": "東板橋分行　　　　　　　　　　　　　　　"},
  {"code": "0050968", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0050979", "name": "建國分行　　　　　　　　　　　　　　　　"},
  {"code": "0050980", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "0050991", "name": "東台北分行　　　　　　　　　　　　　　　"},
  {"code": "0051002", "name": "西三重分行　　　　　　　　　　　　　　　"},
  {"code": "0051013", "name": "南台中分行　　　　　　　　　　　　　　　"},
  {"code": "0051024", "name": "長春分行　　　　　　　　　　　　　　　　"},
  {"code": "0051035", "name": "東新竹分行　　　　　　　　　　　　　　　"},
  {"code": "0051046", "name": "新市分行　　　　　　　　　　　　　　　　"},
  {"code": "0051057", "name": "博愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0051068", "name": "中崙分行　　　　　　　　　　　　　　　　"},
  {"code": "0051079", "name": "華江分行　　　　　　　　　　　　　　　　"},
  {"code": "0051080", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "0051091", "name": "安平分行　　　　　　　　　　　　　　　　"},
  {"code": "0051105", "name": "嘉興分行　　　　　　　　　　　　　　　　"},
  {"code": "0051116", "name": "南新莊分行　　　　　　　　　　　　　　　"},
  {"code": "0051127", "name": "三峽分行　　　　　　　　　　　　　　　　"},
  {"code": "0051138", "name": "沙鹿分行　　　　　　　　　　　　　　　　"},
  {"code": "0051149", "name": "南桃園分行　　　　　　　　　　　　　　　"},
  {"code": "0051150", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "0051161", "name": "萬華分行　　　　　　　　　　　　　　　　"},
  {"code": "0051172", "name": "小港分行　　　　　　　　　　　　　　　　"},
  {"code": "0051183", "name": "新工分行　　　　　　　　　　　　　　　　"},
  {"code": "0051194", "name": "烏日分行　　　　　　　　　　　　　　　　"},
  {"code": "0051208", "name": "西湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0051219", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "0051220", "name": "北屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0051231", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "0051242", "name": "北中壢分行　　　　　　　　　　　　　　　"},
  {"code": "0051253", "name": "高樹分行　　　　　　　　　　　　　　　　"},
  {"code": "0051264", "name": "枋寮分行　　　　　　　　　　　　　　　　"},
  {"code": "0051286", "name": "金城分行　　　　　　　　　　　　　　　　"},
  {"code": "0051297", "name": "光復分行　　　　　　　　　　　　　　　　"},
  {"code": "0051301", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "0051312", "name": "北桃園分行　　　　　　　　　　　　　　　"},
  {"code": "0051323", "name": "東港分行　　　　　　　　　　　　　　　　"},
  {"code": "0051334", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "0051345", "name": "泰山分行　　　　　　　　　　　　　　　　"},
  {"code": "0051356", "name": "中科分行　　　　　　　　　　　　　　　　"},
  {"code": "0051367", "name": "大園分行　　　　　　　　　　　　　　　　"},
  {"code": "0051378", "name": "楊梅分行　　　　　　　　　　　　　　　　"},
  {"code": "0051389", "name": "東門分行　　　　　　　　　　　　　　　　"},
  {"code": "0051404", "name": "城東分行　　　　　　　　　　　　　　　　"},
  {"code": "0051415", "name": "松南分行　　　　　　　　　　　　　　　　"},
  {"code": "0051426", "name": "福興分行　　　　　　　　　　　　　　　　"},
  {"code": "0051437", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "0051448", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0051459", "name": "內壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0051460", "name": "竹南分行　　　　　　　　　　　　　　　　"},
  {"code": "0051471", "name": "安南分行　　　　　　　　　　　　　　　　"},
  {"code": "0051482", "name": "汐科分行　　　　　　　　　　　　　　　　"},
  {"code": "0051493", "name": "楠梓分行　　　　　　　　　　　　　　　　"},
  {"code": "0051507", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "0051518", "name": "大灣分行　　　　　　　　　　　　　　　　"},
  {"code": "0051530", "name": "大發分行　　　　　　　　　　　　　　　　"},
  {"code": "0051552", "name": "圓山分行　　　　　　　　　　　　　　　　"},
  {"code": "0051563", "name": "工研院分行　　　　　　　　　　　　　　　"},
  {"code": "0051574", "name": "北三重分行　　　　　　　　　　　　　　　"},
  {"code": "0051585", "name": "圓通分行　　　　　　　　　　　　　　　　"},
  {"code": "0051600", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "0051611", "name": "南屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0051633", "name": "寶中分行　　　　　　　　　　　　　　　　"},
  {"code": "0051644", "name": "中清分行　　　　　　　　　　　　　　　　"},
  {"code": "0051655", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "0051666", "name": "仁武分行　　　　　　　　　　　　　　　　"}
  ],
  "006": [
  {"code": "0060017", "name": "總行　　　　　　　　　　　　　　　　　　"},
  {"code": "0060028", "name": "館前分行　　　　　　　　　　　　　　　　"},
  {"code": "0060039", "name": "西門分行　　　　　　　　　　　　　　　　"},
  {"code": "0060040", "name": "延平分行　　　　　　　　　　　　　　　　"},
  {"code": "0060051", "name": "大稻埕分行　　　　　　　　　　　　　　　"},
  {"code": "0060062", "name": "東門分行　　　　　　　　　　　　　　　　"},
  {"code": "0060073", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "0060084", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "0060095", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "0060109", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "0060110", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0060121", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0060132", "name": "宜蘭分行　　　　　　　　　　　　　　　　"},
  {"code": "0060143", "name": "蘇澳分行　　　　　　　　　　　　　　　　"},
  {"code": "0060154", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0060165", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0060176", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0060187", "name": "苗栗分行　　　　　　　　　　　　　　　　"},
  {"code": "0060198", "name": "頭份分行　　　　　　　　　　　　　　　　"},
  {"code": "0060202", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "0060213", "name": "沙鹿分行　　　　　　　　　　　　　　　　"},
  {"code": "0060224", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0060235", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "0060246", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "0060257", "name": "南投分行　　　　　　　　　　　　　　　　"},
  {"code": "0060268", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "0060279", "name": "北港分行　　　　　　　　　　　　　　　　"},
  {"code": "0060280", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "0060291", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "0060305", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0060316", "name": "成功分行　　　　　　　　　　　　　　　　"},
  {"code": "0060327", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "0060338", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "0060349", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0060350", "name": "新興分行　　　　　　　　　　　　　　　　"},
  {"code": "0060361", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "0060372", "name": "潮州分行　　　　　　　　　　　　　　　　"},
  {"code": "0060383", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "0060394", "name": "台東分行　　　　　　　　　　　　　　　　"},
  {"code": "0060408", "name": "澎湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0060419", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "0060420", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0060431", "name": "大同分行　　　　　　　　　　　　　　　　"},
  {"code": "0060453", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "0060464", "name": "景美分行　　　　　　　　　　　　　　　　"},
  {"code": "0060475", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "0060486", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "0060497", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "0060501", "name": "中興分行　　　　　　　　　　　　　　　　"},
  {"code": "0060512", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0060545", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "0060567", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0060578", "name": "南豐原分行　　　　　　　　　　　　　　　"},
  {"code": "0060589", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "0060590", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "0060604", "name": "城東分行　　　　　　　　　　　　　　　　"},
  {"code": "0060615", "name": "佳里分行　　　　　　　　　　　　　　　　"},
  {"code": "0060626", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "0060637", "name": "南高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0060648", "name": "南嘉義分行　　　　　　　　　　　　　　　"},
  {"code": "0060659", "name": "竹東分行　　　　　　　　　　　　　　　　"},
  {"code": "0060660", "name": "林口文化分行　　　　　　　　　　　　　　"},
  {"code": "0060671", "name": "東三重分行　　　　　　　　　　　　　　　"},
  {"code": "0060682", "name": "南興分行　　　　　　　　　　　　　　　　"},
  {"code": "0060693", "name": "五權分行　　　　　　　　　　　　　　　　"},
  {"code": "0060707", "name": "埔里分行　　　　　　　　　　　　　　　　"},
  {"code": "0060718", "name": "大順分行　　　　　　　　　　　　　　　　"},
  {"code": "0060729", "name": "南勢角分行　　　　　　　　　　　　　　　"},
  {"code": "0060730", "name": "朴子分行　　　　　　　　　　　　　　　　"},
  {"code": "0060763", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "0060774", "name": "民權分行　　　　　　　　　　　　　　　　"},
  {"code": "0060785", "name": "東高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0060796", "name": "東台北分行　　　　　　　　　　　　　　　"},
  {"code": "0060800", "name": "城內分行　　　　　　　　　　　　　　　　"},
  {"code": "0060811", "name": "建國分行　　　　　　　　　　　　　　　　"},
  {"code": "0060822", "name": "圓山分行　　　　　　　　　　　　　　　　"},
  {"code": "0060833", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "0060844", "name": "長春分行　　　　　　　　　　　　　　　　"},
  {"code": "0060855", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0060866", "name": "玉成分行　　　　　　　　　　　　　　　　"},
  {"code": "0060877", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "0060888", "name": "長安分行　　　　　　　　　　　　　　　　"},
  {"code": "0060899", "name": "松興分行　　　　　　　　　　　　　　　　"},
  {"code": "0060903", "name": "民族分行　　　　　　　　　　　　　　　　"},
  {"code": "0060914", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "0060925", "name": "雙連分行　　　　　　　　　　　　　　　　"},
  {"code": "0060936", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "0060947", "name": "新生分行　　　　　　　　　　　　　　　　"},
  {"code": "0060958", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "0060969", "name": "永吉分行　　　　　　　　　　　　　　　　"},
  {"code": "0060981", "name": "東新莊分行　　　　　　　　　　　　　　　"},
  {"code": "0060992", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "0061003", "name": "前金分行　　　　　　　　　　　　　　　　"},
  {"code": "0061014", "name": "成大分行　　　　　　　　　　　　　　　　"},
  {"code": "0061025", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "0061036", "name": "海山分行　　　　　　　　　　　　　　　　"},
  {"code": "0061070", "name": "南台中分行　　　　　　　　　　　　　　　"},
  {"code": "0061081", "name": "埔墘分行　　　　　　　　　　　　　　　　"},
  {"code": "0061092", "name": "慈文分行　　　　　　　　　　　　　　　　"},
  {"code": "0061106", "name": "北寧分行　　　　　　　　　　　　　　　　"},
  {"code": "0061117", "name": "迴龍分行　　　　　　　　　　　　　　　　"},
  {"code": "0061128", "name": "太平分行　　　　　　　　　　　　　　　　"},
  {"code": "0061139", "name": "彰營分行　　　　　　　　　　　　　　　　"},
  {"code": "0061140", "name": "彰儲分行　　　　　　　　　　　　　　　　"},
  {"code": "0061151", "name": "虎尾分行　　　　　　　　　　　　　　　　"},
  {"code": "0061162", "name": "南屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0061173", "name": "西台中分行　　　　　　　　　　　　　　　"},
  {"code": "0061184", "name": "溪湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0061195", "name": "烏日分行　　　　　　　　　　　　　　　　"},
  {"code": "0061209", "name": "和美分行　　　　　　　　　　　　　　　　"},
  {"code": "0061210", "name": "南桃園分行　　　　　　　　　　　　　　　"},
  {"code": "0061221", "name": "屏南分行　　　　　　　　　　　　　　　　"},
  {"code": "0061232", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "0061243", "name": "北新竹分行　　　　　　　　　　　　　　　"},
  {"code": "0061254", "name": "復旦分行　　　　　　　　　　　　　　　　"},
  {"code": "0061265", "name": "竹山分行　　　　　　　　　　　　　　　　"},
  {"code": "0061276", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0061287", "name": "灣內分行　　　　　　　　　　　　　　　　"},
  {"code": "0061298", "name": "路竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0061302", "name": "憲德分行　　　　　　　　　　　　　　　　"},
  {"code": "0061313", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "0061324", "name": "北新分行　　　　　　　　　　　　　　　　"},
  {"code": "0061335", "name": "五洲分行　　　　　　　　　　　　　　　　"},
  {"code": "0061346", "name": "臺大分行　　　　　　　　　　　　　　　　"},
  {"code": "0061368", "name": "龜山分行　　　　　　　　　　　　　　　　"},
  {"code": "0061379", "name": "大溪分行　　　　　　　　　　　　　　　　"},
  {"code": "0061380", "name": "龍潭分行　　　　　　　　　　　　　　　　"},
  {"code": "0061391", "name": "中原分行　　　　　　　　　　　　　　　　"},
  {"code": "0061405", "name": "三興分行　　　　　　　　　　　　　　　　"},
  {"code": "0061427", "name": "石牌分行　　　　　　　　　　　　　　　　"},
  {"code": "0061438", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0061449", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "0061450", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "0061461", "name": "光華分行　　　　　　　　　　　　　　　　"},
  {"code": "0061472", "name": "北台南分行　　　　　　　　　　　　　　　"},
  {"code": "0061483", "name": "興鳳分行　　　　　　　　　　　　　　　　"},
  {"code": "0061494", "name": "北屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0061508", "name": "一心路分行　　　　　　　　　　　　　　　"},
  {"code": "0061519", "name": "三峽分行　　　　　　　　　　　　　　　　"},
  {"code": "0061520", "name": "北嘉義分行　　　　　　　　　　　　　　　"},
  {"code": "0061531", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "0061542", "name": "平鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0061553", "name": "大發分行　　　　　　　　　　　　　　　　"},
  {"code": "0061564", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0061575", "name": "光復分行　　　　　　　　　　　　　　　　"},
  {"code": "0061586", "name": "二重分行　　　　　　　　　　　　　　　　"},
  {"code": "0061601", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "0061656", "name": "軍功分行　　　　　　　　　　　　　　　　"},
  {"code": "0061715", "name": "永安分行　　　　　　　　　　　　　　　　"},
  {"code": "0061726", "name": "中權分行　　　　　　　　　　　　　　　　"},
  {"code": "0061759", "name": "太原分行　　　　　　　　　　　　　　　　"},
  {"code": "0061760", "name": "松竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0061852", "name": "中清分行　　　　　　　　　　　　　　　　"},
  {"code": "0061885", "name": "建成分行　　　　　　　　　　　　　　　　"},
  {"code": "0061900", "name": "朝馬分行　　　　　　　　　　　　　　　　"},
  {"code": "0061966", "name": "東台中分行　　　　　　　　　　　　　　　"},
  {"code": "0061988", "name": "美村分行　　　　　　　　　　　　　　　　"},
  {"code": "0062000", "name": "黎明分行　　　　　　　　　　　　　　　　"},
  {"code": "0062033", "name": "昌平分行　　　　　　　　　　　　　　　　"},
  {"code": "0062044", "name": "精武分行　　　　　　　　　　　　　　　　"},
  {"code": "0062055", "name": "文心分行　　　　　　　　　　　　　　　　"},
  {"code": "0062077", "name": "神岡分行　　　　　　　　　　　　　　　　"},
  {"code": "0063030", "name": "大竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0063074", "name": "林內分行　　　　　　　　　　　　　　　　"},
  {"code": "0063100", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "0063111", "name": "伸港分行　　　　　　　　　　　　　　　　"},
  {"code": "0063122", "name": "五股分行　　　　　　　　　　　　　　　　"},
  {"code": "0063133", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "0063155", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "0063166", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "0063177", "name": "泰山分行　　　　　　　　　　　　　　　　"},
  {"code": "0063199", "name": "大坪林分行　　　　　　　　　　　　　　　"},
  {"code": "0063373", "name": "鶯歌分行　　　　　　　　　　　　　　　　"},
  {"code": "0063395", "name": "鹿港分行　　　　　　　　　　　　　　　　"},
  {"code": "0063409", "name": "新樹分行　　　　　　　　　　　　　　　　"},
  {"code": "0063410", "name": "六家分行　　　　　　　　　　　　　　　　"},
  {"code": "0063421", "name": "大雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0063443", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "0063465", "name": "鼓山分行　　　　　　　　　　　　　　　　"},
  {"code": "0063476", "name": "大社分行　　　　　　　　　　　　　　　　"},
  {"code": "0063498", "name": "逢甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0063502", "name": "立德分行　　　　　　　　　　　　　　　　"},
  {"code": "0063513", "name": "林園分行　　　　　　　　　　　　　　　　"},
  {"code": "0063524", "name": "高雄科技園區分行　　　　　　　　　　　　"},
  {"code": "0063535", "name": "蘆竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0063546", "name": "北中和分行　　　　　　　　　　　　　　　"},
  {"code": "0063557", "name": "新湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0063568", "name": "丹鳳分行　　　　　　　　　　　　　　　　"},
  {"code": "0063580", "name": "旗山分行　　　　　　　　　　　　　　　　"},
  {"code": "0063591", "name": "大園分行　　　　　　　　　　　　　　　　"},
  {"code": "0063605", "name": "南土城分行　　　　　　　　　　　　　　　"},
  {"code": "0063616", "name": "潭子分行　　　　　　　　　　　　　　　　"},
  {"code": "0063627", "name": "后里分行　　　　　　　　　　　　　　　　"},
  {"code": "0063638", "name": "長庚分行　　　　　　　　　　　　　　　　"},
  {"code": "0063649", "name": "楠梓分行　　　　　　　　　　　　　　　　"},
  {"code": "0065012", "name": "自強分行　　　　　　　　　　　　　　　　"},
  {"code": "0065023", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "0065034", "name": "敦南分行　　　　　　　　　　　　　　　　"},
  {"code": "0065056", "name": "世貿分行　　　　　　　　　　　　　　　　"},
  {"code": "0065078", "name": "光復南路分行　　　　　　　　　　　　　　"},
  {"code": "0065089", "name": "北士林分行　　　　　　　　　　　　　　　"},
  {"code": "0065090", "name": "信維分行　　　　　　　　　　　　　　　　"},
  {"code": "0065104", "name": "西湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0065115", "name": "大湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0065137", "name": "國醫中心分行　　　　　　　　　　　　　　"},
  {"code": "0065159", "name": "南門分行　　　　　　　　　　　　　　　　"},
  {"code": "0065160", "name": "新中分行　　　　　　　　　　　　　　　　"},
  {"code": "0065171", "name": "中港分行　　　　　　　　　　　　　　　　"},
  {"code": "0065182", "name": "衛道分行　　　　　　　　　　　　　　　　"},
  {"code": "0065193", "name": "忠明南路分行　　　　　　　　　　　　　　"},
  {"code": "0065207", "name": "東基隆分行　　　　　　　　　　　　　　　"},
  {"code": "0065218", "name": "赤崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0065229", "name": "府城分行　　　　　　　　　　　　　　　　"},
  {"code": "0065230", "name": "開元分行　　　　　　　　　　　　　　　　"},
  {"code": "0065241", "name": "港都分行　　　　　　　　　　　　　　　　"},
  {"code": "0065252", "name": "七賢分行　　　　　　　　　　　　　　　　"},
  {"code": "0065274", "name": "十全分行　　　　　　　　　　　　　　　　"},
  {"code": "0065285", "name": "九如分行　　　　　　　　　　　　　　　　"},
  {"code": "0065296", "name": "小港分行　　　　　　　　　　　　　　　　"},
  {"code": "0065300", "name": "北三峽分行　　　　　　　　　　　　　　　"},
  {"code": "0065311", "name": "板新分行　　　　　　　　　　　　　　　　"},
  {"code": "0065322", "name": "南三重分行　　　　　　　　　　　　　　　"},
  {"code": "0065355", "name": "寶橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0065366", "name": "新泰分行　　　　　　　　　　　　　　　　"},
  {"code": "0065377", "name": "北土城分行　　　　　　　　　　　　　　　"},
  {"code": "0065388", "name": "南汐止分行　　　　　　　　　　　　　　　"},
  {"code": "0065399", "name": "北樹林分行　　　　　　　　　　　　　　　"},
  {"code": "0065403", "name": "五股工業區分行　　　　　　　　　　　　　"},
  {"code": "0065414", "name": "北羅東分行　　　　　　　　　　　　　　　"},
  {"code": "0065425", "name": "礁溪分行　　　　　　　　　　　　　　　　"},
  {"code": "0065436", "name": "東桃園分行　　　　　　　　　　　　　　　"},
  {"code": "0065447", "name": "壢新分行　　　　　　　　　　　　　　　　"},
  {"code": "0065458", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0065470", "name": "新明分行　　　　　　　　　　　　　　　　"},
  {"code": "0065481", "name": "楊梅分行　　　　　　　　　　　　　　　　"},
  {"code": "0065492", "name": "東台東分行　　　　　　　　　　　　　　　"},
  {"code": "0065517", "name": "東竹北分行　　　　　　　　　　　　　　　"},
  {"code": "0065528", "name": "北苗栗分行　　　　　　　　　　　　　　　"},
  {"code": "0065539", "name": "竹南分行　　　　　　　　　　　　　　　　"},
  {"code": "0065540", "name": "豐中分行　　　　　　　　　　　　　　　　"},
  {"code": "0065551", "name": "北大里分行　　　　　　　　　　　　　　　"},
  {"code": "0065562", "name": "東沙鹿分行　　　　　　　　　　　　　　　"},
  {"code": "0065573", "name": "草屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0065584", "name": "集集分行　　　　　　　　　　　　　　　　"},
  {"code": "0065595", "name": "東埔里分行　　　　　　　　　　　　　　　"},
  {"code": "0065609", "name": "員新分行　　　　　　　　　　　　　　　　"},
  {"code": "0065610", "name": "南彰化分行　　　　　　　　　　　　　　　"},
  {"code": "0065621", "name": "北斗分行　　　　　　　　　　　　　　　　"},
  {"code": "0065632", "name": "竹塹分行　　　　　　　　　　　　　　　　"},
  {"code": "0065643", "name": "新竹科學園區分行　　　　　　　　　　　　"},
  {"code": "0065665", "name": "雲林分行　　　　　　　　　　　　　　　　"},
  {"code": "0065687", "name": "北朴子分行　　　　　　　　　　　　　　　"},
  {"code": "0065698", "name": "北新營分行　　　　　　　　　　　　　　　"},
  {"code": "0065702", "name": "仁德分行　　　　　　　　　　　　　　　　"},
  {"code": "0065713", "name": "南永康分行　　　　　　　　　　　　　　　"},
  {"code": "0065735", "name": "鳳松分行　　　　　　　　　　　　　　　　"},
  {"code": "0065746", "name": "北岡山分行　　　　　　　　　　　　　　　"},
  {"code": "0065757", "name": "美濃分行　　　　　　　　　　　　　　　　"},
  {"code": "0065768", "name": "大樹分行　　　　　　　　　　　　　　　　"},
  {"code": "0065816", "name": "東港分行　　　　　　　　　　　　　　　　"},
  {"code": "0065827", "name": "萬丹分行　　　　　　　　　　　　　　　　"},
  {"code": "0065838", "name": "枋寮分行　　　　　　　　　　　　　　　　"},
  {"code": "0065849", "name": "東嘉義分行　　　　　　　　　　　　　　　"},
  {"code": "0065850", "name": "北花蓮分行　　　　　　　　　　　　　　　"},
  {"code": "0065919", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "0065942", "name": "水湳分行　　　　　　　　　　　　　　　　"},
  {"code": "0066064", "name": "仁美分行　　　　　　　　　　　　　　　　"},
  {"code": "0066097", "name": "社皮分行　　　　　　　　　　　　　　　　"},
  {"code": "0066123", "name": "港湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0069021", "name": "五甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0069043", "name": "淡水分行　　　　　　　　　　　　　　　　"}
  ],
  "007": [
  {"code": "0070937", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0070948", "name": "安和分行　　　　　　　　　　　　　　　　"},
  {"code": "0071015", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "0071026", "name": "西門分行　　　　　　　　　　　　　　　　"},
  {"code": "0071037", "name": "忠孝路分行　　　　　　　　　　　　　　　"},
  {"code": "0071059", "name": "東湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0071060", "name": "景美分行　　　　　　　　　　　　　　　　"},
  {"code": "0071071", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "0071118", "name": "大稻埕分行　　　　　　　　　　　　　　　"},
  {"code": "0071130", "name": "信維分行　　　　　　　　　　　　　　　　"},
  {"code": "0071211", "name": "建成分行　　　　　　　　　　　　　　　　"},
  {"code": "0071299", "name": "華山分行　　　　　　　　　　　　　　　　"},
  {"code": "0071314", "name": "大同分行　　　　　　　　　　　　　　　　"},
  {"code": "0071336", "name": "新生分行　　　　　　　　　　　　　　　　"},
  {"code": "0071358", "name": "劍潭分行　　　　　　　　　　　　　　　　"},
  {"code": "0071406", "name": "圓山分行　　　　　　　　　　　　　　　　"},
  {"code": "0071417", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "0071428", "name": "中崙分行　　　　　　　　　　　　　　　　"},
  {"code": "0071439", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "0071440", "name": "城東分行　　　　　　　　　　　　　　　　"},
  {"code": "0071451", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "0071462", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "0071473", "name": "民權分行　　　　　　　　　　　　　　　　"},
  {"code": "0071484", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "0071495", "name": "長春分行　　　　　　　　　　　　　　　　"},
  {"code": "0071509", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0071510", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "0071521", "name": "延吉分行　　　　　　　　　　　　　　　　"},
  {"code": "0071532", "name": "光復分行　　　　　　　　　　　　　　　　"},
  {"code": "0071554", "name": "興雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0071576", "name": "永春分行　　　　　　　　　　　　　　　　"},
  {"code": "0071587", "name": "內科園區分行　　　　　　　　　　　　　　"},
  {"code": "0071598", "name": "吉林分行　　　　　　　　　　　　　　　　"},
  {"code": "0071602", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0071613", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "0071624", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "0071635", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "0071646", "name": "敦化分行　　　　　　　　　　　　　　　　"},
  {"code": "0071657", "name": "仁和分行　　　　　　　　　　　　　　　　"},
  {"code": "0071668", "name": "世貿分行　　　　　　　　　　　　　　　　"},
  {"code": "0071679", "name": "木柵分行　　　　　　　　　　　　　　　　"},
  {"code": "0071680", "name": "松貿分行　　　　　　　　　　　　　　　　"},
  {"code": "0071691", "name": "新湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0071716", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "0071727", "name": "南門分行　　　　　　　　　　　　　　　　"},
  {"code": "0071738", "name": "公館分行　　　　　　　　　　　　　　　　"},
  {"code": "0071761", "name": "和平分行　　　　　　　　　　　　　　　　"},
  {"code": "0071819", "name": "萬華分行　　　　　　　　　　　　　　　　"},
  {"code": "0071831", "name": "雙園分行　　　　　　　　　　　　　　　　"},
  {"code": "0071901", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "0071912", "name": "北投分行　　　　　　　　　　　　　　　　"},
  {"code": "0071923", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "0071934", "name": "建國分行　　　　　　　　　　　　　　　　"},
  {"code": "0071945", "name": "萬隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0071956", "name": "石牌分行　　　　　　　　　　　　　　　　"},
  {"code": "0072012", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0072023", "name": "華江分行　　　　　　　　　　　　　　　　"},
  {"code": "0072034", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "0072056", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "0072067", "name": "江子翠分行　　　　　　　　　　　　　　　"},
  {"code": "0072078", "name": "北土城分行　　　　　　　　　　　　　　　"},
  {"code": "0072089", "name": "林口工二分行　　　　　　　　　　　　　　"},
  {"code": "0072115", "name": "三重埔分行　　　　　　　　　　　　　　　"},
  {"code": "0072126", "name": "長泰分行　　　　　　　　　　　　　　　　"},
  {"code": "0072137", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "0072148", "name": "頭前分行　　　　　　　　　　　　　　　　"},
  {"code": "0072159", "name": "五股分行　　　　　　　　　　　　　　　　"},
  {"code": "0072160", "name": "重陽分行　　　　　　　　　　　　　　　　"},
  {"code": "0072171", "name": "五股工業區分行　　　　　　　　　　　　　"},
  {"code": "0072182", "name": "淡水分行　　　　　　　　　　　　　　　　"},
  {"code": "0072218", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "0072229", "name": "大坪林分行　　　　　　　　　　　　　　　"},
  {"code": "0072300", "name": "泰山分行　　　　　　　　　　　　　　　　"},
  {"code": "0072311", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "0072322", "name": "鶯歌分行　　　　　　　　　　　　　　　　"},
  {"code": "0072333", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "0072344", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "0072355", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "0072366", "name": "連城分行　　　　　　　　　　　　　　　　"},
  {"code": "0072377", "name": "瑞芳分行　　　　　　　　　　　　　　　　"},
  {"code": "0072388", "name": "埔墘分行　　　　　　　　　　　　　　　　"},
  {"code": "0072399", "name": "丹鳳分行　　　　　　　　　　　　　　　　"},
  {"code": "0072414", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0072436", "name": "哨船頭分行　　　　　　　　　　　　　　　"},
  {"code": "0072458", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "0072469", "name": "汐科分行　　　　　　　　　　　　　　　　"},
  {"code": "0072470", "name": "幸福分行　　　　　　　　　　　　　　　　"},
  {"code": "0072517", "name": "宜蘭分行　　　　　　　　　　　　　　　　"},
  {"code": "0072610", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "0072621", "name": "蘇澳分行　　　　　　　　　　　　　　　　"},
  {"code": "0072713", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0072724", "name": "北桃分行　　　　　　　　　　　　　　　　"},
  {"code": "0072735", "name": "中正分行（客戶移撥桃園分行服務）　　　　"},
  {"code": "0072791", "name": "大湳分行　　　　　　　　　　　　　　　　"},
  {"code": "0072805", "name": "內壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0072816", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0072827", "name": "西壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0072838", "name": "平鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0072849", "name": "大園分行　　　　　　　　　　　　　　　　"},
  {"code": "0072850", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0072872", "name": "迴龍分行　　　　　　　　　　　　　　　　"},
  {"code": "0072908", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "0072919", "name": "大溪分行　　　　　　　　　　　　　　　　"},
  {"code": "0072920", "name": "龍潭分行　　　　　　　　　　　　　　　　"},
  {"code": "0073019", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0073020", "name": "東門分行　　　　　　　　　　　　　　　　"},
  {"code": "0073031", "name": "竹科分行　　　　　　　　　　　　　　　　"},
  {"code": "0073112", "name": "竹東分行　　　　　　　　　　　　　　　　"},
  {"code": "0073123", "name": "關西分行　　　　　　　　　　　　　　　　"},
  {"code": "0073134", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "0073215", "name": "苗栗分行　　　　　　　　　　　　　　　　"},
  {"code": "0073318", "name": "竹南分行　　　　　　　　　　　　　　　　"},
  {"code": "0073329", "name": "頭份分行　　　　　　　　　　　　　　　　"},
  {"code": "0074016", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0074027", "name": "南台中分行　　　　　　　　　　　　　　　"},
  {"code": "0074038", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "0074049", "name": "中港分行　　　　　　　　　　　　　　　　"},
  {"code": "0074050", "name": "北屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0074061", "name": "進化分行　　　　　　　　　　　　　　　　"},
  {"code": "0074072", "name": "南屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0074119", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "0074120", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "0074153", "name": "中科分行　　　　　　　　　　　　　　　　"},
  {"code": "0074212", "name": "東勢分行　　　　　　　　　　　　　　　　"},
  {"code": "0074223", "name": "沙鹿分行　　　　　　　　　　　　　　　　"},
  {"code": "0074234", "name": "大甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0074245", "name": "太平分行　　　　　　　　　　　　　　　　"},
  {"code": "0074256", "name": "清水分行　　　　　　　　　　　　　　　　"},
  {"code": "0074267", "name": "大雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0074315", "name": "南投分行　　　　　　　　　　　　　　　　"},
  {"code": "0074418", "name": "草屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0074429", "name": "埔里分行　　　　　　　　　　　　　　　　"},
  {"code": "0074511", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "0074614", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "0074625", "name": "鹿港分行　　　　　　　　　　　　　　　　"},
  {"code": "0074636", "name": "溪湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0074647", "name": "北斗分行　　　　　　　　　　　　　　　　"},
  {"code": "0074717", "name": "和美分行　　　　　　　　　　　　　　　　"},
  {"code": "0075013", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "0075035", "name": "興嘉分行　　　　　　　　　　　　　　　　"},
  {"code": "0075116", "name": "朴子分行　　　　　　　　　　　　　　　　"},
  {"code": "0075219", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "0075312", "name": "北港分行　　　　　　　　　　　　　　　　"},
  {"code": "0075323", "name": "西螺分行　　　　　　　　　　　　　　　　"},
  {"code": "0075334", "name": "虎尾分行　　　　　　　　　　　　　　　　"},
  {"code": "0076010", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0076021", "name": "運河分行（客戶移撥台南分行服務）　　　　"},
  {"code": "0076043", "name": "富強分行　　　　　　　　　　　　　　　　"},
  {"code": "0076054", "name": "赤崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0076065", "name": "竹溪分行　　　　　　　　　　　　　　　　"},
  {"code": "0076076", "name": "金城分行　　　　　　　　　　　　　　　　"},
  {"code": "0076087", "name": "安南分行　　　　　　　　　　　　　　　　"},
  {"code": "0076113", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "0076216", "name": "鹽水分行　　　　　　　　　　　　　　　　"},
  {"code": "0076227", "name": "麻豆分行　　　　　　　　　　　　　　　　"},
  {"code": "0076238", "name": "善化分行　　　　　　　　　　　　　　　　"},
  {"code": "0076249", "name": "佳里分行　　　　　　　　　　　　　　　　"},
  {"code": "0076250", "name": "新化分行　　　　　　　　　　　　　　　　"},
  {"code": "0076261", "name": "大灣分行　　　　　　　　　　　　　　　　"},
  {"code": "0076283", "name": "南科園區分行　　　　　　　　　　　　　　"},
  {"code": "0076294", "name": "歸仁分行　　　　　　　　　　　　　　　　"},
  {"code": "0076308", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "0077017", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0077028", "name": "鹽埕分行　　　　　　　　　　　　　　　　"},
  {"code": "0077039", "name": "新興分行　　　　　　　　　　　　　　　　"},
  {"code": "0077040", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "0077051", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0077062", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "0077073", "name": "楠梓分行　　　　　　　　　　　　　　　　"},
  {"code": "0077084", "name": "五福分行　　　　　　　　　　　　　　　　"},
  {"code": "0077095", "name": "十全分行　　　　　　　　　　　　　　　　"},
  {"code": "0077109", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0077110", "name": "灣內分行　　　　　　　　　　　　　　　　"},
  {"code": "0077121", "name": "博愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0077132", "name": "鼎泰分行（客戶移撥博愛分行服務）　　　　"},
  {"code": "0077143", "name": "小港分行　　　　　　　　　　　　　　　　"},
  {"code": "0077202", "name": "五甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0077213", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "0077305", "name": "路竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0077316", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "0077327", "name": "旗山分行　　　　　　　　　　　　　　　　"},
  {"code": "0077338", "name": "林園分行　　　　　　　　　　　　　　　　"},
  {"code": "0077419", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "0077512", "name": "潮州分行　　　　　　　　　　　　　　　　"},
  {"code": "0077523", "name": "東港分行　　　　　　　　　　　　　　　　"},
  {"code": "0077534", "name": "恆春分行　　　　　　　　　　　　　　　　"},
  {"code": "0077785", "name": "梓本分行　　　　　　　　　　　　　　　　"},
  {"code": "0077855", "name": "萬巒分行　　　　　　　　　　　　　　　　"},
  {"code": "0078014", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "0078117", "name": "台東分行　　　　　　　　　　　　　　　　"},
  {"code": "0078210", "name": "澎湖分行　　　　　　　　　　　　　　　　"}
  ],
  "008": [
  {"code": "0081005", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0081016", "name": "儲蓄分行　　　　　　　　　　　　　　　　"},
  {"code": "0081027", "name": "國外營業部　　　　　　　　　　　　　　　"},
  {"code": "0081038", "name": "城內分行　　　　　　　　　　　　　　　　"},
  {"code": "0081049", "name": "大稻埕分行　　　　　　　　　　　　　　　"},
  {"code": "0081050", "name": "建成分行　　　　　　　　　　　　　　　　"},
  {"code": "0081061", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "0081072", "name": "圓山分行　　　　　　　　　　　　　　　　"},
  {"code": "0081083", "name": "城東分行　　　　　　　　　　　　　　　　"},
  {"code": "0081094", "name": "西門分行　　　　　　　　　　　　　　　　"},
  {"code": "0081108", "name": "南松山分行　　　　　　　　　　　　　　　"},
  {"code": "0081119", "name": "仁愛路分行　　　　　　　　　　　　　　　"},
  {"code": "0081120", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "0081131", "name": "新生分行　　　　　　　　　　　　　　　　"},
  {"code": "0081142", "name": "大同分行　　　　　　　　　　　　　　　　"},
  {"code": "0081153", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "0081164", "name": "中崙分行　　　　　　　　　　　　　　　　"},
  {"code": "0081175", "name": "臺北南門分行　　　　　　　　　　　　　　"},
  {"code": "0081186", "name": "公館分行　　　　　　　　　　　　　　　　"},
  {"code": "0081197", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "0081201", "name": "忠孝東路分行　　　　　　　　　　　　　　"},
  {"code": "0081212", "name": "和平分行　　　　　　　　　　　　　　　　"},
  {"code": "0081223", "name": "雙園分行　　　　　　　　　　　　　　　　"},
  {"code": "0081234", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "0081245", "name": "東台北分行　　　　　　　　　　　　　　　"},
  {"code": "0081256", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "0081267", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "0081278", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "0081289", "name": "龍江分行　　　　　　　　　　　　　　　　"},
  {"code": "0081290", "name": "永吉分行　　　　　　　　　　　　　　　　"},
  {"code": "0081304", "name": "敦化分行　　　　　　　　　　　　　　　　"},
  {"code": "0081326", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "0081337", "name": "敦和分行　　　　　　　　　　　　　　　　"},
  {"code": "0081348", "name": "東湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0081360", "name": "東興分行　　　　　　　　　　　　　　　　"},
  {"code": "0081371", "name": "北南港分行　　　　　　　　　　　　　　　"},
  {"code": "0081382", "name": "木柵分行　　　　　　　　　　　　　　　　"},
  {"code": "0081393", "name": "板橋文化分行　　　　　　　　　　　　　　"},
  {"code": "0081430", "name": "南內湖分行　　　　　　　　　　　　　　　"},
  {"code": "0081452", "name": "長安分行　　　　　　　　　　　　　　　　"},
  {"code": "0081474", "name": "懷生分行　　　　　　　　　　　　　　　　"},
  {"code": "0081485", "name": "中華路分行　　　　　　　　　　　　　　　"},
  {"code": "0081496", "name": "信維分行　　　　　　　　　　　　　　　　"},
  {"code": "0081511", "name": "埔墘分行　　　　　　　　　　　　　　　　"},
  {"code": "0081522", "name": "石牌分行　　　　　　　　　　　　　　　　"},
  {"code": "0081533", "name": "瑞祥分行　　　　　　　　　　　　　　　　"},
  {"code": "0081544", "name": "台大分行　　　　　　　　　　　　　　　　"},
  {"code": "0081566", "name": "世貿分行　　　　　　　　　　　　　　　　"},
  {"code": "0081577", "name": "萬華分行　　　　　　　　　　　　　　　　"},
  {"code": "0081588", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "0081599", "name": "華江分行　　　　　　　　　　　　　　　　"},
  {"code": "0081603", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0081614", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "0081625", "name": "北三重分行　　　　　　　　　　　　　　　"},
  {"code": "0081636", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "0081647", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "0081658", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "0081669", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "0081670", "name": "淡水分行　　　　　　　　　　　　　　　　"},
  {"code": "0081681", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "0081692", "name": "南永和分行　　　　　　　　　　　　　　　"},
  {"code": "0081706", "name": "西三重分行　　　　　　　　　　　　　　　"},
  {"code": "0081717", "name": "南三重分行　　　　　　　　　　　　　　　"},
  {"code": "0081728", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "0081739", "name": "新泰分行　　　　　　　　　　　　　　　　"},
  {"code": "0081740", "name": "二重分行　　　　　　　　　　　　　　　　"},
  {"code": "0081751", "name": "板新分行　　　　　　　　　　　　　　　　"},
  {"code": "0081762", "name": "五股分行　　　　　　　　　　　　　　　　"},
  {"code": "0081784", "name": "北投分行　　　　　　　　　　　　　　　　"},
  {"code": "0081795", "name": "西湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0081809", "name": "積穗分行　　　　　　　　　　　　　　　　"},
  {"code": "0081821", "name": "福和分行　　　　　　　　　　　　　　　　"},
  {"code": "0081832", "name": "南勢角分行　　　　　　　　　　　　　　　"},
  {"code": "0081843", "name": "北蘆洲分行　　　　　　　　　　　　　　　"},
  {"code": "0081854", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "0081865", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "0081876", "name": "北新分行　　　　　　　　　　　　　　　　"},
  {"code": "0081898", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "0081902", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0081913", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "0081924", "name": "樟樹灣分行　　　　　　　　　　　　　　　"},
  {"code": "0081935", "name": "泰山分行　　　　　　　　　　　　　　　　"},
  {"code": "0081946", "name": "三峽分行　　　　　　　　　　　　　　　　"},
  {"code": "0081957", "name": "文山分行　　　　　　　　　　　　　　　　"},
  {"code": "0081968", "name": "鶯歌分行　　　　　　　　　　　　　　　　"},
  {"code": "0081979", "name": "北新莊分行　　　　　　　　　　　　　　　"},
  {"code": "0081980", "name": "北土城分行　　　　　　　　　　　　　　　"},
  {"code": "0081991", "name": "林口站前分行　　　　　　　　　　　　　　"},
  {"code": "0082002", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0082013", "name": "基隆港口分行　　　　　　　　　　　　　　"},
  {"code": "0082116", "name": "七堵分行　　　　　　　　　　　　　　　　"},
  {"code": "0082208", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "0082219", "name": "宜蘭分行　　　　　　　　　　　　　　　　"},
  {"code": "0082404", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0082415", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0082426", "name": "楊梅分行　　　　　　　　　　　　　　　　"},
  {"code": "0082437", "name": "壢昌分行　　　　　　　　　　　　　　　　"},
  {"code": "0082448", "name": "北桃園分行　　　　　　　　　　　　　　　"},
  {"code": "0082459", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0082460", "name": "平鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0082471", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "0082482", "name": "龜山分行　　　　　　　　　　　　　　　　"},
  {"code": "0082493", "name": "龍潭分行　　　　　　　　　　　　　　　　"},
  {"code": "0082507", "name": "大溪分行　　　　　　　　　　　　　　　　"},
  {"code": "0082518", "name": "內壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0082529", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "0082600", "name": "觀音分行　　　　　　　　　　　　　　　　"},
  {"code": "0082622", "name": "大園分行　　　　　　　　　　　　　　　　"},
  {"code": "0083009", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0083010", "name": "竹東分行　　　　　　　　　　　　　　　　"},
  {"code": "0083021", "name": "竹科分行　　　　　　　　　　　　　　　　"},
  {"code": "0083102", "name": "新豐分行　　　　　　　　　　　　　　　　"},
  {"code": "0083135", "name": "六家分行　　　　　　　　　　　　　　　　"},
  {"code": "0083205", "name": "竹南分行　　　　　　　　　　　　　　　　"},
  {"code": "0083216", "name": "頭份分行　　　　　　　　　　　　　　　　"},
  {"code": "0083227", "name": "苗栗分行　　　　　　　　　　　　　　　　"},
  {"code": "0083238", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "0083515", "name": "大眾分行　　　　　　　　　　　　　　　　"},
  {"code": "0084006", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "0084017", "name": "東勢分行　　　　　　　　　　　　　　　　"},
  {"code": "0084028", "name": "清水分行　　　　　　　　　　　　　　　　"},
  {"code": "0084039", "name": "西豐原分行　　　　　　　　　　　　　　　"},
  {"code": "0084202", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0084224", "name": "南台中分行　　　　　　　　　　　　　　　"},
  {"code": "0084235", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "0084246", "name": "台中港路分行　　　　　　　　　　　　　　"},
  {"code": "0084257", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "0084268", "name": "水湳分行　　　　　　　　　　　　　　　　"},
  {"code": "0084279", "name": "五權分行　　　　　　　　　　　　　　　　"},
  {"code": "0084291", "name": "大甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0084305", "name": "太平分行　　　　　　　　　　　　　　　　"},
  {"code": "0084316", "name": "中科分行　　　　　　　　　　　　　　　　"},
  {"code": "0084512", "name": "沙鹿分行　　　　　　　　　　　　　　　　"},
  {"code": "0085003", "name": "草屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0085014", "name": "南投分行　　　　　　　　　　　　　　　　"},
  {"code": "0085209", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "0085210", "name": "和美分行　　　　　　　　　　　　　　　　"},
  {"code": "0085221", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "0085232", "name": "鹿港分行　　　　　　　　　　　　　　　　"},
  {"code": "0085243", "name": "溪湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0085405", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "0085416", "name": "虎尾分行　　　　　　　　　　　　　　　　"},
  {"code": "0085427", "name": "西螺分行　　　　　　　　　　　　　　　　"},
  {"code": "0086000", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "0086011", "name": "嘉南分行　　　　　　　　　　　　　　　　"},
  {"code": "0086022", "name": "朴子分行　　　　　　　　　　　　　　　　"},
  {"code": "0086206", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "0086217", "name": "麻豆分行　　　　　　　　　　　　　　　　"},
  {"code": "0086228", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "0086402", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0086424", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "0086435", "name": "西台南分行　　　　　　　　　　　　　　　"},
  {"code": "0086446", "name": "北台南分行　　　　　　　　　　　　　　　"},
  {"code": "0086457", "name": "南都分行　　　　　　　　　　　　　　　　"},
  {"code": "0086468", "name": "安南分行　　　　　　　　　　　　　　　　"},
  {"code": "0086479", "name": "仁德分行　　　　　　　　　　　　　　　　"},
  {"code": "0086480", "name": "新市分行　　　　　　　　　　　　　　　　"},
  {"code": "0086815", "name": "金華分行　　　　　　　　　　　　　　　　"},
  {"code": "0087007", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0087018", "name": "東苓分行　　　　　　　　　　　　　　　　"},
  {"code": "0087029", "name": "新興分行　　　　　　　　　　　　　　　　"},
  {"code": "0087030", "name": "高雄三民分行　　　　　　　　　　　　　　"},
  {"code": "0087041", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0087052", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0087063", "name": "高雄博愛分行　　　　　　　　　　　　　　"},
  {"code": "0087074", "name": "南高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0087085", "name": "東高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0087096", "name": "大昌分行　　　　　　　　　　　　　　　　"},
  {"code": "0087100", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0087111", "name": "楠梓分行　　　　　　　　　　　　　　　　"},
  {"code": "0087122", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "0087199", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "0087203", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "0087214", "name": "路竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0087225", "name": "仁武分行　　　　　　　　　　　　　　　　"},
  {"code": "0087513", "name": "籬仔內分行　　　　　　　　　　　　　　　"},
  {"code": "0087524", "name": "五甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0087535", "name": "光華分行　　　　　　　　　　　　　　　　"},
  {"code": "0087605", "name": "小港分行　　　　　　　　　　　　　　　　"},
  {"code": "0087650", "name": "高雄桂林分行　　　　　　　　　　　　　　"},
  {"code": "0088004", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "0088015", "name": "內埔分行　　　　　　　　　　　　　　　　"},
  {"code": "0088026", "name": "潮州分行　　　　　　　　　　　　　　　　"},
  {"code": "0088130", "name": "佳冬分行　　　　　　　　　　　　　　　　"},
  {"code": "0088200", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "0088303", "name": "台東分行　　　　　　　　　　　　　　　　"},
  {"code": "0088886", "name": "營運總部分行　　　　　　　　　　　　　　"}
  ],
  "009": [
  {"code": "0092200", "name": "總行營業部　　　　　　　　　　　　　　　"},
  {"code": "0093003", "name": "吉林分行　　　　　　　　　　　　　　　　"},
  {"code": "0093010", "name": "城內分行　　　　　　　　　　　　　　　　"},
  {"code": "0094004", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "0094011", "name": "南台中分行　　　　　　　　　　　　　　　"},
  {"code": "0094028", "name": "北屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0094035", "name": "水湳分行　　　　　　　　　　　　　　　　"},
  {"code": "0094042", "name": "南屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0094059", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0094108", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0094115", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0094122", "name": "東基隆分行　　　　　　　　　　　　　　　"},
  {"code": "0094202", "name": "宜蘭分行　　　　　　　　　　　　　　　　"},
  {"code": "0094219", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "0095005", "name": "北門分行　　　　　　　　　　　　　　　　"},
  {"code": "0095012", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "0095029", "name": "萬華分行　　　　　　　　　　　　　　　　"},
  {"code": "0095036", "name": "西門分行　　　　　　　　　　　　　　　　"},
  {"code": "0095043", "name": "永樂分行　　　　　　　　　　　　　　　　"},
  {"code": "0095050", "name": "建成分行　　　　　　　　　　　　　　　　"},
  {"code": "0095067", "name": "大同分行　　　　　　　　　　　　　　　　"},
  {"code": "0095074", "name": "承德分行　　　　　　　　　　　　　　　　"},
  {"code": "0095081", "name": "中山北路分行　　　　　　　　　　　　　　"},
  {"code": "0095109", "name": "東門分行　　　　　　　　　　　　　　　　"},
  {"code": "0095116", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "0095123", "name": "五分埔分行　　　　　　　　　　　　　　　"},
  {"code": "0095130", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "0095147", "name": "城東分行　　　　　　　　　　　　　　　　"},
  {"code": "0095154", "name": "中崙分行　　　　　　　　　　　　　　　　"},
  {"code": "0095161", "name": "雙園分行　　　　　　　　　　　　　　　　"},
  {"code": "0095178", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "0095185", "name": "總部分行　　　　　　　　　　　　　　　　"},
  {"code": "0095192", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "0095203", "name": "忠孝東路分行　　　　　　　　　　　　　　"},
  {"code": "0095210", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "0095227", "name": "東台北分行　　　　　　　　　　　　　　　"},
  {"code": "0095234", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "0095241", "name": "西松分行　　　　　　　　　　　　　　　　"},
  {"code": "0095258", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "0095265", "name": "台北世貿中心分行　　　　　　　　　　　　"},
  {"code": "0095272", "name": "敦化分行　　　　　　　　　　　　　　　　"},
  {"code": "0095289", "name": "建國分行　　　　　　　　　　　　　　　　"},
  {"code": "0095296", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0095307", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "0095314", "name": "中正分行　　　　　　　　　　　　　　　　"},
  {"code": "0095321", "name": "仁和分行　　　　　　　　　　　　　　　　"},
  {"code": "0095338", "name": "永春分行　　　　　　　　　　　　　　　　"},
  {"code": "0095345", "name": "光隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0095352", "name": "木柵分行　　　　　　　　　　　　　　　　"},
  {"code": "0095369", "name": "新湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0095376", "name": "東湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0095383", "name": "南港科學園區分行　　　　　　　　　　　　"},
  {"code": "0095390", "name": "北投分行　　　　　　　　　　　　　　　　"},
  {"code": "0095401", "name": "和平分行　　　　　　　　　　　　　　　　"},
  {"code": "0095418", "name": "東興分行　　　　　　　　　　　　　　　　"},
  {"code": "0095425", "name": "龍潭分行　　　　　　　　　　　　　　　　"},
  {"code": "0095432", "name": "汐科分行　　　　　　　　　　　　　　　　"},
  {"code": "0095456", "name": "新樹分行　　　　　　　　　　　　　　　　"},
  {"code": "0095463", "name": "立德分行　　　　　　　　　　　　　　　　"},
  {"code": "0095470", "name": "泰山分行　　　　　　　　　　　　　　　　"},
  {"code": "0095487", "name": "五股工業區分行　　　　　　　　　　　　　"},
  {"code": "0095494", "name": "南新莊分行　　　　　　　　　　　　　　　"},
  {"code": "0095505", "name": "三重埔分行　　　　　　　　　　　　　　　"},
  {"code": "0095512", "name": "北三重埔分行　　　　　　　　　　　　　　"},
  {"code": "0095529", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "0095536", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "0095543", "name": "瑞芳分行　　　　　　　　　　　　　　　　"},
  {"code": "0095550", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "0095567", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "0095574", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0095581", "name": "三峽分行　　　　　　　　　　　　　　　　"},
  {"code": "0095598", "name": "福和分行　　　　　　　　　　　　　　　　"},
  {"code": "0095609", "name": "光復分行　　　　　　　　　　　　　　　　"},
  {"code": "0095616", "name": "東三重分行　　　　　　　　　　　　　　　"},
  {"code": "0095623", "name": "北新分行　　　　　　　　　　　　　　　　"},
  {"code": "0095630", "name": "南三重分行　　　　　　　　　　　　　　　"},
  {"code": "0095647", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "0095654", "name": "西三重分行　　　　　　　　　　　　　　　"},
  {"code": "0095661", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "0095678", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "0095685", "name": "淡水分行　　　　　　　　　　　　　　　　"},
  {"code": "0095692", "name": "楊梅分行　　　　　　　　　　　　　　　　"},
  {"code": "0095703", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0095710", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0095727", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0095734", "name": "竹東分行　　　　　　　　　　　　　　　　"},
  {"code": "0095741", "name": "苗栗分行　　　　　　　　　　　　　　　　"},
  {"code": "0095758", "name": "新竹科學園區分行　　　　　　　　　　　　"},
  {"code": "0095765", "name": "北中壢分行　　　　　　　　　　　　　　　"},
  {"code": "0095772", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "0095789", "name": "竹南分行　　　　　　　　　　　　　　　　"},
  {"code": "0095796", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0095807", "name": "苑裡分行　　　　　　　　　　　　　　　　"},
  {"code": "0095814", "name": "大甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0095821", "name": "清水分行　　　　　　　　　　　　　　　　"},
  {"code": "0095838", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "0095845", "name": "東勢分行　　　　　　　　　　　　　　　　"},
  {"code": "0095852", "name": "霧峰分行　　　　　　　　　　　　　　　　"},
  {"code": "0095869", "name": "大雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0095876", "name": "沙鹿分行　　　　　　　　　　　　　　　　"},
  {"code": "0095890", "name": "太平分行　　　　　　　　　　　　　　　　"},
  {"code": "0095901", "name": "草屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0095918", "name": "南投分行　　　　　　　　　　　　　　　　"},
  {"code": "0095925", "name": "埔里分行　　　　　　　　　　　　　　　　"},
  {"code": "0095932", "name": "水裡坑分行　　　　　　　　　　　　　　　"},
  {"code": "0095963", "name": "大肚分行　　　　　　　　　　　　　　　　"},
  {"code": "0095987", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "0096006", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "0096013", "name": "鹿港分行　　　　　　　　　　　　　　　　"},
  {"code": "0096020", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "0096037", "name": "溪湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0096044", "name": "北斗分行　　　　　　　　　　　　　　　　"},
  {"code": "0096051", "name": "西螺分行　　　　　　　　　　　　　　　　"},
  {"code": "0096068", "name": "和美分行　　　　　　　　　　　　　　　　"},
  {"code": "0096075", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "0096099", "name": "二林分行　　　　　　　　　　　　　　　　"},
  {"code": "0096100", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "0096117", "name": "斗南分行　　　　　　　　　　　　　　　　"},
  {"code": "0096124", "name": "虎尾分行　　　　　　　　　　　　　　　　"},
  {"code": "0096131", "name": "北港分行　　　　　　　　　　　　　　　　"},
  {"code": "0096204", "name": "大林分行　　　　　　　　　　　　　　　　"},
  {"code": "0096211", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "0096228", "name": "東嘉義分行　　　　　　　　　　　　　　　"},
  {"code": "0096235", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "0096242", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "0096266", "name": "歸仁分行　　　　　　　　　　　　　　　　"},
  {"code": "0096402", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0096419", "name": "延平分行　　　　　　　　　　　　　　　　"},
  {"code": "0096426", "name": "西台南分行　　　　　　　　　　　　　　　"},
  {"code": "0096433", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "0096440", "name": "南台南分行　　　　　　　　　　　　　　　"},
  {"code": "0096457", "name": "安南分行　　　　　　　　　　　　　　　　"},
  {"code": "0096506", "name": "旗山分行　　　　　　　　　　　　　　　　"},
  {"code": "0096513", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "0096520", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "0098119", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0098126", "name": "七賢分行　　　　　　　　　　　　　　　　"},
  {"code": "0098133", "name": "鹽埕分行　　　　　　　　　　　　　　　　"},
  {"code": "0098140", "name": "東高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0098157", "name": "南高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0098164", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0098171", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "0098195", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0098206", "name": "九如路分行　　　　　　　　　　　　　　　"},
  {"code": "0098213", "name": "新興分行　　　　　　　　　　　　　　　　"},
  {"code": "0098220", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0098237", "name": "大順分行　　　　　　　　　　　　　　　　"},
  {"code": "0098244", "name": "博愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0098251", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "0098300", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "0098317", "name": "東港分行　　　　　　　　　　　　　　　　"},
  {"code": "0098324", "name": "潮州分行　　　　　　　　　　　　　　　　"},
  {"code": "0098348", "name": "恆春分行　　　　　　　　　　　　　　　　"},
  {"code": "0098404", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "0098508", "name": "台東分行　　　　　　　　　　　　　　　　"},
  {"code": "0099269", "name": "思源分行　　　　　　　　　　　　　　　　"},
  {"code": "0099283", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "0099290", "name": "北桃園分行　　　　　　　　　　　　　　　"},
  {"code": "0099301", "name": "新明分行　　　　　　　　　　　　　　　　"},
  {"code": "0099318", "name": "埔心分行　　　　　　　　　　　　　　　　"},
  {"code": "0099332", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0099349", "name": "大發分行　　　　　　　　　　　　　　　　"},
  {"code": "0099356", "name": "東林口分行　　　　　　　　　　　　　　　"},
  {"code": "0099363", "name": "新林口分行　　　　　　　　　　　　　　　"},
  {"code": "0099523", "name": "土庫分行　　　　　　　　　　　　　　　　"},
  {"code": "0099547", "name": "路竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0099554", "name": "蘇澳分行　　　　　　　　　　　　　　　　"},
  {"code": "0099561", "name": "北台南分行　　　　　　　　　　　　　　　"},
  {"code": "0099603", "name": "潭子分行　　　　　　　　　　　　　　　　"},
  {"code": "0099610", "name": "北嘉義分行　　　　　　　　　　　　　　　"},
  {"code": "0099627", "name": "北新竹分行　　　　　　　　　　　　　　　"},
  {"code": "0099634", "name": "建興分行　　　　　　　　　　　　　　　　"},
  {"code": "0099641", "name": "三和路分行　　　　　　　　　　　　　　　"},
  {"code": "0099658", "name": "吉成分行　　　　　　　　　　　　　　　　"},
  {"code": "0099689", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "0099696", "name": "江翠分行　　　　　　　　　　　　　　　　"},
  {"code": "0099714", "name": "長安東路分行　　　　　　　　　　　　　　"},
  {"code": "0099721", "name": "晴光分行　　　　　　　　　　　　　　　　"},
  {"code": "0099738", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "0099752", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "0099790", "name": "西內湖分行　　　　　　　　　　　　　　　"},
  {"code": "0099801", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "0099818", "name": "中港分行　　　　　　　　　　　　　　　　"},
  {"code": "0099832", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "0099849", "name": "中華路分行　　　　　　　　　　　　　　　"}
  ],
  "011": [
  {"code": "0110026", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0110037", "name": "儲蓄部　　　　　　　　　　　　　　　　　"},
  {"code": "0110048", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0110060", "name": "城中分行　　　　　　　　　　　　　　　　"},
  {"code": "0110082", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0110093", "name": "東台北分行　　　　　　　　　　　　　　　"},
  {"code": "0110107", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0110118", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0110129", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0110130", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "0110141", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0110152", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "0110163", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "0110185", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "0110196", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "0110200", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "0110211", "name": "龍山分行　　　　　　　　　　　　　　　　"},
  {"code": "0110222", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0110233", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "0110244", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0110255", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "0110266", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0110288", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "0110299", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "0110303", "name": "前金分行　　　　　　　　　　　　　　　　"},
  {"code": "0110314", "name": "松南分行　　　　　　　　　　　　　　　　"},
  {"code": "0110325", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "0110336", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "0110347", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0110358", "name": "中港分行　　　　　　　　　　　　　　　　"},
  {"code": "0110369", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "0110370", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "0110381", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "0110392", "name": "北三重分行　　　　　　　　　　　　　　　"},
  {"code": "0110406", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "0110417", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "0110428", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "0110439", "name": "世貿分行　　　　　　　　　　　　　　　　"},
  {"code": "0110440", "name": "承德分行　　　　　　　　　　　　　　　　"},
  {"code": "0110451", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "0110462", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "0110473", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "0110484", "name": "華江分行　　　　　　　　　　　　　　　　"},
  {"code": "0110495", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "0110509", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "0110510", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "0110521", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "0110532", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0110543", "name": "楊梅分行　　　　　　　　　　　　　　　　"},
  {"code": "0110554", "name": "內湖科技園區分行　　　　　　　　　　　　"},
  {"code": "0110565", "name": "北中和分行　　　　　　　　　　　　　　　"},
  {"code": "0110576", "name": "西湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0110598", "name": "二重分行　　　　　　　　　　　　　　　　"},
  {"code": "0110602", "name": "延平分行　　　　　　　　　　　　　　　　"},
  {"code": "0110613", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0110624", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "0110635", "name": "北新竹分行　　　　　　　　　　　　　　　"},
  {"code": "0110657", "name": "宜蘭分行　　　　　　　　　　　　　　　　"},
  {"code": "0110668", "name": "文山分行　　　　　　　　　　　　　　　　"},
  {"code": "0110680", "name": "敦北分行　　　　　　　　　　　　　　　　"},
  {"code": "0110691", "name": "東高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0110705", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "0110716", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "0110727", "name": "市政分行　　　　　　　　　　　　　　　　"},
  {"code": "0110738", "name": "觀音分行　　　　　　　　　　　　　　　　"},
  {"code": "0110749", "name": "北桃園分行　　　　　　　　　　　　　　　"},
  {"code": "0110750", "name": "丹鳳分行　　　　　　　　　　　　　　　　"},
  {"code": "0110761", "name": "北新莊分行　　　　　　　　　　　　　　　"},
  {"code": "0110772", "name": "南屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0110794", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "0110808", "name": "竹科分行　　　　　　　　　　　　　　　　"},
  {"code": "0110819", "name": "永吉分行　　　　　　　　　　　　　　　　"}
  ],
  "012": [
  {"code": "0122009", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0122032", "name": "長安東路分行　　　　　　　　　　　　　　"},
  {"code": "0122102", "name": "公庫處　　　　　　　　　　　　　　　　　"},
  {"code": "0122205", "name": "城東分行　　　　　　　　　　　　　　　　"},
  {"code": "0122216", "name": "農安分行（客戶移撥建國分行服務）　　　　"},
  {"code": "0123006", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "0123017", "name": "士東分行　　　　　　　　　　　　　　　　"},
  {"code": "0123028", "name": "瑞光分行（客戶移撥瑞湖分行服務）　　　　"},
  {"code": "0123039", "name": "玉成分行　　　　　　　　　　　　　　　　"},
  {"code": "0123040", "name": "福港分行　　　　　　　　　　　　　　　　"},
  {"code": "0123051", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "0123062", "name": "承德分行（客戶移撥延平分行服務）　　　　"},
  {"code": "0123073", "name": "龍江分行（客戶移撥南京東路分行服務）　　"},
  {"code": "0123109", "name": "延平分行　　　　　　　　　　　　　　　　"},
  {"code": "0123202", "name": "木柵分行　　　　　　　　　　　　　　　　"},
  {"code": "0123213", "name": "木新分行（客戶移撥木柵分行服務）　　　　"},
  {"code": "0123305", "name": "西門分行（客戶移撥桂林分行服務）　　　　"},
  {"code": "0123408", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "0123419", "name": "松南分行　　　　　　　　　　　　　　　　"},
  {"code": "0123420", "name": "永吉分行　　　　　　　　　　　　　　　　"},
  {"code": "0123501", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "0123604", "name": "北投分行　　　　　　　　　　　　　　　　"},
  {"code": "0123615", "name": "石牌分行　　　　　　　　　　　　　　　　"},
  {"code": "0123707", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "0123800", "name": "大同分行　　　　　　　　　　　　　　　　"},
  {"code": "0123903", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "0124003", "name": "雙園分行　　　　　　　　　　　　　　　　"},
  {"code": "0124014", "name": "萬華分行　　　　　　　　　　　　　　　　"},
  {"code": "0124106", "name": "建成分行　　　　　　　　　　　　　　　　"},
  {"code": "0124117", "name": "市府分行　　　　　　　　　　　　　　　　"},
  {"code": "0124209", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "0124302", "name": "景美分行　　　　　　　　　　　　　　　　"},
  {"code": "0124313", "name": "興隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0124405", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0124427", "name": "文德分行　　　　　　　　　　　　　　　　"},
  {"code": "0124508", "name": "敦化分行　　　　　　　　　　　　　　　　"},
  {"code": "0124542", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "0124601", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "0124612", "name": "莊敬分行　　　　　　　　　　　　　　　　"},
  {"code": "0124623", "name": "東門分行　　　　　　　　　　　　　　　　"},
  {"code": "0124704", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "0124807", "name": "和平分行　　　　　　　　　　　　　　　　"},
  {"code": "0124900", "name": "延吉分行（客戶移撥安和分行服務）　　　　"},
  {"code": "0125103", "name": "南門分行　　　　　　　　　　　　　　　　"},
  {"code": "0125206", "name": "復興分行（客戶移撥敦北分行服務）　　　　"},
  {"code": "0125309", "name": "西松分行　　　　　　　　　　　　　　　　"},
  {"code": "0125402", "name": "長安分行（客戶移撥城東分行服務）　　　　"},
  {"code": "0125505", "name": "桂林分行　　　　　　　　　　　　　　　　"},
  {"code": "0125701", "name": "敦和分行　　　　　　　　　　　　　　　　"},
  {"code": "0125804", "name": "臨沂分行　　　　　　　　　　　　　　　　"},
  {"code": "0125907", "name": "中崙分行　　　　　　　　　　　　　　　　"},
  {"code": "0126007", "name": "基隆路分行　　　　　　　　　　　　　　　"},
  {"code": "0126100", "name": "師大分行　　　　　　　　　　　　　　　　"},
  {"code": "0126203", "name": "永春分行　　　　　　　　　　　　　　　　"},
  {"code": "0126214", "name": "懷生分行　　　　　　　　　　　　　　　　"},
  {"code": "0126306", "name": "民權分行　　　　　　　　　　　　　　　　"},
  {"code": "0126409", "name": "吉林簡易型分行（客戶移撥松江分行服務）　"},
  {"code": "0126502", "name": "社子分行　　　　　　　　　　　　　　　　"},
  {"code": "0126605", "name": "港都分行　　　　　　　　　　　　　　　　"},
  {"code": "0126683", "name": "西湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0126694", "name": "金城分行（客戶移撥土城分行服務）　　　　"},
  {"code": "0126708", "name": "萬隆分行（客戶移撥景美分行服務）　　　　"},
  {"code": "0126719", "name": "中港分行　　　　　　　　　　　　　　　　"},
  {"code": "0126720", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "0126731", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0126742", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0126764", "name": "松隆簡易型分行（客戶移撥永吉分行服務）　"},
  {"code": "0126775", "name": "埔墘分行　　　　　　　　　　　　　　　　"},
  {"code": "0126786", "name": "北中壢分行　　　　　　　　　　　　　　　"},
  {"code": "0126797", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "0126801", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "0126812", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "0126823", "name": "鼓山分行　　　　　　　　　　　　　　　　"},
  {"code": "0126845", "name": "風城分行　　　　　　　　　　　　　　　　"},
  {"code": "0126856", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "0126867", "name": "東湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0126878", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "0126889", "name": "岡山簡易型分行　　　　　　　　　　　　　"},
  {"code": "0126890", "name": "台北一０一分行　　　　　　　　　　　　　"},
  {"code": "0127015", "name": "雙連分行（客戶移撥營業部服務）　　　　　"},
  {"code": "0127026", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "0127037", "name": "敦北分行　　　　　　　　　　　　　　　　"},
  {"code": "0127048", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0127059", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0127060", "name": "中正分行　　　　　　　　　　　　　　　　"},
  {"code": "0127071", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0127093", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "0127107", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "0127118", "name": "東寧分行　　　　　　　　　　　　　　　　"},
  {"code": "0127129", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "0127130", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0127152", "name": "安和分行　　　　　　　　　　　　　　　　"},
  {"code": "0127163", "name": "正義分行　　　　　　　　　　　　　　　　"},
  {"code": "0127174", "name": "大湳分行　　　　　　　　　　　　　　　　"},
  {"code": "0127185", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "0127196", "name": "苓雅分行（客戶移撥港都分行服務）　　　　"},
  {"code": "0127211", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0127222", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "0127233", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "0127244", "name": "建國分行　　　　　　　　　　　　　　　　"},
  {"code": "0127255", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0127266", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "0127277", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "0127288", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "0127303", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "0127314", "name": "城中分行　　　　　　　　　　　　　　　　"},
  {"code": "0127336", "name": "五股分行　　　　　　　　　　　　　　　　"},
  {"code": "0127347", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "0127358", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "0127369", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0127370", "name": "敦南分行　　　　　　　　　　　　　　　　"},
  {"code": "0127381", "name": "保生分行　　　　　　　　　　　　　　　　"},
  {"code": "0127392", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "0127406", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "0127417", "name": "瑞湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0127428", "name": "基和簡易型分行（客戶移撥敦和分行服務）　"},
  {"code": "0127439", "name": "南昌簡易型分行（客戶移撥金華分行服務）　"},
  {"code": "0127451", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "0127462", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "0127473", "name": "南台中分行　　　　　　　　　　　　　　　"},
  {"code": "0127484", "name": "博愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0127495", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "0127509", "name": "華江分行　　　　　　　　　　　　　　　　"},
  {"code": "0127510", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "0127521", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "0127532", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0127543", "name": "竹科分行　　　　　　　　　　　　　　　　"},
  {"code": "0127554", "name": "林口簡易型分行　　　　　　　　　　　　　"},
  {"code": "0127565", "name": "新板分行　　　　　　　　　　　　　　　　"},
  {"code": "0127576", "name": "三峽分行　　　　　　　　　　　　　　　　"},
  {"code": "0127587", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0127598", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "0127602", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "0127613", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "0127624", "name": "得和分行　　　　　　　　　　　　　　　　"},
  {"code": "0127635", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "0127646", "name": "國美分行　　　　　　　　　　　　　　　　"},
  {"code": "0127657", "name": "南勢角分行　　　　　　　　　　　　　　　"},
  {"code": "0127668", "name": "北屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0127679", "name": "淡水分行　　　　　　　　　　　　　　　　"},
  {"code": "0127680", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0127691", "name": "北新分行　　　　　　　　　　　　　　　　"},
  {"code": "0127705", "name": "市政分行　　　　　　　　　　　　　　　　"},
  {"code": "0127716", "name": "北新莊分行　　　　　　　　　　　　　　　"},
  {"code": "0127727", "name": "大雅簡易型分行　　　　　　　　　　　　　"}
  ],
  "013": [
  {"code": "0130017", "name": "館前分行　　　　　　　　　　　　　　　　"},
  {"code": "0130028", "name": "環球交易服務部　　　　　　　　　　　　　"},
  {"code": "0130039", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "0130051", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0130062", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0130073", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "0130095", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "0130109", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0130110", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "0130121", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "0130132", "name": "西台中分行　　　　　　　　　　　　　　　"},
  {"code": "0130143", "name": "東高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0130154", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "0130165", "name": "光復分行　　　　　　　　　　　　　　　　"},
  {"code": "0130176", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0130187", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "0130198", "name": "民權分行　　　　　　　　　　　　　　　　"},
  {"code": "0130202", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "0130213", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "0130224", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0130235", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "0130246", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "0130257", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "0130268", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "0130279", "name": "安和分行　　　　　　　　　　　　　　　　"},
  {"code": "0130280", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "0130291", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0130305", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "0130316", "name": "建成分行　　　　　　　　　　　　　　　　"},
  {"code": "0130327", "name": "東門分行　　　　　　　　　　　　　　　　"},
  {"code": "0130349", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0130350", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "0130361", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "0130372", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "0130383", "name": "前金分行　　　　　　　　　　　　　　　　"},
  {"code": "0130394", "name": "北三重分行　　　　　　　　　　　　　　　"},
  {"code": "0130408", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0130419", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "0130420", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "0130431", "name": "埔墘分行　　　　　　　　　　　　　　　　"},
  {"code": "0130442", "name": "新生分行　　　　　　　　　　　　　　　　"},
  {"code": "0130453", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "0130464", "name": "清水分行　　　　　　　　　　　　　　　　"},
  {"code": "0130475", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "0130486", "name": "敦北分行　　　　　　　　　　　　　　　　"},
  {"code": "0130497", "name": "中正分行　　　　　　　　　　　　　　　　"},
  {"code": "0130501", "name": "五權分行　　　　　　　　　　　　　　　　"},
  {"code": "0130512", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "0130523", "name": "新興分行　　　　　　　　　　　　　　　　"},
  {"code": "0130534", "name": "敦南分行　　　　　　　　　　　　　　　　"},
  {"code": "0130545", "name": "後埔分行　　　　　　　　　　　　　　　　"},
  {"code": "0130556", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "0130567", "name": "西門分行　　　　　　　　　　　　　　　　"},
  {"code": "0130578", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "0130590", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0130604", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "0130615", "name": "南高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0130626", "name": "大同分行　　　　　　　　　　　　　　　　"},
  {"code": "0130637", "name": "成功分行　　　　　　　　　　　　　　　　"},
  {"code": "0130648", "name": "中港分行　　　　　　　　　　　　　　　　"},
  {"code": "0130659", "name": "世貿分行　　　　　　　　　　　　　　　　"},
  {"code": "0130660", "name": "北桃園分行　　　　　　　　　　　　　　　"},
  {"code": "0130671", "name": "善化分行　　　　　　　　　　　　　　　　"},
  {"code": "0130682", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "0130693", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "0130707", "name": "二重分行　　　　　　　　　　　　　　　　"},
  {"code": "0130729", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "0130730", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0130741", "name": "華江分行　　　　　　　　　　　　　　　　"},
  {"code": "0130752", "name": "竹科分行　　　　　　　　　　　　　　　　"},
  {"code": "0130763", "name": "南門分行　　　　　　　　　　　　　　　　"},
  {"code": "0130774", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "0130785", "name": "永春分行　　　　　　　　　　　　　　　　"},
  {"code": "0130796", "name": "萬華分行　　　　　　　　　　　　　　　　"},
  {"code": "0131014", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "0131025", "name": "台東分行　　　　　　　　　　　　　　　　"},
  {"code": "0131036", "name": "文山分行　　　　　　　　　　　　　　　　"},
  {"code": "0131047", "name": "新樹分行　　　　　　　　　　　　　　　　"},
  {"code": "0131058", "name": "宜蘭分行　　　　　　　　　　　　　　　　"},
  {"code": "0131069", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "0131070", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "0131081", "name": "南投分行　　　　　　　　　　　　　　　　"},
  {"code": "0131092", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "0131106", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "0131117", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "0131128", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "0131139", "name": "大甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0131140", "name": "苗栗分行　　　　　　　　　　　　　　　　"},
  {"code": "0131151", "name": "北投分行　　　　　　　　　　　　　　　　"},
  {"code": "0131162", "name": "臨安分行　　　　　　　　　　　　　　　　"},
  {"code": "0131173", "name": "幸福分行　　　　　　　　　　　　　　　　"},
  {"code": "0131184", "name": "華山分行　　　　　　　　　　　　　　　　"},
  {"code": "0131195", "name": "東湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0131209", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "0131210", "name": "臨沂分行　　　　　　　　　　　　　　　　"},
  {"code": "0131221", "name": "新湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0131232", "name": "中崙分行　　　　　　　　　　　　　　　　"},
  {"code": "0131243", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0131254", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "0131276", "name": "淡水分行　　　　　　　　　　　　　　　　"},
  {"code": "0131287", "name": "連城分行　　　　　　　　　　　　　　　　"},
  {"code": "0131298", "name": "石牌分行　　　　　　　　　　　　　　　　"},
  {"code": "0131302", "name": "南內湖分行　　　　　　　　　　　　　　　"},
  {"code": "0131313", "name": "景美分行　　　　　　　　　　　　　　　　"},
  {"code": "0131324", "name": "大坪林分行　　　　　　　　　　　　　　　"},
  {"code": "0131335", "name": "丹鳳分行　　　　　　　　　　　　　　　　"},
  {"code": "0131346", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "0131357", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0131368", "name": "東林口分行　　　　　　　　　　　　　　　"},
  {"code": "0131379", "name": "大湳分行　　　　　　　　　　　　　　　　"},
  {"code": "0131380", "name": "松勤分行　　　　　　　　　　　　　　　　"},
  {"code": "0132011", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0132022", "name": "大昌分行　　　　　　　　　　　　　　　　"},
  {"code": "0132033", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "0132044", "name": "篤行分行　　　　　　　　　　　　　　　　"},
  {"code": "0132055", "name": "板東分行　　　　　　　　　　　　　　　　"},
  {"code": "0132066", "name": "桃興分行　　　　　　　　　　　　　　　　"},
  {"code": "0132088", "name": "彰泰分行（客戶移撥彰化分行服務）　　　　"},
  {"code": "0132099", "name": "嘉泰分行　　　　　　　　　　　　　　　　"},
  {"code": "0132103", "name": "竹城分行　　　　　　　　　　　　　　　　"},
  {"code": "0132114", "name": "忠誠分行　　　　　　　　　　　　　　　　"},
  {"code": "0132125", "name": "敦化分行　　　　　　　　　　　　　　　　"},
  {"code": "0132147", "name": "新泰分行　　　　　　　　　　　　　　　　"},
  {"code": "0132158", "name": "文心分行　　　　　　　　　　　　　　　　"},
  {"code": "0132169", "name": "福和分行　　　　　　　　　　　　　　　　"},
  {"code": "0132170", "name": "四維分行　　　　　　　　　　　　　　　　"},
  {"code": "0132181", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0132192", "name": "豐北分行（客戶移撥豐原分行服務）　　　　"},
  {"code": "0132206", "name": "重新分行　　　　　　　　　　　　　　　　"},
  {"code": "0132217", "name": "北中壢分行　　　　　　　　　　　　　　　"},
  {"code": "0132228", "name": "城東分行　　　　　　　　　　　　　　　　"},
  {"code": "0132239", "name": "建國分行　　　　　　　　　　　　　　　　"},
  {"code": "0132251", "name": "學府分行　　　　　　　　　　　　　　　　"},
  {"code": "0132262", "name": "北新分行　　　　　　　　　　　　　　　　"},
  {"code": "0132273", "name": "信安分行　　　　　　　　　　　　　　　　"},
  {"code": "0132295", "name": "文德分行　　　　　　　　　　　　　　　　"},
  {"code": "0132321", "name": "中台中分行　　　　　　　　　　　　　　　"},
  {"code": "0132332", "name": "水湳分行　　　　　　　　　　　　　　　　"},
  {"code": "0132343", "name": "市政分行　　　　　　　　　　　　　　　　"},
  {"code": "0132354", "name": "東台中分行　　　　　　　　　　　　　　　"},
  {"code": "0132365", "name": "昌平分行　　　　　　　　　　　　　　　　"},
  {"code": "0132376", "name": "健行分行　　　　　　　　　　　　　　　　"},
  {"code": "0132398", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0132402", "name": "南屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0132413", "name": "崇德分行　　　　　　　　　　　　　　　　"},
  {"code": "0132457", "name": "香山分行　　　　　　　　　　　　　　　　"},
  {"code": "0132468", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "0132480", "name": "同德分行　　　　　　　　　　　　　　　　"},
  {"code": "0132527", "name": "秀水分行　　　　　　　　　　　　　　　　"},
  {"code": "0132549", "name": "彰美分行　　　　　　　　　　　　　　　　"},
  {"code": "0132550", "name": "太平分行　　　　　　　　　　　　　　　　"},
  {"code": "0132561", "name": "沙鹿分行　　　　　　　　　　　　　　　　"},
  {"code": "0132583", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "0132608", "name": "逢甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0132619", "name": "大雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0132620", "name": "潭子分行　　　　　　　　　　　　　　　　"},
  {"code": "0132631", "name": "光華分行　　　　　　　　　　　　　　　　"},
  {"code": "0132642", "name": "西松分行　　　　　　　　　　　　　　　　"},
  {"code": "0132653", "name": "蘭雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0132664", "name": "永平分行　　　　　　　　　　　　　　　　"},
  {"code": "0132675", "name": "和平分行　　　　　　　　　　　　　　　　"},
  {"code": "0132686", "name": "慶城分行　　　　　　　　　　　　　　　　"},
  {"code": "0132697", "name": "瑞湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0132701", "name": "文昌分行　　　　　　　　　　　　　　　　"},
  {"code": "0132712", "name": "正義分行　　　　　　　　　　　　　　　　"},
  {"code": "0132723", "name": "新板分行　　　　　　　　　　　　　　　　"},
  {"code": "0132734", "name": "永貞分行　　　　　　　　　　　　　　　　"},
  {"code": "0132778", "name": "明誠分行　　　　　　　　　　　　　　　　"}
  ],
  "016": [
  {"code": "0161017", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0161028", "name": "公庫部　　　　　　　　　　　　　　　　　"},
  {"code": "0161039", "name": "岡山本洲分行　　　　　　　　　　　　　　"},
  {"code": "0161040", "name": "國外部　　　　　　　　　　　　　　　　　"},
  {"code": "0161051", "name": "信託部　　　　　　　　　　　　　　　　　"},
  {"code": "0162003", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "0162025", "name": "前金分行　　　　　　　　　　　　　　　　"},
  {"code": "0162036", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "0162081", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "0162106", "name": "小港分行　　　　　　　　　　　　　　　　"},
  {"code": "0162117", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0162128", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0162139", "name": "右昌分行　　　　　　　　　　　　　　　　"},
  {"code": "0162140", "name": "灣內分行　　　　　　　　　　　　　　　　"},
  {"code": "0162151", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "0162162", "name": "桂林分行　　　　　　　　　　　　　　　　"},
  {"code": "0162173", "name": "北屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0162184", "name": "楠梓分行　　　　　　　　　　　　　　　　"},
  {"code": "0162195", "name": "鼓山分行　　　　　　　　　　　　　　　　"},
  {"code": "0162209", "name": "建國分行　　　　　　　　　　　　　　　　"},
  {"code": "0162210", "name": "九如分行　　　　　　　　　　　　　　　　"},
  {"code": "0162221", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0162232", "name": "草衙分行　　　　　　　　　　　　　　　　"},
  {"code": "0162243", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0162254", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0162265", "name": "三多分行　　　　　　　　　　　　　　　　"},
  {"code": "0162276", "name": "大發分行　　　　　　　　　　　　　　　　"},
  {"code": "0162287", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "0162298", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0162313", "name": "旗津簡易型分行　　　　　　　　　　　　　"},
  {"code": "0162324", "name": "南高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0162335", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "0162346", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0162357", "name": "市府分行　　　　　　　　　　　　　　　　"},
  {"code": "0162379", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "0162380", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "0162405", "name": "成大分行　　　　　　　　　　　　　　　　"},
  {"code": "0162416", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0162450", "name": "博愛分行　　　　　　　　　　　　　　　　"}
  ],
  "017": [
  {"code": "0170022", "name": "港都分行　　　　　　　　　　　　　　　　"},
  {"code": "0170033", "name": "楠梓分行　　　　　　　　　　　　　　　　"},
  {"code": "0170044", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0170055", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "0170066", "name": "府城分行　　　　　　　　　　　　　　　　"},
  {"code": "0170077", "name": "國外部　　　　　　　　　　　　　　　　　"},
  {"code": "0170088", "name": "台北復興分行　　　　　　　　　　　　　　"},
  {"code": "0170099", "name": "財富管理處　　　　　　　　　　　　　　　"},
  {"code": "0170103", "name": "蘭雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0170114", "name": "財務處　　　　　　　　　　　　　　　　　"},
  {"code": "0170125", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "0170136", "name": "新興分行　　　　　　　　　　　　　　　　"},
  {"code": "0170147", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0170158", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "0170169", "name": "高雄加工出口區分行　　　　　　　　　　　"},
  {"code": "0170170", "name": "城中分行　　　　　　　　　　　　　　　　"},
  {"code": "0170181", "name": "北彰化分行　　　　　　　　　　　　　　　"},
  {"code": "0170192", "name": "安和分行　　　　　　　　　　　　　　　　"},
  {"code": "0170206", "name": "竹科新安分行　　　　　　　　　　　　　　"},
  {"code": "0170217", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "0170228", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "0170239", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "0170251", "name": "國際金融業務分行　　　　　　　　　　　　"},
  {"code": "0170262", "name": "北新竹分行　　　　　　　　　　　　　　　"},
  {"code": "0170273", "name": "板南分行　　　　　　　　　　　　　　　　"},
  {"code": "0170284", "name": "潭子分行　　　　　　　　　　　　　　　　"},
  {"code": "0170295", "name": "桃園國際機場分行　　　　　　　　　　　　"},
  {"code": "0170309", "name": "南台北分行　　　　　　　　　　　　　　　"},
  {"code": "0170310", "name": "敦南分行　　　　　　　　　　　　　　　　"},
  {"code": "0170321", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "0170343", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "0170354", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "0170365", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "0170376", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "0170387", "name": "三多分行　　　　　　　　　　　　　　　　"},
  {"code": "0170398", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0170402", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "0170413", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "0170424", "name": "松南分行　　　　　　　　　　　　　　　　"},
  {"code": "0170435", "name": "大同分行　　　　　　　　　　　　　　　　"},
  {"code": "0170446", "name": "南台中分行　　　　　　　　　　　　　　　"},
  {"code": "0170457", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "0170468", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "0170479", "name": "東高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0170480", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "0170491", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0170505", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "0170516", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0170527", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "0170538", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "0170550", "name": "松山機場分行　　　　　　　　　　　　　　"},
  {"code": "0170561", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "0170572", "name": "大稻埕分行　　　　　　　　　　　　　　　"},
  {"code": "0170583", "name": "頭份分行　　　　　　　　　　　　　　　　"},
  {"code": "0170594", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0170608", "name": "沙鹿分行　　　　　　　　　　　　　　　　"},
  {"code": "0170619", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "0170620", "name": "宜蘭分行　　　　　　　　　　　　　　　　"},
  {"code": "0170631", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "0170642", "name": "南投分行　　　　　　　　　　　　　　　　"},
  {"code": "0170653", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "0170664", "name": "高雄國際機場分行　　　　　　　　　　　　"},
  {"code": "0170675", "name": "東內湖分行　　　　　　　　　　　　　　　"},
  {"code": "0170686", "name": "太平分行　　　　　　　　　　　　　　　　"},
  {"code": "0170697", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "0170701", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "0170712", "name": "東台中分行　　　　　　　　　　　　　　　"},
  {"code": "0170723", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0170745", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "0170756", "name": "竹南科學園區分行　　　　　　　　　　　　"},
  {"code": "0170767", "name": "中科分行　　　　　　　　　　　　　　　　"},
  {"code": "0170778", "name": "大甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0170789", "name": "成功簡易型分行　　　　　　　　　　　　　"},
  {"code": "0170790", "name": "金門分行　　　　　　　　　　　　　　　　"},
  {"code": "0170804", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0170815", "name": "中鋼簡易型分行　　　　　　　　　　　　　"},
  {"code": "0170837", "name": "榮總分行　　　　　　　　　　　　　　　　"},
  {"code": "0170860", "name": "駐外交部簡易型分行　　　　　　　　　　　"},
  {"code": "0171030", "name": "仁武分行　　　　　　　　　　　　　　　　"},
  {"code": "0171166", "name": "高雄漁港簡易型分行　　　　　　　　　　　"},
  {"code": "0172015", "name": "金控總部分行　　　　　　　　　　　　　　"},
  {"code": "0172026", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "0172037", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0172048", "name": "中台中分行　　　　　　　　　　　　　　　"},
  {"code": "0172059", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0172060", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0172071", "name": "桃興分行　　　　　　　　　　　　　　　　"},
  {"code": "0172082", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "0172107", "name": "敦化分行　　　　　　　　　　　　　　　　"},
  {"code": "0172129", "name": "嘉興分行　　　　　　　　　　　　　　　　"},
  {"code": "0172130", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0172141", "name": "寶成分行　　　　　　　　　　　　　　　　"},
  {"code": "0172152", "name": "竹科竹村分行　　　　　　　　　　　　　　"},
  {"code": "0172163", "name": "世貿分行　　　　　　　　　　　　　　　　"},
  {"code": "0172196", "name": "南三重分行　　　　　　　　　　　　　　　"},
  {"code": "0172200", "name": "南彰化分行　　　　　　　　　　　　　　　"},
  {"code": "0172266", "name": "城東分行　　　　　　　　　　　　　　　　"},
  {"code": "0172277", "name": "五福分行　　　　　　　　　　　　　　　　"},
  {"code": "0172288", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "0172299", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "0172314", "name": "城北分行　　　　　　　　　　　　　　　　"},
  {"code": "0172325", "name": "后里分行　　　　　　　　　　　　　　　　"},
  {"code": "0172336", "name": "鹿港分行　　　　　　　　　　　　　　　　"},
  {"code": "0172347", "name": "圓山分行　　　　　　　　　　　　　　　　"},
  {"code": "0172358", "name": "思源分行　　　　　　　　　　　　　　　　"},
  {"code": "0172369", "name": "北中壢分行　　　　　　　　　　　　　　　"},
  {"code": "0172370", "name": "內湖科學園區分行　　　　　　　　　　　　"},
  {"code": "0172381", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "0172406", "name": "衡陽分行　　　　　　　　　　　　　　　　"},
  {"code": "0172417", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "0172428", "name": "台南科學園區分行　　　　　　　　　　　　"}
  ],
  "018": [
  {"code": "0180012", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0180034", "name": "臺中分行　　　　　　　　　　　　　　　　"},
  {"code": "0180045", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0180067", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0180078", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "0180090", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0180104", "name": "臺南分行　　　　　　　　　　　　　　　　"}
  ],
  "020": [
  {"code": "0200017", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "0200028", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0200040", "name": "台中分行　　　　　　　　　　　　　　　　"}
  ],
  "021": [
  {"code": "0210018", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0210030", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0210041", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0210052", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0210063", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0210074", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0210085", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "0210096", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0210100", "name": "文心分行　　　　　　　　　　　　　　　　"},
  {"code": "0210111", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "0210122", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "0210133", "name": "建成分行　　　　　　　　　　　　　　　　"},
  {"code": "0210144", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "0210166", "name": "永福分行　　　　　　　　　　　　　　　　"},
  {"code": "0210177", "name": "港都分行　　　　　　　　　　　　　　　　"},
  {"code": "0210188", "name": "中港分行　　　　　　　　　　　　　　　　"},
  {"code": "0210199", "name": "襄陽分行　　　　　　　　　　　　　　　　"},
  {"code": "0210203", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "0210214", "name": "新興分行　　　　　　　　　　　　　　　　"},
  {"code": "0210225", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0210236", "name": "北桃園分行　　　　　　　　　　　　　　　"},
  {"code": "0210247", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "0210258", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "0210269", "name": "民權分行　　　　　　　　　　　　　　　　"},
  {"code": "0210281", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0210292", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "0210306", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "0210317", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "0210328", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "0210340", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0210351", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "0210362", "name": "竹城分行　　　　　　　　　　　　　　　　"},
  {"code": "0210373", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "0210384", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "0210395", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0210409", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "0210421", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "0210443", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "0210465", "name": "高美館分行　　　　　　　　　　　　　　　"},
  {"code": "0210476", "name": "南京分行　　　　　　　　　　　　　　　　"},
  {"code": "0210502", "name": "中正分行　　　　　　　　　　　　　　　　"},
  {"code": "0210513", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "0210524", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "0210535", "name": "敦化分行　　　　　　　　　　　　　　　　"},
  {"code": "0210579", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0210580", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "0210627", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "0210650", "name": "土城分行　　　　　　　　　　　　　　　　"}
  ],
  "022": [
  {"code": "0220019", "name": "美國銀行台北分行　　　　　　　　　　　　"}
  ],
  "023": [
  {"code": "0230010", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "0230032", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0230043", "name": "台中分行　　　　　　　　　　　　　　　　"}
  ],
  "025": [
  {"code": "0250012", "name": "台北分行　　　　　　　　　　　　　　　　"}
  ],
  "029": [
  {"code": "0290005", "name": "台北分行　　　　　　　　　　　　　　　　"}
  ],
  "030": [
  {"code": "0300010", "name": "台北分行　　　　　　　　　　　　　　　　"}
  ],
  "037": [
  {"code": "0370017", "name": "台北分行　　　　　　　　　　　　　　　　"}
  ],
  "039": [
  {"code": "0390019", "name": "台北分行　　　　　　　　　　　　　　　　"}
  ],
  "048": [
  {"code": "0480011", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0480022", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0480033", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0480055", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0480066", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0480077", "name": "忠孝敦化分行　　　　　　　　　　　　　　"}
  ],
  "050": [
  {"code": "0500016", "name": "吉林分行（客戶移撥建國分行服務）　　　　"},
  {"code": "0500027", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "0500038", "name": "博愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0500049", "name": "北桃園分行　　　　　　　　　　　　　　　"},
  {"code": "0500050", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0500061", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0500072", "name": "忠明分行　　　　　　　　　　　　　　　　"},
  {"code": "0500094", "name": "金門分行　　　　　　　　　　　　　　　　"},
  {"code": "0500108", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0500119", "name": "大雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0500120", "name": "仁大分行　　　　　　　　　　　　　　　　"},
  {"code": "0500201", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0500212", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "0500223", "name": "建成分行　　　　　　　　　　　　　　　　"},
  {"code": "0500234", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "0500245", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "0500256", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "0500267", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "0500278", "name": "化成分行　　　　　　　　　　　　　　　　"},
  {"code": "0500407", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "0500500", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "0500603", "name": "萬華分行　　　　　　　　　　　　　　　　"},
  {"code": "0500614", "name": "南台北分行　　　　　　　　　　　　　　　"},
  {"code": "0500706", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "0500809", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "0500810", "name": "建國分行　　　　　　　　　　　　　　　　"},
  {"code": "0500821", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0500902", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "0501002", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "0501024", "name": "世貿分行　　　　　　　　　　　　　　　　"},
  {"code": "0501035", "name": "永春分行　　　　　　　　　　　　　　　　"},
  {"code": "0501057", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "0501105", "name": "松南分行　　　　　　　　　　　　　　　　"},
  {"code": "0501116", "name": "東湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0501208", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "0501219", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "0501220", "name": "錦和分行　　　　　　　　　　　　　　　　"},
  {"code": "0501301", "name": "五股分行　　　　　　　　　　　　　　　　"},
  {"code": "0501312", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "0501323", "name": "東林口分行　　　　　　　　　　　　　　　"},
  {"code": "0501404", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0501415", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "0501426", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "0501437", "name": "迴龍分行　　　　　　　　　　　　　　　　"},
  {"code": "0501448", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "0501482", "name": "三峽分行　　　　　　　　　　　　　　　　"},
  {"code": "0501507", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "0501518", "name": "埔墘分行　　　　　　　　　　　　　　　　"},
  {"code": "0501529", "name": "北三重分行　　　　　　　　　　　　　　　"},
  {"code": "0501530", "name": "南三重分行　　　　　　　　　　　　　　　"},
  {"code": "0501541", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "0501600", "name": "宜蘭分行　　　　　　　　　　　　　　　　"},
  {"code": "0501703", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "0501714", "name": "蘇澳分行　　　　　　　　　　　　　　　　"},
  {"code": "0502906", "name": "楊梅分行　　　　　　　　　　　　　　　　"},
  {"code": "0502917", "name": "湖口分行　　　　　　　　　　　　　　　　"},
  {"code": "0503006", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0503017", "name": "大園分行　　　　　　　　　　　　　　　　"},
  {"code": "0503028", "name": "大溪分行　　　　　　　　　　　　　　　　"},
  {"code": "0503109", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0503110", "name": "內壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0503121", "name": "新明分行　　　　　　　　　　　　　　　　"},
  {"code": "0503132", "name": "東桃園分行　　　　　　　　　　　　　　　"},
  {"code": "0503154", "name": "新屋分行　　　　　　　　　　　　　　　　"},
  {"code": "0503202", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0503213", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "0503224", "name": "竹科分行　　　　　　　　　　　　　　　　"},
  {"code": "0503305", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "0503327", "name": "龍潭分行　　　　　　　　　　　　　　　　"},
  {"code": "0503408", "name": "竹東分行　　　　　　　　　　　　　　　　"},
  {"code": "0503501", "name": "竹南分行　　　　　　　　　　　　　　　　"},
  {"code": "0503512", "name": "頭份分行　　　　　　　　　　　　　　　　"},
  {"code": "0503604", "name": "苗栗分行　　　　　　　　　　　　　　　　"},
  {"code": "0504601", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "0504704", "name": "太平分行　　　　　　　　　　　　　　　　"},
  {"code": "0504807", "name": "大甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0504829", "name": "沙鹿分行　　　　　　　　　　　　　　　　"},
  {"code": "0504830", "name": "烏日分行　　　　　　　　　　　　　　　　"},
  {"code": "0504900", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0504911", "name": "民權分行　　　　　　　　　　　　　　　　"},
  {"code": "0505000", "name": "興中分行　　　　　　　　　　　　　　　　"},
  {"code": "0505011", "name": "北屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0505103", "name": "南投分行　　　　　　　　　　　　　　　　"},
  {"code": "0505114", "name": "草屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0505206", "name": "埔里分行　　　　　　　　　　　　　　　　"},
  {"code": "0505217", "name": "潭子分行　　　　　　　　　　　　　　　　"},
  {"code": "0505309", "name": "竹山分行　　　　　　　　　　　　　　　　"},
  {"code": "0505402", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "0505413", "name": "和美分行　　　　　　　　　　　　　　　　"},
  {"code": "0505505", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "0505608", "name": "北斗分行　　　　　　　　　　　　　　　　"},
  {"code": "0505619", "name": "二林分行　　　　　　　　　　　　　　　　"},
  {"code": "0506605", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "0506708", "name": "北港分行　　　　　　　　　　　　　　　　"},
  {"code": "0506719", "name": "虎尾分行　　　　　　　　　　　　　　　　"},
  {"code": "0506801", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "0506812", "name": "民雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0506867", "name": "嘉新分行　　　　　　　　　　　　　　　　"},
  {"code": "0506904", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "0506915", "name": "開元分行　　　　　　　　　　　　　　　　"},
  {"code": "0507004", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "0507015", "name": "學甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0507026", "name": "善化分行　　　　　　　　　　　　　　　　"},
  {"code": "0507037", "name": "永大分行　　　　　　　　　　　　　　　　"},
  {"code": "0507107", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0507118", "name": "仁德分行　　　　　　　　　　　　　　　　"},
  {"code": "0507200", "name": "成功分行　　　　　　　　　　　　　　　　"},
  {"code": "0507211", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "0507303", "name": "安平分行　　　　　　　　　　　　　　　　"},
  {"code": "0507602", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "0507705", "name": "台東分行　　　　　　　　　　　　　　　　"},
  {"code": "0508207", "name": "東高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0508300", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "0508403", "name": "北鳳山分行　　　　　　　　　　　　　　　"},
  {"code": "0508414", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0508506", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0508517", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0508528", "name": "大昌分行　　　　　　　　　　　　　　　　"},
  {"code": "0508539", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0508609", "name": "九如分行　　　　　　　　　　　　　　　　"},
  {"code": "0508702", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "0508805", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "0508816", "name": "大發分行　　　　　　　　　　　　　　　　"},
  {"code": "0508908", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "0508919", "name": "小港分行　　　　　　　　　　　　　　　　"},
  {"code": "0508920", "name": "潮州分行　　　　　　　　　　　　　　　　"}
  ],
  "052": [
  {"code": "0520041", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0520052", "name": "竹東分行　　　　　　　　　　　　　　　　"},
  {"code": "0520063", "name": "竹南分行　　　　　　　　　　　　　　　　"},
  {"code": "0520074", "name": "苗栗分行　　　　　　　　　　　　　　　　"},
  {"code": "0520096", "name": "頭份分行　　　　　　　　　　　　　　　　"},
  {"code": "0520111", "name": "楊梅分行　　　　　　　　　　　　　　　　"},
  {"code": "0520122", "name": "新屋分行　　　　　　　　　　　　　　　　"},
  {"code": "0520133", "name": "湖口分行　　　　　　　　　　　　　　　　"},
  {"code": "0520144", "name": "苑裡分行　　　　　　　　　　　　　　　　"},
  {"code": "0520166", "name": "龍潭分行　　　　　　　　　　　　　　　　"},
  {"code": "0520177", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "0520199", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "0520203", "name": "內壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0520214", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "0520225", "name": "新明分行　　　　　　　　　　　　　　　　"},
  {"code": "0520247", "name": "公館分行　　　　　　　　　　　　　　　　"},
  {"code": "0520269", "name": "後龍分行　　　　　　　　　　　　　　　　"},
  {"code": "0520270", "name": "龜山分行　　　　　　　　　　　　　　　　"},
  {"code": "0520281", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0520317", "name": "大樹林分行　　　　　　　　　　　　　　　"},
  {"code": "0520328", "name": "光復分行　　　　　　　　　　　　　　　　"},
  {"code": "0520351", "name": "龍岡分行　　　　　　　　　　　　　　　　"},
  {"code": "0520362", "name": "山子頂分行　　　　　　　　　　　　　　　"},
  {"code": "0520373", "name": "埔心分行　　　　　　　　　　　　　　　　"},
  {"code": "0520384", "name": "新豐分行　　　　　　　　　　　　　　　　"},
  {"code": "0520454", "name": "中正分行　　　　　　　　　　　　　　　　"},
  {"code": "0520476", "name": "環北分行　　　　　　　　　　　　　　　　"},
  {"code": "0520513", "name": "新興分行　　　　　　　　　　　　　　　　"},
  {"code": "0520524", "name": "新社分行　　　　　　　　　　　　　　　　"},
  {"code": "0520546", "name": "科學園區分行　　　　　　　　　　　　　　"},
  {"code": "0520579", "name": "北新竹分行　　　　　　　　　　　　　　　"},
  {"code": "0520591", "name": "平鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "0520649", "name": "東內壢分行　　　　　　　　　　　　　　　"},
  {"code": "0520672", "name": "一０一分行　　　　　　　　　　　　　　　"},
  {"code": "0520683", "name": "公西分行　　　　　　　　　　　　　　　　"},
  {"code": "0520708", "name": "莊敬分行　　　　　　　　　　　　　　　　"},
  {"code": "0520719", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0520731", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "0520742", "name": "文心分行　　　　　　　　　　　　　　　　"},
  {"code": "0520753", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0520764", "name": "九如分行　　　　　　　　　　　　　　　　"},
  {"code": "0520775", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0520797", "name": "南屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0520812", "name": "東寧分行　　　　　　　　　　　　　　　　"},
  {"code": "0520823", "name": "東海分行　　　　　　　　　　　　　　　　"},
  {"code": "0520878", "name": "北屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0520889", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0520926", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "0520959", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0520960", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0520971", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0520982", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0521015", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "0521037", "name": "中清分行　　　　　　　　　　　　　　　　"},
  {"code": "0521060", "name": "三多分行　　　　　　　　　　　　　　　　"},
  {"code": "0521071", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "0521093", "name": "南京分行　　　　　　　　　　　　　　　　"},
  {"code": "0521118", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "0521129", "name": "東台北分行　　　　　　　　　　　　　　　"},
  {"code": "0521141", "name": "敦化分行　　　　　　　　　　　　　　　　"},
  {"code": "0521152", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "0521163", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0521185", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "0521196", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "0521200", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "0521211", "name": "金山分行　　　　　　　　　　　　　　　　"}
  ],
  "053": [
  {"code": "0530019", "name": "中正分行　　　　　　　　　　　　　　　　"},
  {"code": "0530020", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0530042", "name": "南台中分行　　　　　　　　　　　　　　　"},
  {"code": "0530053", "name": "霧峰分行　　　　　　　　　　　　　　　　"},
  {"code": "0530064", "name": "大甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0530075", "name": "沙鹿分行　　　　　　　　　　　　　　　　"},
  {"code": "0530086", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "0530097", "name": "東勢分行　　　　　　　　　　　　　　　　"},
  {"code": "0530101", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "0530112", "name": "溪湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0530123", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "0530134", "name": "田中分行　　　　　　　　　　　　　　　　"},
  {"code": "0530145", "name": "北斗分行　　　　　　　　　　　　　　　　"},
  {"code": "0530156", "name": "二林分行　　　　　　　　　　　　　　　　"},
  {"code": "0530167", "name": "南投分行　　　　　　　　　　　　　　　　"},
  {"code": "0530189", "name": "草屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0530190", "name": "竹山分行　　　　　　　　　　　　　　　　"},
  {"code": "0530204", "name": "埔里分行　　　　　　　　　　　　　　　　"},
  {"code": "0530215", "name": "鹿港分行　　　　　　　　　　　　　　　　"},
  {"code": "0530226", "name": "西台中分行　　　　　　　　　　　　　　　"},
  {"code": "0530237", "name": "清水分行　　　　　　　　　　　　　　　　"},
  {"code": "0530248", "name": "東豐原分行　　　　　　　　　　　　　　　"},
  {"code": "0530259", "name": "烏日分行　　　　　　　　　　　　　　　　"},
  {"code": "0530271", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "0530318", "name": "和美分行　　　　　　　　　　　　　　　　"},
  {"code": "0530330", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0530341", "name": "太平分行　　　　　　　　　　　　　　　　"},
  {"code": "0530363", "name": "大雅分行　　　　　　　　　　　　　　　　"},
  {"code": "0530374", "name": "后里分行　　　　　　　　　　　　　　　　"},
  {"code": "0530385", "name": "潭子分行　　　　　　　　　　　　　　　　"},
  {"code": "0530396", "name": "社頭分行　　　　　　　　　　　　　　　　"},
  {"code": "0530400", "name": "永靖分行　　　　　　　　　　　　　　　　"},
  {"code": "0530411", "name": "花壇分行　　　　　　　　　　　　　　　　"},
  {"code": "0530422", "name": "秀水分行　　　　　　　　　　　　　　　　"},
  {"code": "0530444", "name": "南屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0530455", "name": "大肚分行　　　　　　　　　　　　　　　　"},
  {"code": "0530466", "name": "神岡分行　　　　　　　　　　　　　　　　"},
  {"code": "0530477", "name": "內新分行　　　　　　　　　　　　　　　　"},
  {"code": "0530488", "name": "伸港分行　　　　　　　　　　　　　　　　"},
  {"code": "0530499", "name": "北太平分行　　　　　　　　　　　　　　　"},
  {"code": "0530503", "name": "台中港分行　　　　　　　　　　　　　　　"},
  {"code": "0530514", "name": "北員林分行　　　　　　　　　　　　　　　"},
  {"code": "0530525", "name": "南陽分行　　　　　　　　　　　　　　　　"},
  {"code": "0530536", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "0530570", "name": "埤頭分行　　　　　　　　　　　　　　　　"},
  {"code": "0530581", "name": "四民分行　　　　　　　　　　　　　　　　"},
  {"code": "0530592", "name": "軍功分行　　　　　　　　　　　　　　　　"},
  {"code": "0530639", "name": "北屯分行　　　　　　　　　　　　　　　　"},
  {"code": "0530662", "name": "埔心分行　　　　　　　　　　　　　　　　"},
  {"code": "0530684", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "0530710", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "0530721", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "0530732", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0530754", "name": "龍井分行　　　　　　　　　　　　　　　　"},
  {"code": "0530776", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "0530787", "name": "虎尾分行　　　　　　　　　　　　　　　　"},
  {"code": "0530798", "name": "苑裡分行　　　　　　　　　　　　　　　　"},
  {"code": "0530813", "name": "斗南分行　　　　　　　　　　　　　　　　"},
  {"code": "0530824", "name": "竹南分行　　　　　　　　　　　　　　　　"},
  {"code": "0530846", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0530857", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "0530868", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0530880", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "0530891", "name": "民雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0530905", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0530916", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "0530927", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "0530938", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0530949", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0530950", "name": "內壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0530961", "name": "新豐分行　　　　　　　　　　　　　　　　"},
  {"code": "0530972", "name": "大園分行　　　　　　　　　　　　　　　　"},
  {"code": "0530983", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0531005", "name": "楊梅分行　　　　　　　　　　　　　　　　"},
  {"code": "0531016", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "0531038", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "0531050", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "0531061", "name": "大同分行　　　　　　　　　　　　　　　　"},
  {"code": "0531072", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0531083", "name": "新港分行　　　　　　　　　　　　　　　　"},
  {"code": "0531094", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "0531108", "name": "燕巢分行　　　　　　　　　　　　　　　　"}
  ],
  "054": [
  {"code": "0540010", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "0540032", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0540043", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "0540054", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "0540065", "name": "鹽水分行　　　　　　　　　　　　　　　　"},
  {"code": "0540076", "name": "虎尾分行　　　　　　　　　　　　　　　　"},
  {"code": "0540087", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "0540098", "name": "民雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0540102", "name": "北港分行　　　　　　　　　　　　　　　　"},
  {"code": "0540113", "name": "麻豆分行　　　　　　　　　　　　　　　　"},
  {"code": "0540124", "name": "朴子分行　　　　　　　　　　　　　　　　"},
  {"code": "0540135", "name": "佳里分行　　　　　　　　　　　　　　　　"},
  {"code": "0540146", "name": "梅山分行　　　　　　　　　　　　　　　　"},
  {"code": "0540157", "name": "斗南分行　　　　　　　　　　　　　　　　"},
  {"code": "0540180", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "0540227", "name": "西螺分行　　　　　　　　　　　　　　　　"},
  {"code": "0540249", "name": "善化分行　　　　　　　　　　　　　　　　"},
  {"code": "0540250", "name": "學甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0540272", "name": "開元分行　　　　　　　　　　　　　　　　"},
  {"code": "0540283", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "0540294", "name": "新市分行　　　　　　　　　　　　　　　　"},
  {"code": "0540308", "name": "仁德分行　　　　　　　　　　　　　　　　"},
  {"code": "0540319", "name": "六甲分行　　　　　　　　　　　　　　　　"},
  {"code": "0540320", "name": "安南分行　　　　　　　　　　　　　　　　"},
  {"code": "0540331", "name": "中埔分行　　　　　　　　　　　　　　　　"},
  {"code": "0540342", "name": "崙背分行　　　　　　　　　　　　　　　　"},
  {"code": "0540353", "name": "西港分行　　　　　　　　　　　　　　　　"},
  {"code": "0540364", "name": "新化分行　　　　　　　　　　　　　　　　"},
  {"code": "0540375", "name": "竹崎分行　　　　　　　　　　　　　　　　"},
  {"code": "0540397", "name": "安和分行　　　　　　　　　　　　　　　　"},
  {"code": "0540401", "name": "新興分行　　　　　　　　　　　　　　　　"},
  {"code": "0540412", "name": "中華分行　　　　　　　　　　　　　　　　"},
  {"code": "0540434", "name": "白河分行　　　　　　　　　　　　　　　　"},
  {"code": "0540445", "name": "興業分行　　　　　　　　　　　　　　　　"},
  {"code": "0540467", "name": "水上分行　　　　　　　　　　　　　　　　"},
  {"code": "0540489", "name": "府城分行　　　　　　　　　　　　　　　　"},
  {"code": "0540504", "name": "歸仁分行　　　　　　　　　　　　　　　　"},
  {"code": "0540515", "name": "鹽行分行　　　　　　　　　　　　　　　　"},
  {"code": "0540537", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "0540548", "name": "大林分行　　　　　　　　　　　　　　　　"},
  {"code": "0540607", "name": "關廟分行　　　　　　　　　　　　　　　　"},
  {"code": "0540641", "name": "太保分行　　　　　　　　　　　　　　　　"},
  {"code": "0540652", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "0540663", "name": "玉井分行　　　　　　　　　　　　　　　　"},
  {"code": "0540696", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0540700", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0540711", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0540744", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0540755", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "0540766", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "0540777", "name": "中正分行　　　　　　　　　　　　　　　　"},
  {"code": "0540788", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "0540799", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "0540814", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0540825", "name": "文心分行　　　　　　　　　　　　　　　　"},
  {"code": "0540836", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "0540847", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "0540858", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0540869", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0540870", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "0540881", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "0540892", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "0540906", "name": "楠梓分行　　　　　　　　　　　　　　　　"},
  {"code": "0540917", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "0540928", "name": "東新竹分行　　　　　　　　　　　　　　　"},
  {"code": "0540939", "name": "裕農分行　　　　　　　　　　　　　　　　"}
  ],
  "060": [
  {"code": "0600019", "name": "總公司　　　　　　　　　　　　　　　　　"}
  ],
  "061": [
  {"code": "0610010", "name": "台北總公司　　　　　　　　　　　　　　　"},
  {"code": "0610021", "name": "高雄分公司　　　　　　　　　　　　　　　"},
  {"code": "0610032", "name": "台中分公司　　　　　　　　　　　　　　　"},
  {"code": "0610043", "name": "台南分公司　　　　　　　　　　　　　　　"},
  {"code": "0610054", "name": "桃園分公司　　　　　　　　　　　　　　　"},
  {"code": "0610065", "name": "板橋分公司　　　　　　　　　　　　　　　"}
  ],
  "062": [
  {"code": "0620011", "name": "台北總公司　　　　　　　　　　　　　　　"},
  {"code": "0620022", "name": "台中分公司　　　　　　　　　　　　　　　"},
  {"code": "0620033", "name": "台南分公司　　　　　　　　　　　　　　　"},
  {"code": "0620044", "name": "高雄分公司　　　　　　　　　　　　　　　"},
  {"code": "0620055", "name": "臺北分公司　　　　　　　　　　　　　　　"},
  {"code": "0620066", "name": "桃園分公司　　　　　　　　　　　　　　　"},
  {"code": "0620077", "name": "板橋分公司　　　　　　　　　　　　　　　"},
  {"code": "0620088", "name": "中山分公司　　　　　　　　　　　　　　　"},
  {"code": "0620099", "name": "新竹分公司　　　　　　　　　　　　　　　"}
  ],
  "066": [
  {"code": "0660015", "name": "總公司　　　　　　　　　　　　　　　　　"}
  ],
  "072": [
  {"code": "0720014", "name": "台北分行　　　　　　　　　　　　　　　　"}
  ],
  "075": [
  {"code": "0750006", "name": "台北分行　　　　　　　　　　　　　　　　"}
  ],
  "076": [
  {"code": "0760018", "name": "台北分行　　　　　　　　　　　　　　　　"}
  ],
  "081": [
  {"code": "0810016", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "0810027", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0810049", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0810050", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "0810061", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "0810072", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "0810083", "name": "建國分行　　　　　　　　　　　　　　　　"},
  {"code": "0810094", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "0810108", "name": "東門分行　　　　　　　　　　　　　　　　"},
  {"code": "0810120", "name": "光復分行　　　　　　　　　　　　　　　　"},
  {"code": "0810164", "name": "新板分行　　　　　　　　　　　　　　　　"},
  {"code": "0810186", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "0810197", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "0810201", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "0810212", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "0810223", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "0810234", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "0810304", "name": "安和分行　　　　　　　　　　　　　　　　"},
  {"code": "0810315", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "0810326", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "0810337", "name": "敦北分行　　　　　　　　　　　　　　　　"},
  {"code": "0810360", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "0810382", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "0810511", "name": "國美分行　　　　　　　　　　　　　　　　"},
  {"code": "0810522", "name": "敦南分行　　　　　　　　　　　　　　　　"},
  {"code": "0810533", "name": "大興分行　　　　　　　　　　　　　　　　"},
  {"code": "0810566", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "0810577", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "0810588", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "0810599", "name": "崇德分行　　　　　　　　　　　　　　　　"}
  ],
  "082": [
  {"code": "0820017", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "0820039", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "0820051", "name": "台中分行　　　　　　　　　　　　　　　　"}
  ],
  "085": [
  {"code": "0850009", "name": "台北分行　　　　　　　　　　　　　　　　"}
  ],
  "086": [
  {"code": "0860011", "name": "台北分行　　　　　　　　　　　　　　　　"}
  ],
  "092": [
  {"code": "0920010", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "0920032", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "0920043", "name": "高雄分行　　　　　　　　　　　　　　　　"}
  ],
  "093": [
  {"code": "0930011", "name": "台北分行　　　　　　　　　　　　　　　　"}
  ],
  "098": [
  {"code": "0980016", "name": "台北分行　　　　　　　　　　　　　　　　"}
  ],
  "101": [
  {"code": "1010011", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1010020", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "1010039", "name": "建成分行　　　　　　　　　　　　　　　　"},
  {"code": "1010048", "name": "大橋分行　　　　　　　　　　　　　　　　"},
  {"code": "1010057", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "1010066", "name": "昆明分行　　　　　　　　　　　　　　　　"},
  {"code": "1010075", "name": "長安分行　　　　　　　　　　　　　　　　"},
  {"code": "1010084", "name": "永吉分行　　　　　　　　　　　　　　　　"},
  {"code": "1010093", "name": "和平東路分行　　　　　　　　　　　　　　"},
  {"code": "1010109", "name": "石牌分行　　　　　　　　　　　　　　　　"},
  {"code": "1010118", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "1010127", "name": "成功簡易型分行　　　　　　　　　　　　　"},
  {"code": "1010136", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "1010145", "name": "景美分行　　　　　　　　　　　　　　　　"},
  {"code": "1010154", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "1010163", "name": "信義簡易型分行　　　　　　　　　　　　　"},
  {"code": "1010172", "name": "萬華分行　　　　　　　　　　　　　　　　"},
  {"code": "1010181", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "1010190", "name": "松山簡易型分行　　　　　　　　　　　　　"},
  {"code": "1010206", "name": "城內分行　　　　　　　　　　　　　　　　"},
  {"code": "1010215", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "1010224", "name": "中和分行　　　　　　　　　　　　　　　　"}
  ],
  "102": [
  {"code": "1020010", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1020029", "name": "迪化街分行　　　　　　　　　　　　　　　"},
  {"code": "1020038", "name": "建成分行　　　　　　　　　　　　　　　　"},
  {"code": "1020047", "name": "大同分行　　　　　　　　　　　　　　　　"},
  {"code": "1020056", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "1020065", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "1020074", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "1020083", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "1020092", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "1020108", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "1020117", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "1020126", "name": "永吉分行　　　　　　　　　　　　　　　　"},
  {"code": "1020135", "name": "和平分行　　　　　　　　　　　　　　　　"},
  {"code": "1020144", "name": "光復分行　　　　　　　　　　　　　　　　"},
  {"code": "1020153", "name": "文山分行　　　　　　　　　　　　　　　　"},
  {"code": "1020171", "name": "石牌分行　　　　　　　　　　　　　　　　"},
  {"code": "1020180", "name": "萬華分行　　　　　　　　　　　　　　　　"},
  {"code": "1020199", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "1020205", "name": "松德分行　　　　　　　　　　　　　　　　"},
  {"code": "1020214", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "1020223", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "1020232", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "1020241", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "1020250", "name": "敦化分行　　　　　　　　　　　　　　　　"},
  {"code": "1020269", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "1020278", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "1020287", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "1020296", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "1020302", "name": "總部分行　　　　　　　　　　　　　　　　"},
  {"code": "1020348", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "1020357", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "1020366", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "1020375", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "1020384", "name": "北台中分行　　　　　　　　　　　　　　　"}
  ],
  "103": [
  {"code": "1030019", "name": "中正分行　　　　　　　　　　　　　　　　"},
  {"code": "1030028", "name": "東台北分行　　　　　　　　　　　　　　　"},
  {"code": "1030037", "name": "龍山分行　　　　　　　　　　　　　　　　"},
  {"code": "1030046", "name": "西園分行　　　　　　　　　　　　　　　　"},
  {"code": "1030055", "name": "西門分行　　　　　　　　　　　　　　　　"},
  {"code": "1030064", "name": "大同分行　　　　　　　　　　　　　　　　"},
  {"code": "1030073", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "1030082", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "1030091", "name": "五常分行　　　　　　　　　　　　　　　　"},
  {"code": "1030107", "name": "城北分行　　　　　　　　　　　　　　　　"},
  {"code": "1030116", "name": "城內分行　　　　　　　　　　　　　　　　"},
  {"code": "1030125", "name": "館前簡易型分行　　　　　　　　　　　　　"},
  {"code": "1030134", "name": "新金湖分行　　　　　　　　　　　　　　　"},
  {"code": "1030143", "name": "慶城分行　　　　　　　　　　　　　　　　"},
  {"code": "1030152", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "1030161", "name": "世貿分行　　　　　　　　　　　　　　　　"},
  {"code": "1030170", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "1030189", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "1030198", "name": "林森北路分行　　　　　　　　　　　　　　"},
  {"code": "1030204", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "1030213", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "1030222", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "1030231", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "1030240", "name": "東三重分行　　　　　　　　　　　　　　　"},
  {"code": "1030259", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "1030268", "name": "連城路分行　　　　　　　　　　　　　　　"},
  {"code": "1030277", "name": "竹科分行　　　　　　　　　　　　　　　　"},
  {"code": "1030286", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "1030295", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "1030301", "name": "建成分行　　　　　　　　　　　　　　　　"},
  {"code": "1030310", "name": "北三重分行　　　　　　　　　　　　　　　"},
  {"code": "1030329", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "1030338", "name": "新埔分行　　　　　　　　　　　　　　　　"},
  {"code": "1030347", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "1030356", "name": "中港分行　　　　　　　　　　　　　　　　"},
  {"code": "1030365", "name": "左營華夏路分行　　　　　　　　　　　　　"},
  {"code": "1030374", "name": "大甲分行　　　　　　　　　　　　　　　　"},
  {"code": "1030383", "name": "大墩分行　　　　　　　　　　　　　　　　"},
  {"code": "1030392", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "1030408", "name": "南屯分行　　　　　　　　　　　　　　　　"},
  {"code": "1030417", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "1030426", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "1030435", "name": "松竹分行　　　　　　　　　　　　　　　　"},
  {"code": "1030444", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "1030453", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "1030462", "name": "新板分行　　　　　　　　　　　　　　　　"},
  {"code": "1030471", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "1030480", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "1030499", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1030505", "name": "丹鳳分行　　　　　　　　　　　　　　　　"},
  {"code": "1030514", "name": "北投復興崗分行　　　　　　　　　　　　　"},
  {"code": "1030523", "name": "新生南路分行　　　　　　　　　　　　　　"},
  {"code": "1030541", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "1030550", "name": "天母簡易型分行　　　　　　　　　　　　　"},
  {"code": "1030569", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "1030578", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "1030587", "name": "興隆簡易型分行　　　　　　　　　　　　　"},
  {"code": "1030596", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "1030611", "name": "長安分行　　　　　　　　　　　　　　　　"},
  {"code": "1030620", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "1030648", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "1030657", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "1030666", "name": "北嘉義分行　　　　　　　　　　　　　　　"},
  {"code": "1030675", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "1030684", "name": "竹南分行　　　　　　　　　　　　　　　　"},
  {"code": "1030693", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "1030709", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "1030718", "name": "宜蘭分行　　　　　　　　　　　　　　　　"},
  {"code": "1030727", "name": "三峽分行　　　　　　　　　　　　　　　　"},
  {"code": "1030736", "name": "路竹分行　　　　　　　　　　　　　　　　"},
  {"code": "1030745", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "1030754", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "1030763", "name": "江子翠分行　　　　　　　　　　　　　　　"},
  {"code": "1030772", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "1030781", "name": "彌陀簡易型分行　　　　　　　　　　　　　"},
  {"code": "1030790", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "1030806", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "1030824", "name": "小港分行　　　　　　　　　　　　　　　　"},
  {"code": "1030833", "name": "中華分行　　　　　　　　　　　　　　　　"},
  {"code": "1030842", "name": "承德分行　　　　　　　　　　　　　　　　"},
  {"code": "1030851", "name": "敦南分行　　　　　　　　　　　　　　　　"},
  {"code": "1030860", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "1030879", "name": "南台中分行　　　　　　　　　　　　　　　"},
  {"code": "1030888", "name": "水湳分行　　　　　　　　　　　　　　　　"},
  {"code": "1030897", "name": "北屯分行　　　　　　　　　　　　　　　　"},
  {"code": "1030903", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "1030912", "name": "向上分行　　　　　　　　　　　　　　　　"},
  {"code": "1030921", "name": "十甲分行　　　　　　　　　　　　　　　　"},
  {"code": "1030930", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "1030949", "name": "永安分行　　　　　　　　　　　　　　　　"},
  {"code": "1030958", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "1030967", "name": "東園分行　　　　　　　　　　　　　　　　"},
  {"code": "1030976", "name": "萬丹分行　　　　　　　　　　　　　　　　"},
  {"code": "1030985", "name": "七賢分行　　　　　　　　　　　　　　　　"},
  {"code": "1031003", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "1031012", "name": "桃北分行　　　　　　　　　　　　　　　　"},
  {"code": "1031021", "name": "東新竹分行　　　　　　　　　　　　　　　"},
  {"code": "1031030", "name": "九如分行　　　　　　　　　　　　　　　　"},
  {"code": "1031049", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "1031058", "name": "壢新分行　　　　　　　　　　　　　　　　"},
  {"code": "1031067", "name": "沙鹿分行　　　　　　　　　　　　　　　　"},
  {"code": "1031076", "name": "大雅分行　　　　　　　　　　　　　　　　"},
  {"code": "1031094", "name": "草屯分行　　　　　　　　　　　　　　　　"},
  {"code": "1031100", "name": "南東分行　　　　　　　　　　　　　　　　"}
  ],
  "104": [
  {"code": "1040018", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1040027", "name": "吉林分社　　　　　　　　　　　　　　　　"},
  {"code": "1040036", "name": "大同分社　　　　　　　　　　　　　　　　"},
  {"code": "1040045", "name": "中山分社　　　　　　　　　　　　　　　　"},
  {"code": "1040054", "name": "松山分社　　　　　　　　　　　　　　　　"},
  {"code": "1040063", "name": "大安分社　　　　　　　　　　　　　　　　"},
  {"code": "1040072", "name": "石牌分社　　　　　　　　　　　　　　　　"},
  {"code": "1040081", "name": "南港分社　　　　　　　　　　　　　　　　"},
  {"code": "1040090", "name": "文山分社　　　　　　　　　　　　　　　　"},
  {"code": "1040106", "name": "中正分社　　　　　　　　　　　　　　　　"},
  {"code": "1040115", "name": "北投分社　　　　　　　　　　　　　　　　"},
  {"code": "1040124", "name": "內湖分社　　　　　　　　　　　　　　　　"},
  {"code": "1040133", "name": "天母分社　　　　　　　　　　　　　　　　"}
  ],
  "108": [
  {"code": "1080014", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1080023", "name": "石牌分行　　　　　　　　　　　　　　　　"},
  {"code": "1080032", "name": "北投分行　　　　　　　　　　　　　　　　"},
  {"code": "1080041", "name": "社子分行　　　　　　　　　　　　　　　　"},
  {"code": "1080050", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "1080069", "name": "大屯分行　　　　　　　　　　　　　　　　"},
  {"code": "1080078", "name": "劍潭分行　　　　　　　　　　　　　　　　"},
  {"code": "1080087", "name": "蘭雅分行　　　　　　　　　　　　　　　　"},
  {"code": "1080096", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "1080102", "name": "社中分行　　　　　　　　　　　　　　　　"},
  {"code": "1080111", "name": "吉林分行　　　　　　　　　　　　　　　　"},
  {"code": "1080120", "name": "成功分行　　　　　　　　　　　　　　　　"},
  {"code": "1080139", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "1080148", "name": "延吉分行　　　　　　　　　　　　　　　　"},
  {"code": "1080157", "name": "木柵分行　　　　　　　　　　　　　　　　"},
  {"code": "1080166", "name": "龍江分行　　　　　　　　　　　　　　　　"},
  {"code": "1080175", "name": "南京分行　　　　　　　　　　　　　　　　"},
  {"code": "1080184", "name": "景美分行　　　　　　　　　　　　　　　　"},
  {"code": "1080193", "name": "中興分行　　　　　　　　　　　　　　　　"},
  {"code": "1080209", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "1080218", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "1080227", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "1080236", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "1080245", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "1080263", "name": "新和分行　　　　　　　　　　　　　　　　"},
  {"code": "1080272", "name": "溪洲分行　　　　　　　　　　　　　　　　"},
  {"code": "1080281", "name": "泰山分行　　　　　　　　　　　　　　　　"},
  {"code": "1080290", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "1080306", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "1080315", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "1080324", "name": "大業分行　　　　　　　　　　　　　　　　"},
  {"code": "1080333", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "1080342", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "1080351", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "1080360", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "1080379", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "1080397", "name": "新福分行　　　　　　　　　　　　　　　　"},
  {"code": "1080403", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "1080412", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "1080421", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "1080430", "name": "精武分行　　　　　　　　　　　　　　　　"},
  {"code": "1080449", "name": "社頭分行　　　　　　　　　　　　　　　　"},
  {"code": "1080458", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "1080467", "name": "和平分行　　　　　　　　　　　　　　　　"},
  {"code": "1080476", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "1080485", "name": "大同分行　　　　　　　　　　　　　　　　"},
  {"code": "1080494", "name": "北屯分行　　　　　　　　　　　　　　　　"},
  {"code": "1080500", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "1080519", "name": "新埔分行　　　　　　　　　　　　　　　　"},
  {"code": "1080528", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "1080555", "name": "東寧分行　　　　　　　　　　　　　　　　"},
  {"code": "1080564", "name": "中華分行　　　　　　　　　　　　　　　　"},
  {"code": "1080573", "name": "健康分行　　　　　　　　　　　　　　　　"},
  {"code": "1080582", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "1080607", "name": "西華分行　　　　　　　　　　　　　　　　"},
  {"code": "1080616", "name": "安順分行　　　　　　　　　　　　　　　　"},
  {"code": "1080634", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "1080643", "name": "向上分行　　　　　　　　　　　　　　　　"},
  {"code": "1080652", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "1080661", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "1080670", "name": "五股分行　　　　　　　　　　　　　　　　"},
  {"code": "1080689", "name": "林森分行　　　　　　　　　　　　　　　　"},
  {"code": "1080698", "name": "立文分行　　　　　　　　　　　　　　　　"},
  {"code": "1080704", "name": "新興分行　　　　　　　　　　　　　　　　"},
  {"code": "1080713", "name": "青年分行　　　　　　　　　　　　　　　　"},
  {"code": "1080722", "name": "三鳳分行　　　　　　　　　　　　　　　　"},
  {"code": "1080731", "name": "四維分行　　　　　　　　　　　　　　　　"},
  {"code": "1080740", "name": "大公分行　　　　　　　　　　　　　　　　"},
  {"code": "1080759", "name": "大順分行　　　　　　　　　　　　　　　　"},
  {"code": "1080768", "name": "海光分行　　　　　　　　　　　　　　　　"},
  {"code": "1080777", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "1080786", "name": "平等分行　　　　　　　　　　　　　　　　"},
  {"code": "1080795", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "1080801", "name": "小港分行　　　　　　　　　　　　　　　　"},
  {"code": "1080810", "name": "右昌分行　　　　　　　　　　　　　　　　"},
  {"code": "1080829", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "1080838", "name": "五甲分行　　　　　　　　　　　　　　　　"},
  {"code": "1080847", "name": "鼎力分行　　　　　　　　　　　　　　　　"},
  {"code": "1080856", "name": "楠梓分行　　　　　　　　　　　　　　　　"},
  {"code": "1080865", "name": "旗山分行　　　　　　　　　　　　　　　　"},
  {"code": "1080874", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "1080883", "name": "南桃園分行　　　　　　　　　　　　　　　"},
  {"code": "1080917", "name": "林園簡易型分行　　　　　　　　　　　　　"},
  {"code": "1080926", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "1080935", "name": "仁德分行　　　　　　　　　　　　　　　　"},
  {"code": "1080944", "name": "東桃園分行　　　　　　　　　　　　　　　"},
  {"code": "1080953", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "1080971", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "1080980", "name": "里港簡易型分行　　　　　　　　　　　　　"},
  {"code": "1080999", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "1081017", "name": "萬華分行　　　　　　　　　　　　　　　　"},
  {"code": "1081026", "name": "臺北分行　　　　　　　　　　　　　　　　"},
  {"code": "1081035", "name": "長安分行　　　　　　　　　　　　　　　　"},
  {"code": "1081053", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "1081062", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "1081071", "name": "重新分行　　　　　　　　　　　　　　　　"},
  {"code": "1081080", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "1081336", "name": "苗栗分行　　　　　　　　　　　　　　　　"},
  {"code": "1081354", "name": "龍井分行　　　　　　　　　　　　　　　　"},
  {"code": "1081363", "name": "雲林分行　　　　　　　　　　　　　　　　"},
  {"code": "1081372", "name": "南投分行　　　　　　　　　　　　　　　　"},
  {"code": "1081503", "name": "臺東分行　　　　　　　　　　　　　　　　"},
  {"code": "1081512", "name": "宜蘭分行　　　　　　　　　　　　　　　　"},
  {"code": "1081567", "name": "林口分行　　　　　　　　　　　　　　　　"}
  ],
  "114": [
  {"code": "1140015", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1140024", "name": "仁一路分社　　　　　　　　　　　　　　　"},
  {"code": "1140033", "name": "愛三路分社　　　　　　　　　　　　　　　"},
  {"code": "1140042", "name": "忠二路分社　　　　　　　　　　　　　　　"},
  {"code": "1140051", "name": "安一路分社　　　　　　　　　　　　　　　"},
  {"code": "1140060", "name": "信二路分社　　　　　　　　　　　　　　　"},
  {"code": "1140079", "name": "中華路分社　　　　　　　　　　　　　　　"},
  {"code": "1140088", "name": "八斗子分社　　　　　　　　　　　　　　　"},
  {"code": "1140097", "name": "南興路分社　　　　　　　　　　　　　　　"},
  {"code": "1140103", "name": "大武崙分社　　　　　　　　　　　　　　　"},
  {"code": "1140112", "name": "碇內分社　　　　　　　　　　　　　　　　"},
  {"code": "1140121", "name": "仁二路分社　　　　　　　　　　　　　　　"},
  {"code": "1140130", "name": "百福分社　　　　　　　　　　　　　　　　"},
  {"code": "1140149", "name": "松山分社　　　　　　　　　　　　　　　　"},
  {"code": "1140158", "name": "永春分社　　　　　　　　　　　　　　　　"}
  ],
  "115": [
  {"code": "1150014", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1150023", "name": "廟口分社　　　　　　　　　　　　　　　　"},
  {"code": "1150032", "name": "中正區分社　　　　　　　　　　　　　　　"},
  {"code": "1150041", "name": "新店分社（元大證券收付處）　　　　　　　"},
  {"code": "1150050", "name": "七堵分社　　　　　　　　　　　　　　　　"},
  {"code": "1150069", "name": "安樂分社　　　　　　　　　　　　　　　　"},
  {"code": "1150078", "name": "信義分社　　　　　　　　　　　　　　　　"},
  {"code": "1150087", "name": "港東分社　　　　　　　　　　　　　　　　"},
  {"code": "1150096", "name": "暖暖分社　　　　　　　　　　　　　　　　"},
  {"code": "1150102", "name": "安和分社　　　　　　　　　　　　　　　　"},
  {"code": "1150111", "name": "臺北分社　　　　　　　　　　　　　　　　"},
  {"code": "1150120", "name": "百福分社　　　　　　　　　　　　　　　　"},
  {"code": "1150139", "name": "基金分社　　　　　　　　　　　　　　　　"},
  {"code": "1150148", "name": "新豐分社　　　　　　　　　　　　　　　　"},
  {"code": "1150157", "name": "復興分社　　　　　　　　　　　　　　　　"}
  ],
  "118": [
  {"code": "1180011", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "1180020", "name": "後埔分行　　　　　　　　　　　　　　　　"},
  {"code": "1180039", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "1180048", "name": "埔墘分行　　　　　　　　　　　　　　　　"},
  {"code": "1180057", "name": "華江分行　　　　　　　　　　　　　　　　"},
  {"code": "1180066", "name": "民族分行　　　　　　　　　　　　　　　　"},
  {"code": "1180075", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "1180084", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "1180093", "name": "文化分行　　　　　　　　　　　　　　　　"},
  {"code": "1180109", "name": "大觀分行　　　　　　　　　　　　　　　　"},
  {"code": "1180118", "name": "興南分行　　　　　　　　　　　　　　　　"},
  {"code": "1180145", "name": "小港分行　　　　　　　　　　　　　　　　"},
  {"code": "1180163", "name": "新興分行　　　　　　　　　　　　　　　　"},
  {"code": "1180181", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "1180206", "name": "陽明分行　　　　　　　　　　　　　　　　"},
  {"code": "1180215", "name": "高新莊分行　　　　　　　　　　　　　　　"},
  {"code": "1180260", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "1180279", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "1180288", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "1180297", "name": "秀朗分行　　　　　　　　　　　　　　　　"},
  {"code": "1180303", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "1180312", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "1180330", "name": "員山分行　　　　　　　　　　　　　　　　"},
  {"code": "1180349", "name": "桃鶯分行　　　　　　　　　　　　　　　　"},
  {"code": "1180358", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "1180367", "name": "龍岡分行　　　　　　　　　　　　　　　　"},
  {"code": "1180385", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "1180394", "name": "金城分行　　　　　　　　　　　　　　　　"},
  {"code": "1180400", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "1180419", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "1180428", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "1180437", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "1180446", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "1180455", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "1180482", "name": "中正分行　　　　　　　　　　　　　　　　"},
  {"code": "1180507", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "1180598", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "1180604", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "1180613", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "1180622", "name": "成功分行　　　　　　　　　　　　　　　　"},
  {"code": "1180631", "name": "福和分行　　　　　　　　　　　　　　　　"},
  {"code": "1180659", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1180668", "name": "瑞光分行　　　　　　　　　　　　　　　　"},
  {"code": "1180677", "name": "丹鳳分行　　　　　　　　　　　　　　　　"},
  {"code": "1180686", "name": "北新分行　　　　　　　　　　　　　　　　"},
  {"code": "1180695", "name": "艋舺分行　　　　　　　　　　　　　　　　"},
  {"code": "1180701", "name": "興隆分行　　　　　　　　　　　　　　　　"},
  {"code": "1180710", "name": "雙園分行　　　　　　　　　　　　　　　　"},
  {"code": "1180729", "name": "西門分行　　　　　　　　　　　　　　　　"},
  {"code": "1180738", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "1180747", "name": "安東分行　　　　　　　　　　　　　　　　"},
  {"code": "1180756", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "1180765", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "1180774", "name": "東湖分行　　　　　　　　　　　　　　　　"},
  {"code": "1180792", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "1180808", "name": "民權分行　　　　　　　　　　　　　　　　"},
  {"code": "1180817", "name": "重慶分行　　　　　　　　　　　　　　　　"},
  {"code": "1180826", "name": "木柵分行　　　　　　　　　　　　　　　　"},
  {"code": "1180844", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "1180853", "name": "萬大分行　　　　　　　　　　　　　　　　"},
  {"code": "1180880", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "1180899", "name": "北桃園分行　　　　　　　　　　　　　　　"},
  {"code": "1180905", "name": "環東分行　　　　　　　　　　　　　　　　"},
  {"code": "1180914", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "1180923", "name": "燕巢分行　　　　　　　　　　　　　　　　"},
  {"code": "1180932", "name": "苗栗分行　　　　　　　　　　　　　　　　"}
  ],
  "119": [
  {"code": "1190010", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1190029", "name": "三重分社　　　　　　　　　　　　　　　　"},
  {"code": "1190038", "name": "三芝分社　　　　　　　　　　　　　　　　"},
  {"code": "1190047", "name": "八里分社　　　　　　　　　　　　　　　　"},
  {"code": "1190056", "name": "石門分社　　　　　　　　　　　　　　　　"},
  {"code": "1190065", "name": "竹圍分社　　　　　　　　　　　　　　　　"},
  {"code": "1190074", "name": "水碓分社　　　　　　　　　　　　　　　　"},
  {"code": "1190083", "name": "英專分社　　　　　　　　　　　　　　　　"},
  {"code": "1190092", "name": "新市分社　　　　　　　　　　　　　　　　"},
  {"code": "1190108", "name": "龍形分社　　　　　　　　　　　　　　　　"},
  {"code": "1190117", "name": "金山分社　　　　　　　　　　　　　　　　"},
  {"code": "1190126", "name": "萬里分社　　　　　　　　　　　　　　　　"},
  {"code": "1190135", "name": "板橋分社　　　　　　　　　　　　　　　　"},
  {"code": "1190153", "name": "林口分社　　　　　　　　　　　　　　　　"},
  {"code": "1190162", "name": "中和分社　　　　　　　　　　　　　　　　"},
  {"code": "1190180", "name": "北投分社　　　　　　　　　　　　　　　　"},
  {"code": "1190199", "name": "新莊分社　　　　　　　　　　　　　　　　"}
  ],
  "120": [
  {"code": "1200016", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1200025", "name": "水碓分社　　　　　　　　　　　　　　　　"},
  {"code": "1200034", "name": "竹圍分社　　　　　　　　　　　　　　　　"},
  {"code": "1200043", "name": "英專分社　　　　　　　　　　　　　　　　"},
  {"code": "1200052", "name": "義山分社　　　　　　　　　　　　　　　　"},
  {"code": "1200061", "name": "三芝分社　　　　　　　　　　　　　　　　"},
  {"code": "1200070", "name": "八里分社　　　　　　　　　　　　　　　　"},
  {"code": "1200089", "name": "成州分社　　　　　　　　　　　　　　　　"},
  {"code": "1200098", "name": "五股分社　　　　　　　　　　　　　　　　"},
  {"code": "1200104", "name": "萬金分社　　　　　　　　　　　　　　　　"},
  {"code": "1200113", "name": "新莊分社　　　　　　　　　　　　　　　　"},
  {"code": "1200122", "name": "泰山分社　　　　　　　　　　　　　　　　"},
  {"code": "1200131", "name": "林口分社　　　　　　　　　　　　　　　　"},
  {"code": "1200140", "name": "板橋分社　　　　　　　　　　　　　　　　"},
  {"code": "1200159", "name": "蘆洲分社　　　　　　　　　　　　　　　　"},
  {"code": "1200168", "name": "三重分社　　　　　　　　　　　　　　　　"}
  ],
  "124": [
  {"code": "1240012", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1240021", "name": "復興分社　　　　　　　　　　　　　　　　"},
  {"code": "1240030", "name": "東門分社　　　　　　　　　　　　　　　　"},
  {"code": "1240058", "name": "頭城分社　　　　　　　　　　　　　　　　"},
  {"code": "1240067", "name": "礁溪分社　　　　　　　　　　　　　　　　"},
  {"code": "1240076", "name": "冬山分社　　　　　　　　　　　　　　　　"},
  {"code": "1240085", "name": "三星分社　　　　　　　　　　　　　　　　"},
  {"code": "1240094", "name": "壯圍分社　　　　　　　　　　　　　　　　"},
  {"code": "1240100", "name": "羅東分社　　　　　　　　　　　　　　　　"},
  {"code": "1240119", "name": "蘇澳分社　　　　　　　　　　　　　　　　"}
  ],
  "127": [
  {"code": "1270019", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1270028", "name": "大林分社　　　　　　　　　　　　　　　　"},
  {"code": "1270037", "name": "永興分社　　　　　　　　　　　　　　　　"},
  {"code": "1270046", "name": "南華分社　　　　　　　　　　　　　　　　"},
  {"code": "1270055", "name": "介壽分社　　　　　　　　　　　　　　　　"},
  {"code": "1270064", "name": "中山分社　　　　　　　　　　　　　　　　"},
  {"code": "1270073", "name": "永安分社　　　　　　　　　　　　　　　　"},
  {"code": "1270082", "name": "會稽分社　　　　　　　　　　　　　　　　"},
  {"code": "1270091", "name": "莊敬分社　　　　　　　　　　　　　　　　"},
  {"code": "1270107", "name": "大湳分社　　　　　　　　　　　　　　　　"},
  {"code": "1270116", "name": "南崁分社　　　　　　　　　　　　　　　　"}
  ],
  "130": [
  {"code": "1300013", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1300022", "name": "城中分社　　　　　　　　　　　　　　　　"},
  {"code": "1300031", "name": "武昌分社　　　　　　　　　　　　　　　　"},
  {"code": "1300040", "name": "新社分社　　　　　　　　　　　　　　　　"},
  {"code": "1300059", "name": "竹北分社　　　　　　　　　　　　　　　　"},
  {"code": "1300068", "name": "三民分社　　　　　　　　　　　　　　　　"},
  {"code": "1300077", "name": "香山分社　　　　　　　　　　　　　　　　"},
  {"code": "1300086", "name": "東南分社　　　　　　　　　　　　　　　　"},
  {"code": "1300095", "name": "光復分社　　　　　　　　　　　　　　　　"},
  {"code": "1300101", "name": "南寮分社　　　　　　　　　　　　　　　　"},
  {"code": "1300110", "name": "南香山分社　　　　　　　　　　　　　　　"},
  {"code": "1300129", "name": "武陵分社　　　　　　　　　　　　　　　　"},
  {"code": "1300138", "name": "延平分社　　　　　　　　　　　　　　　　"},
  {"code": "1300147", "name": "建功分社　　　　　　　　　　　　　　　　"},
  {"code": "1300156", "name": "芎林分社　　　　　　　　　　　　　　　　"},
  {"code": "1300165", "name": "寶山分社　　　　　　　　　　　　　　　　"},
  {"code": "1300174", "name": "平鎮分社　　　　　　　　　　　　　　　　"},
  {"code": "1300183", "name": "楊梅分社　　　　　　　　　　　　　　　　"},
  {"code": "1300192", "name": "八德分社　　　　　　　　　　　　　　　　"},
  {"code": "1300208", "name": "中壢分社　　　　　　　　　　　　　　　　"}
  ],
  "132": [
  {"code": "1320011", "name": "市中分社　　　　　　　　　　　　　　　　"},
  {"code": "1320020", "name": "民生分社　　　　　　　　　　　　　　　　"},
  {"code": "1320039", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1320048", "name": "中正分社　　　　　　　　　　　　　　　　"},
  {"code": "1320057", "name": "東南分社　　　　　　　　　　　　　　　　"},
  {"code": "1320066", "name": "西門分社　　　　　　　　　　　　　　　　"},
  {"code": "1320075", "name": "東光分社　　　　　　　　　　　　　　　　"},
  {"code": "1320084", "name": "香山分社　　　　　　　　　　　　　　　　"},
  {"code": "1320093", "name": "竹南分社　　　　　　　　　　　　　　　　"},
  {"code": "1320109", "name": "延平分社　　　　　　　　　　　　　　　　"},
  {"code": "1320118", "name": "光華分社　　　　　　　　　　　　　　　　"},
  {"code": "1320127", "name": "新豐分社　　　　　　　　　　　　　　　　"},
  {"code": "1320136", "name": "竹北分社　　　　　　　　　　　　　　　　"},
  {"code": "1320145", "name": "六家簡易型分社　　　　　　　　　　　　　"},
  {"code": "1320154", "name": "頭份分社　　　　　　　　　　　　　　　　"}
  ],
  "146": [
  {"code": "1460014", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1460023", "name": "文昌分社　　　　　　　　　　　　　　　　"},
  {"code": "1460032", "name": "南屯分社　　　　　　　　　　　　　　　　"},
  {"code": "1460041", "name": "五權分社　　　　　　　　　　　　　　　　"},
  {"code": "1460050", "name": "東南分社　　　　　　　　　　　　　　　　"},
  {"code": "1460069", "name": "大智分社　　　　　　　　　　　　　　　　"},
  {"code": "1460078", "name": "港路分社　　　　　　　　　　　　　　　　"},
  {"code": "1460087", "name": "精進分社　　　　　　　　　　　　　　　　"},
  {"code": "1460096", "name": "中興分社　　　　　　　　　　　　　　　　"},
  {"code": "1460102", "name": "水湳分社　　　　　　　　　　　　　　　　"},
  {"code": "1460111", "name": "中和分社　　　　　　　　　　　　　　　　"},
  {"code": "1460120", "name": "松竹分社　　　　　　　　　　　　　　　　"},
  {"code": "1460139", "name": "向上分社　　　　　　　　　　　　　　　　"},
  {"code": "1460148", "name": "大雅分社　　　　　　　　　　　　　　　　"},
  {"code": "1460157", "name": "西屯分社　　　　　　　　　　　　　　　　"},
  {"code": "1460166", "name": "太平分社　　　　　　　　　　　　　　　　"},
  {"code": "1460175", "name": "大里分社　　　　　　　　　　　　　　　　"},
  {"code": "1460184", "name": "潭子分社　　　　　　　　　　　　　　　　"},
  {"code": "1460193", "name": "文山分社　　　　　　　　　　　　　　　　"},
  {"code": "1460209", "name": "軍功分社　　　　　　　　　　　　　　　　"},
  {"code": "1460218", "name": "高工分社　　　　　　　　　　　　　　　　"},
  {"code": "1460227", "name": "敦化分社　　　　　　　　　　　　　　　　"}
  ],
  "147": [
  {"code": "1470013", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "1470022", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1470040", "name": "成功分行　　　　　　　　　　　　　　　　"},
  {"code": "1470059", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "1470068", "name": "國光分行　　　　　　　　　　　　　　　　"},
  {"code": "1470077", "name": "大智分行　　　　　　　　　　　　　　　　"},
  {"code": "1470086", "name": "林森分行　　　　　　　　　　　　　　　　"},
  {"code": "1470095", "name": "南門分行　　　　　　　　　　　　　　　　"},
  {"code": "1470101", "name": "進化分行　　　　　　　　　　　　　　　　"},
  {"code": "1470110", "name": "南屯分行　　　　　　　　　　　　　　　　"},
  {"code": "1470138", "name": "北屯分行　　　　　　　　　　　　　　　　"},
  {"code": "1470147", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "1470156", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "1470165", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "1470183", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "1470192", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "1470208", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "1470253", "name": "豐信分行　　　　　　　　　　　　　　　　"},
  {"code": "1470262", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "1470299", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "1470305", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "1470314", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "1470323", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "1470332", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "1470341", "name": "大雅分行　　　　　　　　　　　　　　　　"},
  {"code": "1470350", "name": "橋頭分行　　　　　　　　　　　　　　　　"},
  {"code": "1470369", "name": "大肚分行　　　　　　　　　　　　　　　　"},
  {"code": "1470378", "name": "龍井分行　　　　　　　　　　　　　　　　"},
  {"code": "1470387", "name": "田中分行　　　　　　　　　　　　　　　　"},
  {"code": "1470396", "name": "太平分行　　　　　　　　　　　　　　　　"}
  ],
  "158": [
  {"code": "1580019", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1580028", "name": "中華分社　　　　　　　　　　　　　　　　"},
  {"code": "1580037", "name": "曉陽分社　　　　　　　　　　　　　　　　"},
  {"code": "1580046", "name": "彰美分社　　　　　　　　　　　　　　　　"},
  {"code": "1580055", "name": "花壇分社　　　　　　　　　　　　　　　　"},
  {"code": "1580064", "name": "大竹分社　　　　　　　　　　　　　　　　"},
  {"code": "1580073", "name": "和美分社　　　　　　　　　　　　　　　　"},
  {"code": "1580082", "name": "中正分社　　　　　　　　　　　　　　　　"},
  {"code": "1580091", "name": "員林分社　　　　　　　　　　　　　　　　"}
  ],
  "161": [
  {"code": "1610013", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1610022", "name": "華山分社　　　　　　　　　　　　　　　　"},
  {"code": "1610031", "name": "彰南路分社　　　　　　　　　　　　　　　"},
  {"code": "1610040", "name": "東芳分社　　　　　　　　　　　　　　　　"},
  {"code": "1610059", "name": "旭光分社　　　　　　　　　　　　　　　　"},
  {"code": "1610068", "name": "大里分社　　　　　　　　　　　　　　　　"},
  {"code": "1610077", "name": "埔心分社　　　　　　　　　　　　　　　　"},
  {"code": "1610086", "name": "田中分社　　　　　　　　　　　　　　　　"},
  {"code": "1610095", "name": "芬園分社　　　　　　　　　　　　　　　　"}
  ],
  "162": [
  {"code": "1620012", "name": "車路口分社　　　　　　　　　　　　　　　"},
  {"code": "1620021", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1620030", "name": "觀音亭口分社　　　　　　　　　　　　　　"},
  {"code": "1620049", "name": "華陽分社　　　　　　　　　　　　　　　　"},
  {"code": "1620058", "name": "和美分社　　　　　　　　　　　　　　　　"},
  {"code": "1620067", "name": "花壇分社　　　　　　　　　　　　　　　　"},
  {"code": "1620076", "name": "曉陽分社　　　　　　　　　　　　　　　　"},
  {"code": "1620085", "name": "伸港分社　　　　　　　　　　　　　　　　"},
  {"code": "1620094", "name": "秀水分社　　　　　　　　　　　　　　　　"},
  {"code": "1620100", "name": "福興分社　　　　　　　　　　　　　　　　"},
  {"code": "1620119", "name": "永靖分社　　　　　　　　　　　　　　　　"},
  {"code": "1620128", "name": "埔心分社　　　　　　　　　　　　　　　　"},
  {"code": "1620137", "name": "員林分社　　　　　　　　　　　　　　　　"},
  {"code": "1620146", "name": "東興分社　　　　　　　　　　　　　　　　"}
  ],
  "163": [
  {"code": "1630011", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1630020", "name": "華山分社　　　　　　　　　　　　　　　　"},
  {"code": "1630039", "name": "三民分社　　　　　　　　　　　　　　　　"},
  {"code": "1630048", "name": "中華分社　　　　　　　　　　　　　　　　"},
  {"code": "1630057", "name": "大竹分社　　　　　　　　　　　　　　　　"},
  {"code": "1630066", "name": "和美分社　　　　　　　　　　　　　　　　"},
  {"code": "1630075", "name": "大埔分社　　　　　　　　　　　　　　　　"},
  {"code": "1630084", "name": "埔鹽分社　　　　　　　　　　　　　　　　"},
  {"code": "1630093", "name": "溪湖分社　　　　　　　　　　　　　　　　"},
  {"code": "1630109", "name": "伸港分社　　　　　　　　　　　　　　　　"}
  ],
  "165": [
  {"code": "1650019", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1650028", "name": "彰鹿分社　　　　　　　　　　　　　　　　"},
  {"code": "1650037", "name": "頂番分社　　　　　　　　　　　　　　　　"},
  {"code": "1650046", "name": "埔鹽分社　　　　　　　　　　　　　　　　"},
  {"code": "1650055", "name": "彰濱分社　　　　　　　　　　　　　　　　"},
  {"code": "1650064", "name": "管嶼分社　　　　　　　　　　　　　　　　"},
  {"code": "1650073", "name": "王功分社　　　　　　　　　　　　　　　　"},
  {"code": "1650082", "name": "草港分社　　　　　　　　　　　　　　　　"},
  {"code": "1650091", "name": "溪湖分社　　　　　　　　　　　　　　　　"},
  {"code": "1650107", "name": "員林分社　　　　　　　　　　　　　　　　"}
  ],
  "178": [
  {"code": "1780013", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1780022", "name": "中埔分社　　　　　　　　　　　　　　　　"},
  {"code": "1780031", "name": "新榮分社　　　　　　　　　　　　　　　　"},
  {"code": "1780040", "name": "北興分社　　　　　　　　　　　　　　　　"},
  {"code": "1780059", "name": "忠孝分社　　　　　　　　　　　　　　　　"},
  {"code": "1780068", "name": "興嘉分社　　　　　　　　　　　　　　　　"},
  {"code": "1780077", "name": "新南分社　　　　　　　　　　　　　　　　"},
  {"code": "1780086", "name": "新興分社　　　　　　　　　　　　　　　　"},
  {"code": "1780095", "name": "美源分社　　　　　　　　　　　　　　　　"},
  {"code": "1780101", "name": "新生分社　　　　　　　　　　　　　　　　"},
  {"code": "1780110", "name": "民生分社　　　　　　　　　　　　　　　　"}
  ],
  "188": [
  {"code": "1880010", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "1880029", "name": "東門分社　　　　　　　　　　　　　　　　"},
  {"code": "1880038", "name": "西門分社　　　　　　　　　　　　　　　　"},
  {"code": "1880047", "name": "安平分社　　　　　　　　　　　　　　　　"},
  {"code": "1880056", "name": "成功分社　　　　　　　　　　　　　　　　"},
  {"code": "1880065", "name": "大同分社　　　　　　　　　　　　　　　　"},
  {"code": "1880074", "name": "文賢分社　　　　　　　　　　　　　　　　"},
  {"code": "1880083", "name": "金華分社　　　　　　　　　　　　　　　　"},
  {"code": "1880092", "name": "小東分社　　　　　　　　　　　　　　　　"},
  {"code": "1880108", "name": "開元分社　　　　　　　　　　　　　　　　"},
  {"code": "1880117", "name": "中華分社　　　　　　　　　　　　　　　　"},
  {"code": "1880126", "name": "大灣分社　　　　　　　　　　　　　　　　"},
  {"code": "1880135", "name": "安中分社　　　　　　　　　　　　　　　　"}
  ],
  "204": [
  {"code": "2040011", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "2040020", "name": "八德分社　　　　　　　　　　　　　　　　"},
  {"code": "2040039", "name": "苓雅分社　　　　　　　　　　　　　　　　"},
  {"code": "2040048", "name": "新興分社　　　　　　　　　　　　　　　　"},
  {"code": "2040057", "name": "三民分社　　　　　　　　　　　　　　　　"},
  {"code": "2040066", "name": "鼓山分社　　　　　　　　　　　　　　　　"},
  {"code": "2040075", "name": "臨海分社　　　　　　　　　　　　　　　　"},
  {"code": "2040084", "name": "前鎮分社　　　　　　　　　　　　　　　　"},
  {"code": "2040093", "name": "前金分社　　　　　　　　　　　　　　　　"},
  {"code": "2040109", "name": "左營分社　　　　　　　　　　　　　　　　"},
  {"code": "2040118", "name": "青年分社　　　　　　　　　　　　　　　　"},
  {"code": "2040127", "name": "楠梓分社　　　　　　　　　　　　　　　　"},
  {"code": "2040136", "name": "三多分社　　　　　　　　　　　　　　　　"},
  {"code": "2040145", "name": "灣子分社　　　　　　　　　　　　　　　　"},
  {"code": "2040154", "name": "天祥分社　　　　　　　　　　　　　　　　"},
  {"code": "2040163", "name": "陽明分社　　　　　　　　　　　　　　　　"},
  {"code": "2040172", "name": "武廟分社　　　　　　　　　　　　　　　　"},
  {"code": "2040181", "name": "瑞祥分社　　　　　　　　　　　　　　　　"},
  {"code": "2040190", "name": "右昌分社　　　　　　　　　　　　　　　　"},
  {"code": "2040206", "name": "小港分社　　　　　　　　　　　　　　　　"},
  {"code": "2040215", "name": "文川分社　　　　　　　　　　　　　　　　"}
  ],
  "215": [
  {"code": "2150017", "name": "復興分社（光隆，日盛證券收付處）　　　　"},
  {"code": "2150026", "name": "自由分社　　　　　　　　　　　　　　　　"},
  {"code": "2150035", "name": "中華分社　　　　　　　　　　　　　　　　"},
  {"code": "2150044", "name": "總社〈營業部〉　　　　　　　　　　　　　"},
  {"code": "2150053", "name": "美崙分社　　　　　　　　　　　　　　　　"},
  {"code": "2150062", "name": "信義簡易型分社　　　　　　　　　　　　　"},
  {"code": "2150071", "name": "自強分社　　　　　　　　　　　　　　　　"},
  {"code": "2150080", "name": "國光簡易型分社　　　　　　　　　　　　　"},
  {"code": "2150099", "name": "鳳山分社　　　　　　　　　　　　　　　　"},
  {"code": "2150105", "name": "建國簡易型分社　　　　　　　　　　　　　"},
  {"code": "2150114", "name": "永康分社　　　　　　　　　　　　　　　　"},
  {"code": "2150123", "name": "慶豐簡易型分社　　　　　　　　　　　　　"},
  {"code": "2150132", "name": "台東分社　　　　　　　　　　　　　　　　"},
  {"code": "2150141", "name": "仁武分社　　　　　　　　　　　　　　　　"},
  {"code": "2150150", "name": "橋頭分社　　　　　　　　　　　　　　　　"}
  ],
  "216": [
  {"code": "2160016", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "2160025", "name": "中山分社　　　　　　　　　　　　　　　　"},
  {"code": "2160034", "name": "主里分社　　　　　　　　　　　　　　　　"},
  {"code": "2160043", "name": "美崙分社　　　　　　　　　　　　　　　　"},
  {"code": "2160052", "name": "中正分社　　　　　　　　　　　　　　　　"},
  {"code": "2160061", "name": "富國分社　　　　　　　　　　　　　　　　"},
  {"code": "2160070", "name": "田蒲分社　　　　　　　　　　　　　　　　"},
  {"code": "2160089", "name": "建國分社　　　　　　　　　　　　　　　　"},
  {"code": "2160098", "name": "壽豐分社　　　　　　　　　　　　　　　　"},
  {"code": "2160104", "name": "玉里分社　　　　　　　　　　　　　　　　"},
  {"code": "2160122", "name": "台東分社　　　　　　　　　　　　　　　　"},
  {"code": "2160131", "name": "大里分社　　　　　　　　　　　　　　　　"},
  {"code": "2160140", "name": "太平分社　　　　　　　　　　　　　　　　"},
  {"code": "2160159", "name": "大雅分社　　　　　　　　　　　　　　　　"},
  {"code": "2160168", "name": "烏日分社　　　　　　　　　　　　　　　　"},
  {"code": "2160177", "name": "公益分社　　　　　　　　　　　　　　　　"},
  {"code": "2160186", "name": "西屯分社　　　　　　　　　　　　　　　　"},
  {"code": "2160195", "name": "羅東分社　　　　　　　　　　　　　　　　"},
  {"code": "2160201", "name": "左營分社　　　　　　　　　　　　　　　　"}
  ],
  "222": [
  {"code": "2220017", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "2220026", "name": "民權分社　　　　　　　　　　　　　　　　"},
  {"code": "2220035", "name": "光復分社　　　　　　　　　　　　　　　　"},
  {"code": "2220044", "name": "澎南分社　　　　　　　　　　　　　　　　"},
  {"code": "2220053", "name": "赤崁分社　　　　　　　　　　　　　　　　"},
  {"code": "2220062", "name": "西嶼分社　　　　　　　　　　　　　　　　"},
  {"code": "2220080", "name": "湖西分社　　　　　　　　　　　　　　　　"},
  {"code": "2220099", "name": "港都分社　　　　　　　　　　　　　　　　"},
  {"code": "2220105", "name": "朝陽分社　　　　　　　　　　　　　　　　"}
  ],
  "223": [
  {"code": "2230016", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "2230025", "name": "民生分社　　　　　　　　　　　　　　　　"},
  {"code": "2230034", "name": "陽明分社　　　　　　　　　　　　　　　　"},
  {"code": "2230043", "name": "澎南分社　　　　　　　　　　　　　　　　"},
  {"code": "2230052", "name": "白沙分社　　　　　　　　　　　　　　　　"},
  {"code": "2230061", "name": "西嶼分社　　　　　　　　　　　　　　　　"},
  {"code": "2230070", "name": "湖西分社　　　　　　　　　　　　　　　　"},
  {"code": "2230089", "name": "漁港分社　　　　　　　　　　　　　　　　"},
  {"code": "2230098", "name": "中興分社　　　　　　　　　　　　　　　　"}
  ],
  "224": [
  {"code": "2240015", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "2240024", "name": "金沙分社　　　　　　　　　　　　　　　　"},
  {"code": "2240033", "name": "金湖分社　　　　　　　　　　　　　　　　"},
  {"code": "2240042", "name": "烈嶼分社　　　　　　　　　　　　　　　　"}
  ],
  "321": [
  {"code": "3210019", "name": "台北分行　　　　　　　　　　　　　　　　"}
  ],
  "326": [
  {"code": "3268881", "name": "臺北分行　　　　　　　　　　　　　　　　"}
  ],
  "372": [
  {"code": "3720015", "name": "總公司　　　　　　　　　　　　　　　　　"}
  ],
  "380": [
  {"code": "3800016", "name": "臺北分行　　　　　　　　　　　　　　　　"}
  ],
  "381": [
  {"code": "3810888", "name": "臺北分行　　　　　　　　　　　　　　　　"}
  ],
  "382": [
  {"code": "3820018", "name": "臺北分行　　　　　　　　　　　　　　　　"}
  ],
  "501": [
  {"code": "5010017", "name": "宜蘭縣蘇澳區漁會　　　　　　　　　　　　"},
  {"code": "5010028", "name": "新馬分部　　　　　　　　　　　　　　　　"}
  ],
  "502": [
  {"code": "5020018", "name": "宜蘭縣頭城區漁會　　　　　　　　　　　　"},
  {"code": "5020029", "name": "大溪分部　　　　　　　　　　　　　　　　"},
  {"code": "5020030", "name": "壯圍分部　　　　　　　　　　　　　　　　"}
  ],
  "506": [
  {"code": "5060012", "name": "桃園區漁會　　　　　　　　　　　　　　　"}
  ],
  "507": [
  {"code": "5070013", "name": "新竹區漁會　　　　　　　　　　　　　　　"}
  ],
  "508": [
  {"code": "5080014", "name": "通苑區漁會　　　　　　　　　　　　　　　"},
  {"code": "5080025", "name": "苑裡分部　　　　　　　　　　　　　　　　"}
  ],
  "510": [
  {"code": "5100019", "name": "南龍區漁會　　　　　　　　　　　　　　　"},
  {"code": "5100020", "name": "竹南分部　　　　　　　　　　　　　　　　"}
  ],
  "511": [
  {"code": "5110010", "name": "彰化區漁會　　　　　　　　　　　　　　　"},
  {"code": "5110021", "name": "大城分部　　　　　　　　　　　　　　　　"},
  {"code": "5110032", "name": "王功分部　　　　　　　　　　　　　　　　"},
  {"code": "5110043", "name": "芳苑分部　　　　　　　　　　　　　　　　"},
  {"code": "5110054", "name": "草港分部　　　　　　　　　　　　　　　　"},
  {"code": "5110065", "name": "福興分部　　　　　　　　　　　　　　　　"},
  {"code": "5110076", "name": "伸港分部　　　　　　　　　　　　　　　　"},
  {"code": "5110087", "name": "埔心分部　　　　　　　　　　　　　　　　"}
  ],
  "512": [
  {"code": "5120011", "name": "雲林區漁會　　　　　　　　　　　　　　　"},
  {"code": "5120022", "name": "台西分部　　　　　　　　　　　　　　　　"},
  {"code": "5120033", "name": "口湖分部　　　　　　　　　　　　　　　　"},
  {"code": "5120044", "name": "麥寮分部　　　　　　　　　　　　　　　　"},
  {"code": "5120055", "name": "三條崙分部　　　　　　　　　　　　　　　"}
  ],
  "513": [
  {"code": "5130012", "name": "新北市瑞芳區漁會　　　　　　　　　　　　"},
  {"code": "5130023", "name": "深澳分部　　　　　　　　　　　　　　　　"}
  ],
  "514": [
  {"code": "5140013", "name": "萬里區漁會　　　　　　　　　　　　　　　"}
  ],
  "515": [
  {"code": "5150014", "name": "嘉義區漁會　　　　　　　　　　　　　　　"},
  {"code": "5150025", "name": "新塭分部　　　　　　　　　　　　　　　　"},
  {"code": "5150036", "name": "義竹分部　　　　　　　　　　　　　　　　"},
  {"code": "5150047", "name": "過溝分部　　　　　　　　　　　　　　　　"},
  {"code": "5150058", "name": "東石分部　　　　　　　　　　　　　　　　"},
  {"code": "5150069", "name": "過路分部　　　　　　　　　　　　　　　　"},
  {"code": "5150070", "name": "副瀨分部　　　　　　　　　　　　　　　　"},
  {"code": "5150081", "name": "景山分部　　　　　　　　　　　　　　　　"}
  ],
  "516": [
  {"code": "5160015", "name": "基隆區漁會　　　　　　　　　　　　　　　"}
  ],
  "517": [
  {"code": "5170016", "name": "南市區漁會　　　　　　　　　　　　　　　"},
  {"code": "5170027", "name": "四草分部　　　　　　　　　　　　　　　　"},
  {"code": "5170038", "name": "安南分部　　　　　　　　　　　　　　　　"}
  ],
  "518": [
  {"code": "5180017", "name": "南縣區漁會　　　　　　　　　　　　　　　"},
  {"code": "5180028", "name": "七股分部　　　　　　　　　　　　　　　　"},
  {"code": "5180039", "name": "北門分部　　　　　　　　　　　　　　　　"},
  {"code": "5180040", "name": "將軍港分部　　　　　　　　　　　　　　　"},
  {"code": "5180051", "name": "青山港分部　　　　　　　　　　　　　　　"},
  {"code": "5180073", "name": "永吉分部　　　　　　　　　　　　　　　　"}
  ],
  "519": [
  {"code": "5190018", "name": "新化區農會　　　　　　　　　　　　　　　"},
  {"code": "5190029", "name": "那拔林分部　　　　　　　　　　　　　　　"},
  {"code": "5190030", "name": "中山分部　　　　　　　　　　　　　　　　"}
  ],
  "520": [
  {"code": "5200012", "name": "高雄區漁會信用部　　　　　　　　　　　　"},
  {"code": "5200023", "name": "小港區漁會信用部　　　　　　　　　　　　"},
  {"code": "5200034", "name": "旗津分部　　　　　　　　　　　　　　　　"},
  {"code": "5200056", "name": "援中港分部　　　　　　　　　　　　　　　"}
  ],
  "521": [
  {"code": "5210024", "name": "興達港區漁會　　　　　　　　　　　　　　"},
  {"code": "5210035", "name": "下茄萣分部　　　　　　　　　　　　　　　"},
  {"code": "5210068", "name": "林園區漁會　　　　　　　　　　　　　　　"},
  {"code": "5210079", "name": "彌陀區漁會　　　　　　　　　　　　　　　"},
  {"code": "5210091", "name": "永安區漁會　　　　　　　　　　　　　　　"},
  {"code": "5210105", "name": "舊港分部　　　　　　　　　　　　　　　　"},
  {"code": "5210116", "name": "梓官區漁會　　　　　　　　　　　　　　　"},
  {"code": "5210149", "name": "南寮分部　　　　　　　　　　　　　　　　"}
  ],
  "523": [
  {"code": "5230015", "name": "琉球區漁會　　　　　　　　　　　　　　　"},
  {"code": "5230037", "name": "東港區漁會　　　　　　　　　　　　　　　"},
  {"code": "5230048", "name": "林邊區漁會　　　　　　　　　　　　　　　"},
  {"code": "5230059", "name": "塭豐分部　　　　　　　　　　　　　　　　"},
  {"code": "5230082", "name": "崎峰分部　　　　　　　　　　　　　　　　"},
  {"code": "5230093", "name": "水利分部　　　　　　　　　　　　　　　　"},
  {"code": "5230118", "name": "光復分部　　　　　　　　　　　　　　　　"},
  {"code": "5230129", "name": "新園分部　　　　　　　　　　　　　　　　"},
  {"code": "5230130", "name": "枋寮區漁會　　　　　　　　　　　　　　　"}
  ],
  "524": [
  {"code": "5240016", "name": "新港區漁會　　　　　　　　　　　　　　　"}
  ],
  "525": [
  {"code": "5250017", "name": "澎湖區漁會　　　　　　　　　　　　　　　"},
  {"code": "5250028", "name": "西嶼分部　　　　　　　　　　　　　　　　"},
  {"code": "5250039", "name": "白沙分部　　　　　　　　　　　　　　　　"}
  ],
  "526": [
  {"code": "5260018", "name": "金門區漁會　　　　　　　　　　　　　　　"}
  ],
  "538": [
  {"code": "5380013", "name": "宜蘭市農會　　　　　　　　　　　　　　　"},
  {"code": "5380024", "name": "神農分部　　　　　　　　　　　　　　　　"},
  {"code": "5380035", "name": "新店分部　　　　　　　　　　　　　　　　"},
  {"code": "5380057", "name": "南門分部　　　　　　　　　　　　　　　　"},
  {"code": "5380068", "name": "延平分部　　　　　　　　　　　　　　　　"}
  ],
  "541": [
  {"code": "5410019", "name": "白河區農會　　　　　　　　　　　　　　　"},
  {"code": "5410020", "name": "市場分部　　　　　　　　　　　　　　　　"},
  {"code": "5410031", "name": "玉豐分部　　　　　　　　　　　　　　　　"},
  {"code": "5410042", "name": "關嶺分部　　　　　　　　　　　　　　　　"},
  {"code": "5410053", "name": "竹門分部　　　　　　　　　　　　　　　　"}
  ],
  "542": [
  {"code": "5420010", "name": "麻豆區農會　　　　　　　　　　　　　　　"},
  {"code": "5420021", "name": "新生分部　　　　　　　　　　　　　　　　"},
  {"code": "5420032", "name": "復光分部　　　　　　　　　　　　　　　　"},
  {"code": "5420043", "name": "安業分部　　　　　　　　　　　　　　　　"}
  ],
  "547": [
  {"code": "5470015", "name": "後壁區農會　　　　　　　　　　　　　　　"},
  {"code": "5470026", "name": "菁寮分部　　　　　　　　　　　　　　　　"},
  {"code": "5470037", "name": "安溪分部　　　　　　　　　　　　　　　　"},
  {"code": "5470048", "name": "新東分部　　　　　　　　　　　　　　　　"},
  {"code": "5470059", "name": "上茄苳分部　　　　　　　　　　　　　　　"},
  {"code": "5470060", "name": "竹新分部　　　　　　　　　　　　　　　　"}
  ],
  "549": [
  {"code": "5490017", "name": "下營區農會　　　　　　　　　　　　　　　"},
  {"code": "5490028", "name": "中營分部　　　　　　　　　　　　　　　　"},
  {"code": "5490039", "name": "中興分部　　　　　　　　　　　　　　　　"},
  {"code": "5490040", "name": "甲中分部　　　　　　　　　　　　　　　　"}
  ],
  "551": [
  {"code": "5510012", "name": "官田區農會　　　　　　　　　　　　　　　"},
  {"code": "5510023", "name": "官田辦事處　　　　　　　　　　　　　　　"},
  {"code": "5510034", "name": "渡頭辦事處　　　　　　　　　　　　　　　"},
  {"code": "5510045", "name": "西庄辦事處　　　　　　　　　　　　　　　"},
  {"code": "5510056", "name": "湖山辦事處　　　　　　　　　　　　　　　"},
  {"code": "5510067", "name": "二鎮辦事處　　　　　　　　　　　　　　　"}
  ],
  "552": [
  {"code": "5520013", "name": "大內區農會　　　　　　　　　　　　　　　"},
  {"code": "5520024", "name": "頭社分部　　　　　　　　　　　　　　　　"},
  {"code": "5520035", "name": "環湖分部　　　　　　　　　　　　　　　　"},
  {"code": "5520046", "name": "二溪辦事處　　　　　　　　　　　　　　　"}
  ],
  "556": [
  {"code": "5560017", "name": "學甲區農會　　　　　　　　　　　　　　　"},
  {"code": "5560028", "name": "中洲分部　　　　　　　　　　　　　　　　"},
  {"code": "5560039", "name": "宅港分部　　　　　　　　　　　　　　　　"},
  {"code": "5560040", "name": "頂洲分部　　　　　　　　　　　　　　　　"},
  {"code": "5560051", "name": "大灣分部　　　　　　　　　　　　　　　　"},
  {"code": "5560062", "name": "草圣分部　　　　　　　　　　　　　　　　"}
  ],
  "557": [
  {"code": "5570018", "name": "新市區農會　　　　　　　　　　　　　　　"},
  {"code": "5570029", "name": "大社分部　　　　　　　　　　　　　　　　"}
  ],
  "558": [
  {"code": "5580019", "name": "安定區農會　　　　　　　　　　　　　　　"},
  {"code": "5580020", "name": "港口分部　　　　　　　　　　　　　　　　"},
  {"code": "5580031", "name": "蘇厝分部　　　　　　　　　　　　　　　　"},
  {"code": "5580042", "name": "海寮分部　　　　　　　　　　　　　　　　"},
  {"code": "5580053", "name": "中沙分部　　　　　　　　　　　　　　　　"}
  ],
  "559": [
  {"code": "5590010", "name": "山上區農會　　　　　　　　　　　　　　　"}
  ],
  "561": [
  {"code": "5610015", "name": "左鎮區農會　　　　　　　　　　　　　　　"}
  ],
  "562": [
  {"code": "5620016", "name": "仁德區農會　　　　　　　　　　　　　　　"},
  {"code": "5620027", "name": "保安分部　　　　　　　　　　　　　　　　"},
  {"code": "5620038", "name": "二行分部　　　　　　　　　　　　　　　　"},
  {"code": "5620049", "name": "太子分部　　　　　　　　　　　　　　　　"},
  {"code": "5620050", "name": "中洲分部　　　　　　　　　　　　　　　　"},
  {"code": "5620061", "name": "後壁分部　　　　　　　　　　　　　　　　"}
  ],
  "564": [
  {"code": "5640018", "name": "關廟區農會　　　　　　　　　　　　　　　"},
  {"code": "5640029", "name": "龜洞分部　　　　　　　　　　　　　　　　"},
  {"code": "5640030", "name": "埤頭分部　　　　　　　　　　　　　　　　"}
  ],
  "565": [
  {"code": "5650019", "name": "龍崎區農會　　　　　　　　　　　　　　　"},
  {"code": "5650020", "name": "龍船分部　　　　　　　　　　　　　　　　"}
  ],
  "567": [
  {"code": "5670011", "name": "南化區農會　　　　　　　　　　　　　　　"}
  ],
  "568": [
  {"code": "5680012", "name": "七股區農會　　　　　　　　　　　　　　　"}
  ],
  "570": [
  {"code": "5700017", "name": "南投市農會　　　　　　　　　　　　　　　"},
  {"code": "5700028", "name": "內興分部　　　　　　　　　　　　　　　　"},
  {"code": "5700039", "name": "永豐分部　　　　　　　　　　　　　　　　"},
  {"code": "5700040", "name": "福山分部　　　　　　　　　　　　　　　　"},
  {"code": "5700051", "name": "營南分部　　　　　　　　　　　　　　　　"},
  {"code": "5700062", "name": "營北分部　　　　　　　　　　　　　　　　"},
  {"code": "5700073", "name": "漳和分部　　　　　　　　　　　　　　　　"},
  {"code": "5700084", "name": "鳳山分部　　　　　　　　　　　　　　　　"}
  ],
  "573": [
  {"code": "5730010", "name": "埔里鎮農會　　　　　　　　　　　　　　　"},
  {"code": "5730021", "name": "愛蘭分部　　　　　　　　　　　　　　　　"},
  {"code": "5730032", "name": "合成分部　　　　　　　　　　　　　　　　"},
  {"code": "5730043", "name": "東興分部　　　　　　　　　　　　　　　　"}
  ],
  "574": [
  {"code": "5740011", "name": "竹山鎮農會　　　　　　　　　　　　　　　"},
  {"code": "5740022", "name": "社寮分部　　　　　　　　　　　　　　　　"},
  {"code": "5740033", "name": "瑞竹分部　　　　　　　　　　　　　　　　"},
  {"code": "5740044", "name": "延平分部　　　　　　　　　　　　　　　　"},
  {"code": "5740055", "name": "中央分部　　　　　　　　　　　　　　　　"}
  ],
  "575": [
  {"code": "5750012", "name": "中寮鄉農會　　　　　　　　　　　　　　　"},
  {"code": "5750023", "name": "爽文分部　　　　　　　　　　　　　　　　"},
  {"code": "5750034", "name": "義和分部　　　　　　　　　　　　　　　　"},
  {"code": "5750045", "name": "內城分部　　　　　　　　　　　　　　　　"}
  ],
  "577": [
  {"code": "5770014", "name": "魚池鄉農會　　　　　　　　　　　　　　　"},
  {"code": "5770025", "name": "頭社分部　　　　　　　　　　　　　　　　"},
  {"code": "5770036", "name": "日月潭分部　　　　　　　　　　　　　　　"},
  {"code": "5770047", "name": "東光分部　　　　　　　　　　　　　　　　"},
  {"code": "5770058", "name": "共和分部　　　　　　　　　　　　　　　　"},
  {"code": "5770069", "name": "五城分部　　　　　　　　　　　　　　　　"}
  ],
  "578": [
  {"code": "5780015", "name": "水里鄉農會　　　　　　　　　　　　　　　"},
  {"code": "5780026", "name": "玉峰分部　　　　　　　　　　　　　　　　"},
  {"code": "5780037", "name": "民和分部　　　　　　　　　　　　　　　　"},
  {"code": "5780048", "name": "上安分部　　　　　　　　　　　　　　　　"}
  ],
  "579": [
  {"code": "5790016", "name": "國姓鄉農會　　　　　　　　　　　　　　　"},
  {"code": "5790027", "name": "國姓分部　　　　　　　　　　　　　　　　"},
  {"code": "5790038", "name": "長流分部　　　　　　　　　　　　　　　　"},
  {"code": "5790049", "name": "北山分部　　　　　　　　　　　　　　　　"},
  {"code": "5790050", "name": "福龜分部　　　　　　　　　　　　　　　　"},
  {"code": "5790072", "name": "北港分部　　　　　　　　　　　　　　　　"}
  ],
  "580": [
  {"code": "5800010", "name": "鹿谷鄉農會　　　　　　　　　　　　　　　"},
  {"code": "5800021", "name": "廣興分部　　　　　　　　　　　　　　　　"},
  {"code": "5800032", "name": "竹林分部　　　　　　　　　　　　　　　　"},
  {"code": "5800043", "name": "永隆分部　　　　　　　　　　　　　　　　"},
  {"code": "5800054", "name": "初鄉分部　　　　　　　　　　　　　　　　"},
  {"code": "5800065", "name": "坪頂分部　　　　　　　　　　　　　　　　"},
  {"code": "5800076", "name": "瑞田分部　　　　　　　　　　　　　　　　"},
  {"code": "5800087", "name": "鳳凰分部　　　　　　　　　　　　　　　　"}
  ],
  "581": [
  {"code": "5810011", "name": "信義鄉農會　　　　　　　　　　　　　　　"},
  {"code": "5810022", "name": "地利分部　　　　　　　　　　　　　　　　"},
  {"code": "5810033", "name": "和社分部　　　　　　　　　　　　　　　　"}
  ],
  "582": [
  {"code": "5820012", "name": "仁愛鄉農會　　　　　　　　　　　　　　　"}
  ],
  "583": [
  {"code": "5830013", "name": "東山區農會　　　　　　　　　　　　　　　"},
  {"code": "5830024", "name": "東原分部　　　　　　　　　　　　　　　　"},
  {"code": "5830035", "name": "青山分部　　　　　　　　　　　　　　　　"},
  {"code": "5830046", "name": "聖賢分部　　　　　　　　　　　　　　　　"},
  {"code": "5830057", "name": "南溪分部　　　　　　　　　　　　　　　　"}
  ],
  "585": [
  {"code": "5850015", "name": "頭城鎮農會　　　　　　　　　　　　　　　"},
  {"code": "5850026", "name": "金面分部　　　　　　　　　　　　　　　　"},
  {"code": "5850037", "name": "大溪分部　　　　　　　　　　　　　　　　"}
  ],
  "586": [
  {"code": "5860016", "name": "羅東鎮農會　　　　　　　　　　　　　　　"},
  {"code": "5860027", "name": "中正路分部　　　　　　　　　　　　　　　"},
  {"code": "5860049", "name": "民權分部　　　　　　　　　　　　　　　　"},
  {"code": "5860050", "name": "南門分部　　　　　　　　　　　　　　　　"},
  {"code": "5860061", "name": "北門分部　　　　　　　　　　　　　　　　"},
  {"code": "5860119", "name": "東門分部　　　　　　　　　　　　　　　　"}
  ],
  "587": [
  {"code": "5870017", "name": "礁溪鄉農會　　　　　　　　　　　　　　　"},
  {"code": "5870028", "name": "四結分部　　　　　　　　　　　　　　　　"},
  {"code": "5870039", "name": "龍潭分部　　　　　　　　　　　　　　　　"},
  {"code": "5870040", "name": "德陽分部　　　　　　　　　　　　　　　　"}
  ],
  "588": [
  {"code": "5880018", "name": "壯圍鄉農會　　　　　　　　　　　　　　　"},
  {"code": "5880029", "name": "古亭分部　　　　　　　　　　　　　　　　"},
  {"code": "5880030", "name": "美城分部　　　　　　　　　　　　　　　　"}
  ],
  "589": [
  {"code": "5890019", "name": "員山鄉農會　　　　　　　　　　　　　　　"},
  {"code": "5890020", "name": "同樂分部　　　　　　　　　　　　　　　　"},
  {"code": "5890031", "name": "深溝分部　　　　　　　　　　　　　　　　"},
  {"code": "5890042", "name": "大湖分部　　　　　　　　　　　　　　　　"}
  ],
  "596": [
  {"code": "5960019", "name": "五結鄉農會　　　　　　　　　　　　　　　"},
  {"code": "5960020", "name": "二結分部　　　　　　　　　　　　　　　　"},
  {"code": "5960031", "name": "利澤分部　　　　　　　　　　　　　　　　"},
  {"code": "5960042", "name": "四結分部　　　　　　　　　　　　　　　　"}
  ],
  "598": [
  {"code": "5980011", "name": "蘇澳地區農會　　　　　　　　　　　　　　"},
  {"code": "5980022", "name": "南方澳分部　　　　　　　　　　　　　　　"},
  {"code": "5980033", "name": "新馬分部　　　　　　　　　　　　　　　　"},
  {"code": "5980044", "name": "新城分部　　　　　　　　　　　　　　　　"},
  {"code": "5980055", "name": "南澳分部　　　　　　　　　　　　　　　　"},
  {"code": "5980066", "name": "龍德分部　　　　　　　　　　　　　　　　"}
  ],
  "599": [
  {"code": "5990012", "name": "三星地區農會　　　　　　　　　　　　　　"},
  {"code": "5990023", "name": "大洲分部　　　　　　　　　　　　　　　　"},
  {"code": "5990034", "name": "大隱分部　　　　　　　　　　　　　　　　"},
  {"code": "5990045", "name": "福山分部　　　　　　　　　　　　　　　　"},
  {"code": "5990056", "name": "大同分部　　　　　　　　　　　　　　　　"}
  ],
  "602": [
  {"code": "6020015", "name": "中華民國農會中壢辦事處信用部　　　　　　"},
  {"code": "6020026", "name": "大崙分部　　　　　　　　　　　　　　　　"},
  {"code": "6020037", "name": "內壢分部　　　　　　　　　　　　　　　　"}
  ],
  "605": [
  {"code": "6050018", "name": "高雄市高雄地區農會　　　　　　　　　　　"},
  {"code": "6050029", "name": "三民分部　　　　　　　　　　　　　　　　"},
  {"code": "6050030", "name": "鼓山分部　　　　　　　　　　　　　　　　"},
  {"code": "6050041", "name": "新興分部　　　　　　　　　　　　　　　　"},
  {"code": "6050052", "name": "鼎力分部　　　　　　　　　　　　　　　　"},
  {"code": "6050063", "name": "苓雅分部　　　　　　　　　　　　　　　　"},
  {"code": "6050074", "name": "前鎮分部　　　　　　　　　　　　　　　　"},
  {"code": "6050085", "name": "楠梓分部　　　　　　　　　　　　　　　　"},
  {"code": "6050096", "name": "右昌分部　　　　　　　　　　　　　　　　"},
  {"code": "6050100", "name": "後勁分部　　　　　　　　　　　　　　　　"},
  {"code": "6050111", "name": "左營分部　　　　　　　　　　　　　　　　"},
  {"code": "6050122", "name": "營北分部　　　　　　　　　　　　　　　　"},
  {"code": "6050133", "name": "新庄分部　　　　　　　　　　　　　　　　"}
  ],
  "612": [
  {"code": "6121107", "name": "臺中市豐原區農會　　　　　　　　　　　　"},
  {"code": "6121118", "name": "神岡區農會　　　　　　　　　　　　　　　"}
  ],
  "613": [
  {"code": "6130031", "name": "集集鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6130075", "name": "名間鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6130260", "name": "新街分部　　　　　　　　　　　　　　　　"},
  {"code": "6130271", "name": "大庄分部　　　　　　　　　　　　　　　　"},
  {"code": "6130282", "name": "赤水分部　　　　　　　　　　　　　　　　"},
  {"code": "6130293", "name": "松柏嶺分部　　　　　　　　　　　　　　　"},
  {"code": "6130466", "name": "新光分部　　　　　　　　　　　　　　　　"},
  {"code": "6130488", "name": "田寮分部　　　　　　　　　　　　　　　　"}
  ],
  "614": [
  {"code": "6140043", "name": "員林市農會　　　　　　　　　　　　　　　"},
  {"code": "6140087", "name": "二林鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6140124", "name": "秀水鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6140179", "name": "埔心鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6140180", "name": "永靖鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6140227", "name": "埤頭鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6140261", "name": "竹塘鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6140320", "name": "福安分部　　　　　　　　　　　　　　　　"},
  {"code": "6140401", "name": "路口厝分部　　　　　　　　　　　　　　　"},
  {"code": "6140412", "name": "埤頭分部　　　　　　　　　　　　　　　　"},
  {"code": "6140423", "name": "芙朝分部　　　　　　　　　　　　　　　　"},
  {"code": "6140478", "name": "馬鳴分部　　　　　　　　　　　　　　　　"},
  {"code": "6140515", "name": "金興分部　　　　　　　　　　　　　　　　"},
  {"code": "6140526", "name": "東山分部　　　　　　　　　　　　　　　　"},
  {"code": "6140559", "name": "舊館分部　　　　　　　　　　　　　　　　"},
  {"code": "6140593", "name": "明聖分部　　　　　　　　　　　　　　　　"},
  {"code": "6140696", "name": "永安分部　　　　　　　　　　　　　　　　"},
  {"code": "6140700", "name": "百果山分部　　　　　　　　　　　　　　　"},
  {"code": "6140711", "name": "原斗分部　　　　　　　　　　　　　　　　"},
  {"code": "6140733", "name": "五福分部　　　　　　　　　　　　　　　　"},
  {"code": "6140799", "name": "挖仔分部　　　　　　　　　　　　　　　　"},
  {"code": "6140858", "name": "中山分部　　　　　　　　　　　　　　　　"},
  {"code": "6140870", "name": "同安分部　　　　　　　　　　　　　　　　"},
  {"code": "6141017", "name": "長安分部　　　　　　　　　　　　　　　　"},
  {"code": "6141028", "name": "永興分部　　　　　　　　　　　　　　　　"},
  {"code": "6141291", "name": "萬興分部　　　　　　　　　　　　　　　　"},
  {"code": "6141327", "name": "芬園鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6141338", "name": "芳苑鄉農會　　　　　　　　　　　　　　　"}
  ],
  "615": [
  {"code": "6150011", "name": "基隆市農會　　　　　　　　　　　　　　　"},
  {"code": "6150022", "name": "安樂分部　　　　　　　　　　　　　　　　"},
  {"code": "6150033", "name": "百福分部　　　　　　　　　　　　　　　　"},
  {"code": "6150044", "name": "愛六路分部　　　　　　　　　　　　　　　"}
  ],
  "616": [
  {"code": "6160012", "name": "斗六市農會　　　　　　　　　　　　　　　"},
  {"code": "6160023", "name": "虎尾鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6160034", "name": "西螺鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6160056", "name": "斗南鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6160078", "name": "古坑鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6160089", "name": "大埤鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6160090", "name": "莿桐鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6160115", "name": "二崙鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6160126", "name": "崙背鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6160137", "name": "台西鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6160148", "name": "褒忠鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6160160", "name": "四湖鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6160171", "name": "口湖鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6160218", "name": "石龜溪分部　　　　　　　　　　　　　　　"},
  {"code": "6160230", "name": "永光分部　　　　　　　　　　　　　　　　"},
  {"code": "6160241", "name": "東和分部　　　　　　　　　　　　　　　　"},
  {"code": "6160252", "name": "怡然分部　　　　　　　　　　　　　　　　"},
  {"code": "6160263", "name": "饒平分部　　　　　　　　　　　　　　　　"},
  {"code": "6160274", "name": "油車分部　　　　　　　　　　　　　　　　"},
  {"code": "6160285", "name": "永定分部　　　　　　　　　　　　　　　　"},
  {"code": "6160296", "name": "崙豐分部　　　　　　　　　　　　　　　　"},
  {"code": "6160300", "name": "飛沙分部　　　　　　　　　　　　　　　　"},
  {"code": "6160311", "name": "宜梧分部　　　　　　　　　　　　　　　　"},
  {"code": "6160322", "name": "金湖分部　　　　　　　　　　　　　　　　"},
  {"code": "6160333", "name": "下崙分部　　　　　　　　　　　　　　　　"},
  {"code": "6160403", "name": "埤源分部　　　　　　　　　　　　　　　　"},
  {"code": "6160436", "name": "六合分部　　　　　　　　　　　　　　　　"},
  {"code": "6160447", "name": "溪底分部　　　　　　　　　　　　　　　　"},
  {"code": "6160458", "name": "西埤分部　　　　　　　　　　　　　　　　"},
  {"code": "6160469", "name": "新光分部　　　　　　　　　　　　　　　　"},
  {"code": "6160492", "name": "石榴分部　　　　　　　　　　　　　　　　"},
  {"code": "6160506", "name": "大屯分部　　　　　　　　　　　　　　　　"},
  {"code": "6160517", "name": "惠來分部　　　　　　　　　　　　　　　　"},
  {"code": "6160528", "name": "九隆分部　　　　　　　　　　　　　　　　"},
  {"code": "6160539", "name": "和心分部　　　　　　　　　　　　　　　　"},
  {"code": "6160540", "name": "建興分部　　　　　　　　　　　　　　　　"},
  {"code": "6160562", "name": "嘉興分部　　　　　　　　　　　　　　　　"},
  {"code": "6160573", "name": "林厝分部　　　　　　　　　　　　　　　　"},
  {"code": "6160595", "name": "鎮南分部　　　　　　　　　　　　　　　　"},
  {"code": "6160609", "name": "光興分部　　　　　　　　　　　　　　　　"},
  {"code": "6160610", "name": "頂溪分部　　　　　　　　　　　　　　　　"},
  {"code": "6160621", "name": "中山分部　　　　　　　　　　　　　　　　"},
  {"code": "6160643", "name": "牛厝分部　　　　　　　　　　　　　　　　"},
  {"code": "6160665", "name": "蚊港分部　　　　　　　　　　　　　　　　"},
  {"code": "6160698", "name": "箔子分部　　　　　　　　　　　　　　　　"},
  {"code": "6160702", "name": "明昌分部　　　　　　　　　　　　　　　　"},
  {"code": "6160713", "name": "豐榮分部　　　　　　　　　　　　　　　　"},
  {"code": "6160735", "name": "西岐分部　　　　　　　　　　　　　　　　"},
  {"code": "6160746", "name": "成功分部　　　　　　　　　　　　　　　　"},
  {"code": "6160757", "name": "虎溪分部　　　　　　　　　　　　　　　　"}
  ],
  "617": [
  {"code": "6170013", "name": "吳鳳分部　　　　　　　　　　　　　　　　"},
  {"code": "6170024", "name": "朴子市農會　　　　　　　　　　　　　　　"},
  {"code": "6170035", "name": "布袋鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6170046", "name": "大林鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6170057", "name": "民雄鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6170068", "name": "溪口鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6170079", "name": "東石鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6170080", "name": "義竹鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6170091", "name": "鹿草鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6170105", "name": "太保市農會　　　　　　　　　　　　　　　"},
  {"code": "6170116", "name": "水上鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6170138", "name": "番路鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6170149", "name": "竹崎地區農會　　　　　　　　　　　　　　"},
  {"code": "6170150", "name": "梅山鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6170172", "name": "蒜頭分部　　　　　　　　　　　　　　　　"},
  {"code": "6170194", "name": "福全分部　　　　　　　　　　　　　　　　"},
  {"code": "6170208", "name": "北興分部　　　　　　　　　　　　　　　　"},
  {"code": "6170219", "name": "開元分部　　　　　　　　　　　　　　　　"},
  {"code": "6170220", "name": "文化分部　　　　　　　　　　　　　　　　"},
  {"code": "6170231", "name": "松梅分部　　　　　　　　　　　　　　　　"},
  {"code": "6170242", "name": "過溝分部　　　　　　　　　　　　　　　　"},
  {"code": "6170253", "name": "永安分部　　　　　　　　　　　　　　　　"},
  {"code": "6170275", "name": "溝背分部　　　　　　　　　　　　　　　　"},
  {"code": "6170286", "name": "大美分部　　　　　　　　　　　　　　　　"},
  {"code": "6170297", "name": "排路分部　　　　　　　　　　　　　　　　"},
  {"code": "6170301", "name": "北斗分部　　　　　　　　　　　　　　　　"},
  {"code": "6170312", "name": "山中分部　　　　　　　　　　　　　　　　"},
  {"code": "6170323", "name": "菁埔分部　　　　　　　　　　　　　　　　"},
  {"code": "6170334", "name": "柴林分部　　　　　　　　　　　　　　　　"},
  {"code": "6170345", "name": "崙尾分部　　　　　　　　　　　　　　　　"},
  {"code": "6170356", "name": "東石分部　　　　　　　　　　　　　　　　"},
  {"code": "6170367", "name": "副瀨分部　　　　　　　　　　　　　　　　"},
  {"code": "6170378", "name": "下楫分部　　　　　　　　　　　　　　　　"},
  {"code": "6170389", "name": "西崙分部　　　　　　　　　　　　　　　　"},
  {"code": "6170390", "name": "過路分部　　　　　　　　　　　　　　　　"},
  {"code": "6170404", "name": "光榮分部　　　　　　　　　　　　　　　　"},
  {"code": "6170415", "name": "下潭分部　　　　　　　　　　　　　　　　"},
  {"code": "6170426", "name": "後堀分部　　　　　　　　　　　　　　　　"},
  {"code": "6170437", "name": "後潭分部　　　　　　　　　　　　　　　　"},
  {"code": "6170448", "name": "新埤分部　　　　　　　　　　　　　　　　"},
  {"code": "6170459", "name": "南新分部　　　　　　　　　　　　　　　　"},
  {"code": "6170460", "name": "成功分部　　　　　　　　　　　　　　　　"},
  {"code": "6170471", "name": "南靖分部　　　　　　　　　　　　　　　　"},
  {"code": "6170482", "name": "大崙分部　　　　　　　　　　　　　　　　"},
  {"code": "6170493", "name": "忠和分部　　　　　　　　　　　　　　　　"},
  {"code": "6170507", "name": "北回分部　　　　　　　　　　　　　　　　"},
  {"code": "6170518", "name": "柳林分部　　　　　　　　　　　　　　　　"},
  {"code": "6170563", "name": "觸口分部　　　　　　　　　　　　　　　　"},
  {"code": "6170574", "name": "內埔分部　　　　　　　　　　　　　　　　"},
  {"code": "6170585", "name": "灣橋分部　　　　　　　　　　　　　　　　"},
  {"code": "6170596", "name": "東義分部　　　　　　　　　　　　　　　　"},
  {"code": "6170600", "name": "瑞里分部　　　　　　　　　　　　　　　　"},
  {"code": "6170611", "name": "太平分部　　　　　　　　　　　　　　　　"},
  {"code": "6170622", "name": "太和分部　　　　　　　　　　　　　　　　"},
  {"code": "6170633", "name": "月眉分部　　　　　　　　　　　　　　　　"},
  {"code": "6170644", "name": "大潭分部　　　　　　　　　　　　　　　　"},
  {"code": "6170655", "name": "崙子分部　　　　　　　　　　　　　　　　"},
  {"code": "6170666", "name": "港尾寮分部　　　　　　　　　　　　　　　"},
  {"code": "6170677", "name": "六腳分部　　　　　　　　　　　　　　　　"},
  {"code": "6170688", "name": "灣內分部　　　　　　　　　　　　　　　　"},
  {"code": "6170699", "name": "大埔分部　　　　　　　　　　　　　　　　"},
  {"code": "6170703", "name": "更寮分部　　　　　　　　　　　　　　　　"},
  {"code": "6170714", "name": "秀林分部　　　　　　　　　　　　　　　　"},
  {"code": "6170725", "name": "民生分部　　　　　　　　　　　　　　　　"},
  {"code": "6170758", "name": "嘉太分部　　　　　　　　　　　　　　　　"},
  {"code": "6170769", "name": "新厝分部　　　　　　　　　　　　　　　　"},
  {"code": "6170781", "name": "中林分部　　　　　　　　　　　　　　　　"},
  {"code": "6170806", "name": "六腳鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6170817", "name": "新港鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6170862", "name": "嘉義市農會　　　　　　　　　　　　　　　"},
  {"code": "6171261", "name": "安和分部　　　　　　　　　　　　　　　　"},
  {"code": "6171272", "name": "宣信分部　　　　　　　　　　　　　　　　"},
  {"code": "6171283", "name": "民生分部　　　　　　　　　　　　　　　　"},
  {"code": "6171320", "name": "隙頂分部　　　　　　　　　　　　　　　　"},
  {"code": "6171331", "name": "重寮分部　　　　　　　　　　　　　　　　"},
  {"code": "6171353", "name": "大慷榔分部　　　　　　　　　　　　　　　"},
  {"code": "6171364", "name": "雙溪口分部　　　　　　　　　　　　　　　"},
  {"code": "6171375", "name": "新塭分部　　　　　　　　　　　　　　　　"},
  {"code": "6171386", "name": "柳溝分部　　　　　　　　　　　　　　　　"},
  {"code": "6171397", "name": "新店分部　　　　　　　　　　　　　　　　"},
  {"code": "6171401", "name": "松山分部　　　　　　　　　　　　　　　　"},
  {"code": "6171412", "name": "安東分部　　　　　　　　　　　　　　　　"},
  {"code": "6171423", "name": "石棹分部　　　　　　　　　　　　　　　　"},
  {"code": "6171434", "name": "蘇崙分部　　　　　　　　　　　　　　　　"},
  {"code": "6171467", "name": "中坑分部　　　　　　　　　　　　　　　　"},
  {"code": "6171478", "name": "三興分部　　　　　　　　　　　　　　　　"},
  {"code": "6171489", "name": "興南分部　　　　　　　　　　　　　　　　"},
  {"code": "6171490", "name": "鹿滿分部　　　　　　　　　　　　　　　　"}
  ],
  "618": [
  {"code": "6180025", "name": "新營區農會　　　　　　　　　　　　　　　"},
  {"code": "6180036", "name": "鹽水區農會　　　　　　　　　　　　　　　"},
  {"code": "6180069", "name": "佳里區農會　　　　　　　　　　　　　　　"},
  {"code": "6180081", "name": "善化區農會　　　　　　　　　　　　　　　"},
  {"code": "6180092", "name": "柳營區農會　　　　　　　　　　　　　　　"},
  {"code": "6180139", "name": "六甲區農會　　　　　　　　　　　　　　　"},
  {"code": "6180162", "name": "西港區農會　　　　　　　　　　　　　　　"},
  {"code": "6180184", "name": "將軍區農會　　　　　　　　　　　　　　　"},
  {"code": "6180195", "name": "北門區農會　　　　　　　　　　　　　　　"},
  {"code": "6180243", "name": "臺南市玉井區農會　　　　　　　　　　　　"},
  {"code": "6180298", "name": "歸仁區農會　　　　　　　　　　　　　　　"},
  {"code": "6180324", "name": "永康區農會　　　　　　　　　　　　　　　"},
  {"code": "6180335", "name": "太子宮分部　　　　　　　　　　　　　　　"},
  {"code": "6180346", "name": "延平分部　　　　　　　　　　　　　　　　"},
  {"code": "6180357", "name": "歡雅分部　　　　　　　　　　　　　　　　"},
  {"code": "6180368", "name": "圣頭港分部　　　　　　　　　　　　　　　"},
  {"code": "6180416", "name": "佳興分部　　　　　　　　　　　　　　　　"},
  {"code": "6180427", "name": "子龍分部　　　　　　　　　　　　　　　　"},
  {"code": "6180438", "name": "塭內分部　　　　　　　　　　　　　　　　"},
  {"code": "6180449", "name": "延平分部　　　　　　　　　　　　　　　　"},
  {"code": "6180450", "name": "東關里分部　　　　　　　　　　　　　　　"},
  {"code": "6180461", "name": "六分寮分部　　　　　　　　　　　　　　　"},
  {"code": "6180472", "name": "重溪辦事處　　　　　　　　　　　　　　　"},
  {"code": "6180483", "name": "果毅辦事處　　　　　　　　　　　　　　　"},
  {"code": "6180494", "name": "太康辦事處　　　　　　　　　　　　　　　"},
  {"code": "6180508", "name": "旭山辦事處　　　　　　　　　　　　　　　"},
  {"code": "6180612", "name": "林鳳營分部　　　　　　　　　　　　　　　"},
  {"code": "6180689", "name": "後營分部　　　　　　　　　　　　　　　　"},
  {"code": "6180715", "name": "竹林分部　　　　　　　　　　　　　　　　"},
  {"code": "6180771", "name": "苓仔寮分部　　　　　　　　　　　　　　　"},
  {"code": "6180782", "name": "將軍分部　　　　　　　　　　　　　　　　"},
  {"code": "6180793", "name": "馬沙溝分部　　　　　　　　　　　　　　　"},
  {"code": "6180807", "name": "青鯤鯓分部　　　　　　　　　　　　　　　"},
  {"code": "6180818", "name": "溪底寮分部　　　　　　　　　　　　　　　"},
  {"code": "6180829", "name": "蚵寮分部　　　　　　　　　　　　　　　　"},
  {"code": "6180966", "name": "大潭武東分部　　　　　　　　　　　　　　"},
  {"code": "6180977", "name": "大廟分部　　　　　　　　　　　　　　　　"},
  {"code": "6180988", "name": "新市場分部　　　　　　　　　　　　　　　"},
  {"code": "6181011", "name": "大灣分部　　　　　　　　　　　　　　　　"},
  {"code": "6181066", "name": "三民分部　　　　　　　　　　　　　　　　"},
  {"code": "6181158", "name": "新生分部　　　　　　　　　　　　　　　　"},
  {"code": "6181181", "name": "鹽行分部　　　　　　　　　　　　　　　　"},
  {"code": "6181206", "name": "三慈分部　　　　　　　　　　　　　　　　"},
  {"code": "6181217", "name": "中正分部　　　　　　　　　　　　　　　　"},
  {"code": "6181239", "name": "歸南分部　　　　　　　　　　　　　　　　"},
  {"code": "6181240", "name": "中華分部　　　　　　　　　　　　　　　　"},
  {"code": "6181262", "name": "崑山分部　　　　　　　　　　　　　　　　"},
  {"code": "6181343", "name": "龍潭分部　　　　　　　　　　　　　　　　"},
  {"code": "6181365", "name": "茄拔分部　　　　　　　　　　　　　　　　"},
  {"code": "6181402", "name": "楠西區農會　　　　　　　　　　　　　　　"}
  ],
  "619": [
  {"code": "6190015", "name": "鳳山區農會　　　　　　　　　　　　　　　"},
  {"code": "6190026", "name": "岡山區農會　　　　　　　　　　　　　　　"},
  {"code": "6190037", "name": "旗山區農會　　　　　　　　　　　　　　　"},
  {"code": "6190048", "name": "美濃區農會　　　　　　　　　　　　　　　"},
  {"code": "6190059", "name": "橋頭區農會　　　　　　　　　　　　　　　"},
  {"code": "6190060", "name": "燕巢區農會　　　　　　　　　　　　　　　"},
  {"code": "6190071", "name": "田寮區農會　　　　　　　　　　　　　　　"},
  {"code": "6190082", "name": "阿蓮區農會　　　　　　　　　　　　　　　"},
  {"code": "6190093", "name": "路竹區農會　　　　　　　　　　　　　　　"},
  {"code": "6190107", "name": "湖內區農會　　　　　　　　　　　　　　　"},
  {"code": "6190118", "name": "茄萣區農會　　　　　　　　　　　　　　　"},
  {"code": "6190129", "name": "彌陀區農會　　　　　　　　　　　　　　　"},
  {"code": "6190130", "name": "永安區農會　　　　　　　　　　　　　　　"},
  {"code": "6190141", "name": "梓官區農會　　　　　　　　　　　　　　　"},
  {"code": "6190185", "name": "林園區農會　　　　　　　　　　　　　　　"},
  {"code": "6190196", "name": "大寮區農會　　　　　　　　　　　　　　　"},
  {"code": "6190211", "name": "仁武區農會　　　　　　　　　　　　　　　"},
  {"code": "6190222", "name": "大社區農會　　　　　　　　　　　　　　　"},
  {"code": "6190244", "name": "杉林區農會　　　　　　　　　　　　　　　"},
  {"code": "6190255", "name": "甲仙地區農會　　　　　　　　　　　　　　"},
  {"code": "6190266", "name": "五甲分部　　　　　　　　　　　　　　　　"},
  {"code": "6190277", "name": "市場分部　　　　　　　　　　　　　　　　"},
  {"code": "6190288", "name": "嘉興分部　　　　　　　　　　　　　　　　"},
  {"code": "6190299", "name": "仁壽分部　　　　　　　　　　　　　　　　"},
  {"code": "6190303", "name": "六龜區農會　　　　　　　　　　　　　　　"},
  {"code": "6190314", "name": "旗尾分部　　　　　　　　　　　　　　　　"},
  {"code": "6190325", "name": "溪洲分部　　　　　　　　　　　　　　　　"},
  {"code": "6190336", "name": "南溪洲分部　　　　　　　　　　　　　　　"},
  {"code": "6190347", "name": "嶺口分部　　　　　　　　　　　　　　　　"},
  {"code": "6190358", "name": "中正分部　　　　　　　　　　　　　　　　"},
  {"code": "6190369", "name": "中壇分部　　　　　　　　　　　　　　　　"},
  {"code": "6190370", "name": "龍肚分部　　　　　　　　　　　　　　　　"},
  {"code": "6190381", "name": "廣興分部　　　　　　　　　　　　　　　　"},
  {"code": "6190392", "name": "南隆分部　　　　　　　　　　　　　　　　"},
  {"code": "6190406", "name": "鳳雄分部　　　　　　　　　　　　　　　　"},
  {"code": "6190417", "name": "深水分部　　　　　　　　　　　　　　　　"},
  {"code": "6190428", "name": "竹滬分部　　　　　　　　　　　　　　　　"},
  {"code": "6190439", "name": "一甲分部　　　　　　　　　　　　　　　　"},
  {"code": "6190440", "name": "下坑分部　　　　　　　　　　　　　　　　"},
  {"code": "6190451", "name": "三爺分部　　　　　　　　　　　　　　　　"},
  {"code": "6190462", "name": "大湖分部　　　　　　　　　　　　　　　　"},
  {"code": "6190473", "name": "赤崁分部　　　　　　　　　　　　　　　　"},
  {"code": "6190484", "name": "大舍分部　　　　　　　　　　　　　　　　"},
  {"code": "6190495", "name": "梓官分部　　　　　　　　　　　　　　　　"},
  {"code": "6190565", "name": "大寮分部　　　　　　　　　　　　　　　　"},
  {"code": "6190576", "name": "中庄分部　　　　　　　　　　　　　　　　"},
  {"code": "6190587", "name": "後庄分部　　　　　　　　　　　　　　　　"},
  {"code": "6190598", "name": "昭明分部　　　　　　　　　　　　　　　　"},
  {"code": "6190602", "name": "潮寮分部　　　　　　　　　　　　　　　　"},
  {"code": "6190624", "name": "中路分部　　　　　　　　　　　　　　　　"},
  {"code": "6190646", "name": "南安分部　　　　　　　　　　　　　　　　"},
  {"code": "6190657", "name": "海埔分部　　　　　　　　　　　　　　　　"},
  {"code": "6190679", "name": "保寧分部　　　　　　　　　　　　　　　　"},
  {"code": "6190680", "name": "安招分部　　　　　　　　　　　　　　　　"},
  {"code": "6190716", "name": "橋頭分部　　　　　　　　　　　　　　　　"},
  {"code": "6190727", "name": "灣內分部　　　　　　　　　　　　　　　　"},
  {"code": "6190738", "name": "老爺分部　　　　　　　　　　　　　　　　"},
  {"code": "6190749", "name": "市場分部　　　　　　　　　　　　　　　　"},
  {"code": "6190761", "name": "維新分部　　　　　　　　　　　　　　　　"},
  {"code": "6190772", "name": "協榮分部　　　　　　　　　　　　　　　　"},
  {"code": "6190783", "name": "壽齡分部　　　　　　　　　　　　　　　　"},
  {"code": "6190794", "name": "新興分部　　　　　　　　　　　　　　　　"},
  {"code": "6190808", "name": "崇德分部　　　　　　　　　　　　　　　　"},
  {"code": "6190819", "name": "桃源分部　　　　　　　　　　　　　　　　"},
  {"code": "6190831", "name": "中厝分部　　　　　　　　　　　　　　　　"},
  {"code": "6190864", "name": "文山分部　　　　　　　　　　　　　　　　"},
  {"code": "6190886", "name": "東區分部　　　　　　　　　　　　　　　　"},
  {"code": "6190897", "name": "鎮北分部　　　　　　　　　　　　　　　　"},
  {"code": "6190901", "name": "甲圍辦事處　　　　　　　　　　　　　　　"},
  {"code": "6190923", "name": "隆豐和分部　　　　　　　　　　　　　　　"},
  {"code": "6190934", "name": "五林分部　　　　　　　　　　　　　　　　"},
  {"code": "6190967", "name": "仁美分部　　　　　　　　　　　　　　　　"},
  {"code": "6190978", "name": "溝坪分部　　　　　　　　　　　　　　　　"},
  {"code": "6190989", "name": "那瑪夏分部　　　　　　　　　　　　　　　"},
  {"code": "6190990", "name": "過埤分部　　　　　　　　　　　　　　　　"},
  {"code": "6191001", "name": "觀亭分部　　　　　　　　　　　　　　　　"},
  {"code": "6191012", "name": "翁園分部　　　　　　　　　　　　　　　　"},
  {"code": "6191023", "name": "大灣分部　　　　　　　　　　　　　　　　"},
  {"code": "6191045", "name": "八卦分部　　　　　　　　　　　　　　　　"},
  {"code": "6191067", "name": "後紅分部　　　　　　　　　　　　　　　　"},
  {"code": "6191078", "name": "復安分部　　　　　　　　　　　　　　　　"},
  {"code": "6191089", "name": "鳥松區農會　　　　　　　　　　　　　　　"},
  {"code": "6191090", "name": "澄清湖分部　　　　　　　　　　　　　　　"},
  {"code": "6191104", "name": "大樹區農會　　　　　　　　　　　　　　　"},
  {"code": "6191115", "name": "內門區農會　　　　　　　　　　　　　　　"}
  ],
  "620": [
  {"code": "6200031", "name": "東港鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6200042", "name": "恆春鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6200075", "name": "麟洛鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6200086", "name": "九如鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6200112", "name": "里港鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6200167", "name": "崁頂鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6200189", "name": "南州地區農會　　　　　　　　　　　　　　"},
  {"code": "6200204", "name": "琉球鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6200215", "name": "滿州鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6200259", "name": "枋山地區農會　　　　　　　　　　　　　　"},
  {"code": "6200330", "name": "土庫辦事處　　　　　　　　　　　　　　　"},
  {"code": "6200341", "name": "載興辦事處　　　　　　　　　　　　　　　"},
  {"code": "6200547", "name": "墾丁分部　　　　　　　　　　　　　　　　"},
  {"code": "6200628", "name": "三廓分部　　　　　　　　　　　　　　　　"},
  {"code": "6200709", "name": "力社分部　　　　　　　　　　　　　　　　"},
  {"code": "6200710", "name": "港東分部　　　　　　　　　　　　　　　　"},
  {"code": "6200721", "name": "下部分部　　　　　　　　　　　　　　　　"},
  {"code": "6200743", "name": "枋山分部　　　　　　　　　　　　　　　　"},
  {"code": "6200754", "name": "加祿分部　　　　　　　　　　　　　　　　"},
  {"code": "6200787", "name": "洽興分部　　　　　　　　　　　　　　　　"},
  {"code": "6200813", "name": "新埤分部　　　　　　　　　　　　　　　　"},
  {"code": "6200868", "name": "屏東市農會　　　　　　　　　　　　　　　"},
  {"code": "6200879", "name": "車城地區農會　　　　　　　　　　　　　　"},
  {"code": "6200880", "name": "屏東縣農會　　　　　　　　　　　　　　　"},
  {"code": "6200891", "name": "枋寮地區農會　　　　　　　　　　　　　　"},
  {"code": "6200905", "name": "竹田鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6200916", "name": "萬丹鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6200927", "name": "長治鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6200938", "name": "林邊鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6200949", "name": "佳冬鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6200950", "name": "塔樓分部　　　　　　　　　　　　　　　　"},
  {"code": "6200961", "name": "高樹鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6200972", "name": "萬巒地區農會　　　　　　　　　　　　　　"},
  {"code": "6200983", "name": "潮州鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6200994", "name": "新園鄉農會　　　　　　　　　　　　　　　"}
  ],
  "621": [
  {"code": "6210021", "name": "吉安鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6210032", "name": "壽豐鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6210043", "name": "富里鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6210098", "name": "新秀地區農會　　　　　　　　　　　　　　"},
  {"code": "6210102", "name": "仁里分部　　　　　　　　　　　　　　　　"},
  {"code": "6210124", "name": "志學分部　　　　　　　　　　　　　　　　"},
  {"code": "6210135", "name": "東竹分部　　　　　　　　　　　　　　　　"},
  {"code": "6210146", "name": "東里分部　　　　　　　　　　　　　　　　"},
  {"code": "6210191", "name": "新城分部　　　　　　　　　　　　　　　　"},
  {"code": "6210205", "name": "嘉里分部　　　　　　　　　　　　　　　　"},
  {"code": "6210216", "name": "秀林分部　　　　　　　　　　　　　　　　"},
  {"code": "6210227", "name": "北昌分部　　　　　　　　　　　　　　　　"},
  {"code": "6210238", "name": "宜昌分部　　　　　　　　　　　　　　　　"},
  {"code": "6210331", "name": "豐裡分部　　　　　　　　　　　　　　　　"}
  ],
  "622": [
  {"code": "6220011", "name": "關山鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6220022", "name": "成功鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6220033", "name": "池上鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6220044", "name": "東河分部　　　　　　　　　　　　　　　　"},
  {"code": "6220055", "name": "長濱鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6220066", "name": "台東地區農會　　　　　　　　　　　　　　"},
  {"code": "6220077", "name": "鹿野地區農會　　　　　　　　　　　　　　"},
  {"code": "6220088", "name": "太麻里地區農會　　　　　　　　　　　　　"},
  {"code": "6220099", "name": "豐里分部　　　　　　　　　　　　　　　　"},
  {"code": "6220103", "name": "東河鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6220114", "name": "泰源分部　　　　　　　　　　　　　　　　"},
  {"code": "6220125", "name": "台東分部　　　　　　　　　　　　　　　　"},
  {"code": "6220136", "name": "知本分部　　　　　　　　　　　　　　　　"},
  {"code": "6220147", "name": "綠島分部　　　　　　　　　　　　　　　　"},
  {"code": "6220158", "name": "初鹿分部　　　　　　　　　　　　　　　　"},
  {"code": "6220169", "name": "瑞源分部　　　　　　　　　　　　　　　　"},
  {"code": "6220170", "name": "美和分部　　　　　　　　　　　　　　　　"},
  {"code": "6220181", "name": "金崙分部　　　　　　　　　　　　　　　　"},
  {"code": "6220192", "name": "大武分部　　　　　　　　　　　　　　　　"},
  {"code": "6220206", "name": "忠孝分部　　　　　　　　　　　　　　　　"},
  {"code": "6220217", "name": "太平分部　　　　　　　　　　　　　　　　"},
  {"code": "6220228", "name": "蘭嶼分部　　　　　　　　　　　　　　　　"},
  {"code": "6220239", "name": "海端分部　　　　　　　　　　　　　　　　"},
  {"code": "6220240", "name": "瑞豐分部　　　　　　　　　　　　　　　　"},
  {"code": "6220251", "name": "信義分部　　　　　　　　　　　　　　　　"},
  {"code": "6220284", "name": "新園分部　　　　　　　　　　　　　　　　"}
  ],
  "624": [
  {"code": "6240013", "name": "澎湖縣農會信用部　　　　　　　　　　　　"},
  {"code": "6240024", "name": "湖西分部　　　　　　　　　　　　　　　　"},
  {"code": "6240035", "name": "西嶼分部　　　　　　　　　　　　　　　　"},
  {"code": "6240046", "name": "望安分部　　　　　　　　　　　　　　　　"},
  {"code": "6240057", "name": "白沙分部　　　　　　　　　　　　　　　　"},
  {"code": "6240068", "name": "七美分部　　　　　　　　　　　　　　　　"}
  ],
  "625": [
  {"code": "6250014", "name": "臺中地區農會信用部　　　　　　　　　　　"},
  {"code": "6250025", "name": "西屯分部　　　　　　　　　　　　　　　　"},
  {"code": "6250036", "name": "北屯分部　　　　　　　　　　　　　　　　"},
  {"code": "6250047", "name": "南屯分部　　　　　　　　　　　　　　　　"},
  {"code": "6250058", "name": "四民分部　　　　　　　　　　　　　　　　"},
  {"code": "6250069", "name": "西區分部　　　　　　　　　　　　　　　　"},
  {"code": "6250070", "name": "東區分部　　　　　　　　　　　　　　　　"},
  {"code": "6250092", "name": "南區分部　　　　　　　　　　　　　　　　"},
  {"code": "6250117", "name": "北區分部　　　　　　　　　　　　　　　　"},
  {"code": "6250139", "name": "軍功分部　　　　　　　　　　　　　　　　"},
  {"code": "6250140", "name": "大坑分部　　　　　　　　　　　　　　　　"}
  ],
  "627": [
  {"code": "6270016", "name": "連江縣農會　　　　　　　　　　　　　　　"}
  ],
  "628": [
  {"code": "6280017", "name": "鹿港鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6280028", "name": "頂番分部　　　　　　　　　　　　　　　　"},
  {"code": "6280039", "name": "草港分部　　　　　　　　　　　　　　　　"},
  {"code": "6280040", "name": "東崎分部　　　　　　　　　　　　　　　　"},
  {"code": "6280051", "name": "海埔分部　　　　　　　　　　　　　　　　"}
  ],
  "629": [
  {"code": "6290018", "name": "和美鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6290029", "name": "塗厝分部　　　　　　　　　　　　　　　　"},
  {"code": "6290030", "name": "新庄分部　　　　　　　　　　　　　　　　"},
  {"code": "6290041", "name": "鎮平分部　　　　　　　　　　　　　　　　"}
  ],
  "631": [
  {"code": "6310013", "name": "溪湖鎮農會　　　　　　　　　　　　　　　"}
  ],
  "632": [
  {"code": "6320014", "name": "田中鎮農會　　　　　　　　　　　　　　　"}
  ],
  "633": [
  {"code": "6330015", "name": "北斗鎮農會　　　　　　　　　　　　　　　"}
  ],
  "635": [
  {"code": "6350017", "name": "線西鄉農會　　　　　　　　　　　　　　　"}
  ],
  "636": [
  {"code": "6360018", "name": "伸港鄉農會　　　　　　　　　　　　　　　"}
  ],
  "638": [
  {"code": "6380010", "name": "花壇鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6380021", "name": "白沙分部　　　　　　　　　　　　　　　　"},
  {"code": "6380032", "name": "灣雅分部　　　　　　　　　　　　　　　　"},
  {"code": "6380043", "name": "口庄分部　　　　　　　　　　　　　　　　"},
  {"code": "6380054", "name": "長沙分部　　　　　　　　　　　　　　　　"}
  ],
  "639": [
  {"code": "6390011", "name": "大村鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6390022", "name": "大村分部　　　　　　　　　　　　　　　　"},
  {"code": "6390033", "name": "美港分部　　　　　　　　　　　　　　　　"},
  {"code": "6390044", "name": "大西分部　　　　　　　　　　　　　　　　"},
  {"code": "6390055", "name": "村東分部　　　　　　　　　　　　　　　　"}
  ],
  "642": [
  {"code": "6420017", "name": "社頭鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6420028", "name": "湳雅分部　　　　　　　　　　　　　　　　"},
  {"code": "6420039", "name": "橋頭分部　　　　　　　　　　　　　　　　"},
  {"code": "6420040", "name": "清水分部　　　　　　　　　　　　　　　　"}
  ],
  "643": [
  {"code": "6430018", "name": "二水鄉農會　　　　　　　　　　　　　　　"}
  ],
  "646": [
  {"code": "6460011", "name": "大城鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6460022", "name": "西港分部　　　　　　　　　　　　　　　　"}
  ],
  "647": [
  {"code": "6470012", "name": "溪州鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6470023", "name": "西畔分部　　　　　　　　　　　　　　　　"},
  {"code": "6470034", "name": "大庄分部　　　　　　　　　　　　　　　　"}
  ],
  "649": [
  {"code": "6490014", "name": "埔鹽鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6490025", "name": "新水分部　　　　　　　　　　　　　　　　"}
  ],
  "650": [
  {"code": "6500018", "name": "福興鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6500029", "name": "管嶼分部　　　　　　　　　　　　　　　　"},
  {"code": "6500030", "name": "外中分部　　　　　　　　　　　　　　　　"}
  ],
  "651": [
  {"code": "6510019", "name": "彰化市農會　　　　　　　　　　　　　　　"}
  ],
  "683": [
  {"code": "6830010", "name": "北港鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6830021", "name": "好收分部　　　　　　　　　　　　　　　　"}
  ],
  "685": [
  {"code": "6850012", "name": "土庫鎮農會　　　　　　　　　　　　　　　"},
  {"code": "6850023", "name": "馬光分部　　　　　　　　　　　　　　　　"},
  {"code": "6850034", "name": "新庄分部　　　　　　　　　　　　　　　　"},
  {"code": "6850045", "name": "忠正分部　　　　　　　　　　　　　　　　"},
  {"code": "6850056", "name": "後埔分部　　　　　　　　　　　　　　　　"}
  ],
  "693": [
  {"code": "6930013", "name": "東勢鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6930024", "name": "新坤分部　　　　　　　　　　　　　　　　"}
  ],
  "696": [
  {"code": "6960016", "name": "水林鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6960027", "name": "蔦松分部　　　　　　　　　　　　　　　　"},
  {"code": "6960038", "name": "宏仁分部　　　　　　　　　　　　　　　　"},
  {"code": "6960049", "name": "西井分部　　　　　　　　　　　　　　　　"},
  {"code": "6960050", "name": "溪墘分部　　　　　　　　　　　　　　　　"}
  ],
  "697": [
  {"code": "6970017", "name": "元長鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6970028", "name": "客庴分部　　　　　　　　　　　　　　　　"},
  {"code": "6970039", "name": "鹿寮分部　　　　　　　　　　　　　　　　"}
  ],
  "698": [
  {"code": "6980018", "name": "麥寮鄉農會　　　　　　　　　　　　　　　"},
  {"code": "6980029", "name": "橋頭分部　　　　　　　　　　　　　　　　"}
  ],
  "699": [
  {"code": "6990019", "name": "林內鄉農會　　　　　　　　　　　　　　　"}
  ],
  "700": [
  {"code": "7000010", "name": "郵政劃撥儲金　　　　　　　　　　　　　　"},
  {"code": "7000021", "name": "郵政存簿儲金　　　　　　　　　　　　　　"}
  ],
  "749": [
  {"code": "7490011", "name": "內埔地區農會　　　　　　　　　　　　　　"},
  {"code": "7490022", "name": "龍泉分部　　　　　　　　　　　　　　　　"},
  {"code": "7490033", "name": "水門分部　　　　　　　　　　　　　　　　"},
  {"code": "7490044", "name": "東勢分部　　　　　　　　　　　　　　　　"},
  {"code": "7490055", "name": "豐田分部　　　　　　　　　　　　　　　　"},
  {"code": "7490066", "name": "老埤分部　　　　　　　　　　　　　　　　"}
  ],
  "762": [
  {"code": "7620010", "name": "大溪區農會　　　　　　　　　　　　　　　"},
  {"code": "7620021", "name": "一心分部　　　　　　　　　　　　　　　　"},
  {"code": "7620032", "name": "中新分部　　　　　　　　　　　　　　　　"},
  {"code": "7620043", "name": "新峰分部　　　　　　　　　　　　　　　　"},
  {"code": "7620054", "name": "埔頂分部　　　　　　　　　　　　　　　　"},
  {"code": "7620065", "name": "員林分部　　　　　　　　　　　　　　　　"},
  {"code": "7620076", "name": "僑愛分部　　　　　　　　　　　　　　　　"},
  {"code": "7620087", "name": "崎頂分部　　　　　　　　　　　　　　　　"},
  {"code": "7620098", "name": "南興分部　　　　　　　　　　　　　　　　"}
  ],
  "763": [
  {"code": "7630011", "name": "桃園區農會　　　　　　　　　　　　　　　"},
  {"code": "7630022", "name": "大林分部　　　　　　　　　　　　　　　　"},
  {"code": "7630033", "name": "會稽分部　　　　　　　　　　　　　　　　"},
  {"code": "7630055", "name": "中路分部　　　　　　　　　　　　　　　　"},
  {"code": "7630066", "name": "慈文分部　　　　　　　　　　　　　　　　"},
  {"code": "7630077", "name": "埔子分部　　　　　　　　　　　　　　　　"},
  {"code": "7630088", "name": "龍山分部　　　　　　　　　　　　　　　　"}
  ],
  "764": [
  {"code": "7640012", "name": "平鎮區農會　　　　　　　　　　　　　　　"},
  {"code": "7640023", "name": "北勢分部　　　　　　　　　　　　　　　　"},
  {"code": "7640034", "name": "山峰分部　　　　　　　　　　　　　　　　"},
  {"code": "7640045", "name": "龍岡分部　　　　　　　　　　　　　　　　"},
  {"code": "7640056", "name": "宋屋分部　　　　　　　　　　　　　　　　"},
  {"code": "7640067", "name": "金陵分部　　　　　　　　　　　　　　　　"}
  ],
  "765": [
  {"code": "7650013", "name": "楊梅區農會　　　　　　　　　　　　　　　"},
  {"code": "7650035", "name": "埔心分部　　　　　　　　　　　　　　　　"},
  {"code": "7650046", "name": "富岡分部　　　　　　　　　　　　　　　　"},
  {"code": "7650057", "name": "老街分部　　　　　　　　　　　　　　　　"}
  ],
  "766": [
  {"code": "7660014", "name": "大園區農會　　　　　　　　　　　　　　　"},
  {"code": "7660025", "name": "埔心分部　　　　　　　　　　　　　　　　"},
  {"code": "7660036", "name": "竹圍分部　　　　　　　　　　　　　　　　"},
  {"code": "7660047", "name": "三和分部　　　　　　　　　　　　　　　　"},
  {"code": "7660058", "name": "和平分部　　　　　　　　　　　　　　　　"},
  {"code": "7660069", "name": "五權分部　　　　　　　　　　　　　　　　"},
  {"code": "7660070", "name": "潮音分部　　　　　　　　　　　　　　　　"},
  {"code": "7660081", "name": "青埔分部　　　　　　　　　　　　　　　　"}
  ],
  "767": [
  {"code": "7670015", "name": "蘆竹區農會　　　　　　　　　　　　　　　"},
  {"code": "7670026", "name": "新興分部　　　　　　　　　　　　　　　　"},
  {"code": "7670037", "name": "山腳分部　　　　　　　　　　　　　　　　"},
  {"code": "7670048", "name": "宏竹分部　　　　　　　　　　　　　　　　"},
  {"code": "7670059", "name": "大竹分部　　　　　　　　　　　　　　　　"},
  {"code": "7670060", "name": "外社分部　　　　　　　　　　　　　　　　"},
  {"code": "7670071", "name": "蘆竹分部　　　　　　　　　　　　　　　　"},
  {"code": "7670082", "name": "中福分部　　　　　　　　　　　　　　　　"},
  {"code": "7670093", "name": "五福分部　　　　　　　　　　　　　　　　"},
  {"code": "7670107", "name": "海湖分部　　　　　　　　　　　　　　　　"}
  ],
  "768": [
  {"code": "7680016", "name": "龜山區農會　　　　　　　　　　　　　　　"},
  {"code": "7680027", "name": "大崗分部　　　　　　　　　　　　　　　　"},
  {"code": "7680038", "name": "山頂分部　　　　　　　　　　　　　　　　"},
  {"code": "7680049", "name": "龍壽分部　　　　　　　　　　　　　　　　"},
  {"code": "7680050", "name": "南上分部　　　　　　　　　　　　　　　　"},
  {"code": "7680061", "name": "公西分部　　　　　　　　　　　　　　　　"},
  {"code": "7680072", "name": "嶺頂分部　　　　　　　　　　　　　　　　"},
  {"code": "7680083", "name": "山福分部　　　　　　　　　　　　　　　　"},
  {"code": "7680094", "name": "舊路分部　　　　　　　　　　　　　　　　"},
  {"code": "7680108", "name": "樂善分部　　　　　　　　　　　　　　　　"}
  ],
  "769": [
  {"code": "7690017", "name": "八德區農會　　　　　　　　　　　　　　　"},
  {"code": "7690028", "name": "大湳分部　　　　　　　　　　　　　　　　"},
  {"code": "7690039", "name": "瑞豐分部　　　　　　　　　　　　　　　　"},
  {"code": "7690040", "name": "大福分部　　　　　　　　　　　　　　　　"},
  {"code": "7690051", "name": "茄苳分部　　　　　　　　　　　　　　　　"},
  {"code": "7690062", "name": "桃鶯分部　　　　　　　　　　　　　　　　"},
  {"code": "7690073", "name": "霄裡分部　　　　　　　　　　　　　　　　"}
  ],
  "770": [
  {"code": "7700011", "name": "新屋區農會　　　　　　　　　　　　　　　"},
  {"code": "7700022", "name": "永安分部　　　　　　　　　　　　　　　　"},
  {"code": "7700033", "name": "大坡分部　　　　　　　　　　　　　　　　"},
  {"code": "7700066", "name": "高榮分部　　　　　　　　　　　　　　　　"}
  ],
  "771": [
  {"code": "7710012", "name": "龍潭區農會　　　　　　　　　　　　　　　"},
  {"code": "7710023", "name": "中興分部　　　　　　　　　　　　　　　　"},
  {"code": "7710034", "name": "烏林分部　　　　　　　　　　　　　　　　"},
  {"code": "7710045", "name": "高平分部　　　　　　　　　　　　　　　　"},
  {"code": "7710056", "name": "八德分部　　　　　　　　　　　　　　　　"}
  ],
  "772": [
  {"code": "7720013", "name": "復興區農會　　　　　　　　　　　　　　　"},
  {"code": "7720024", "name": "三民分部　　　　　　　　　　　　　　　　"}
  ],
  "773": [
  {"code": "7730014", "name": "觀音區農會　　　　　　　　　　　　　　　"}
  ],
  "775": [
  {"code": "7750016", "name": "土城區農會　　　　　　　　　　　　　　　"},
  {"code": "7750027", "name": "清水分部　　　　　　　　　　　　　　　　"},
  {"code": "7750038", "name": "貨饒分部　　　　　　　　　　　　　　　　"},
  {"code": "7750049", "name": "頂埔分部　　　　　　　　　　　　　　　　"},
  {"code": "7750050", "name": "峰廷分部　　　　　　　　　　　　　　　　"},
  {"code": "7750061", "name": "廣福分部　　　　　　　　　　　　　　　　"},
  {"code": "7750072", "name": "永豐分部　　　　　　　　　　　　　　　　"}
  ],
  "776": [
  {"code": "7760017", "name": "三重區農會　　　　　　　　　　　　　　　"},
  {"code": "7760028", "name": "溪美分部　　　　　　　　　　　　　　　　"},
  {"code": "7760040", "name": "三民分部　　　　　　　　　　　　　　　　"},
  {"code": "7760051", "name": "力行分部　　　　　　　　　　　　　　　　"},
  {"code": "7760062", "name": "光復分部　　　　　　　　　　　　　　　　"},
  {"code": "7760073", "name": "成功分部　　　　　　　　　　　　　　　　"},
  {"code": "7760084", "name": "慈福分部　　　　　　　　　　　　　　　　"}
  ],
  "777": [
  {"code": "7770018", "name": "中和地區農會　　　　　　　　　　　　　　"},
  {"code": "7770029", "name": "中正分部　　　　　　　　　　　　　　　　"},
  {"code": "7770030", "name": "員山分部　　　　　　　　　　　　　　　　"},
  {"code": "7770063", "name": "興南分部　　　　　　　　　　　　　　　　"},
  {"code": "7770085", "name": "民享分部　　　　　　　　　　　　　　　　"},
  {"code": "7770096", "name": "連城分部　　　　　　　　　　　　　　　　"},
  {"code": "7770111", "name": "仁愛分部　　　　　　　　　　　　　　　　"},
  {"code": "7770122", "name": "錦和分部　　　　　　　　　　　　　　　　"},
  {"code": "7770133", "name": "智光分部　　　　　　　　　　　　　　　　"},
  {"code": "7770166", "name": "竹林分部　　　　　　　　　　　　　　　　"}
  ],
  "778": [
  {"code": "7780019", "name": "淡水區農會　　　　　　　　　　　　　　　"},
  {"code": "7780020", "name": "竹圍分部　　　　　　　　　　　　　　　　"},
  {"code": "7780031", "name": "中興分部　　　　　　　　　　　　　　　　"},
  {"code": "7780042", "name": "水碓分部　　　　　　　　　　　　　　　　"},
  {"code": "7780053", "name": "義山分部　　　　　　　　　　　　　　　　"},
  {"code": "7780064", "name": "新興分部　　　　　　　　　　　　　　　　"},
  {"code": "7780075", "name": "福德分部　　　　　　　　　　　　　　　　"}
  ],
  "779": [
  {"code": "7790010", "name": "樹林區農會　　　　　　　　　　　　　　　"},
  {"code": "7790021", "name": "柑園分部　　　　　　　　　　　　　　　　"},
  {"code": "7790032", "name": "山佳分部　　　　　　　　　　　　　　　　"},
  {"code": "7790043", "name": "三多分部　　　　　　　　　　　　　　　　"},
  {"code": "7790054", "name": "大同分部　　　　　　　　　　　　　　　　"},
  {"code": "7790065", "name": "保安分部　　　　　　　　　　　　　　　　"},
  {"code": "7790113", "name": "復興分部　　　　　　　　　　　　　　　　"},
  {"code": "7790124", "name": "東山分部　　　　　　　　　　　　　　　　"},
  {"code": "7790135", "name": "金寮分部　　　　　　　　　　　　　　　　"},
  {"code": "7790157", "name": "圳安分部　　　　　　　　　　　　　　　　"},
  {"code": "7790168", "name": "大學城分部　　　　　　　　　　　　　　　"}
  ],
  "780": [
  {"code": "7800014", "name": "鶯歌區農會　　　　　　　　　　　　　　　"},
  {"code": "7800025", "name": "二橋分部　　　　　　　　　　　　　　　　"},
  {"code": "7800036", "name": "鳳鳴分部　　　　　　　　　　　　　　　　"},
  {"code": "7800047", "name": "永昌分部　　　　　　　　　　　　　　　　"}
  ],
  "781": [
  {"code": "7810015", "name": "三峽區農會　　　　　　　　　　　　　　　"},
  {"code": "7810026", "name": "大埔分部　　　　　　　　　　　　　　　　"},
  {"code": "7810037", "name": "成福分部　　　　　　　　　　　　　　　　"},
  {"code": "7810048", "name": "橫溪分部　　　　　　　　　　　　　　　　"},
  {"code": "7810059", "name": "民生分部　　　　　　　　　　　　　　　　"},
  {"code": "7810060", "name": "北大分部　　　　　　　　　　　　　　　　"}
  ],
  "785": [
  {"code": "7850019", "name": "蘆洲區農會　　　　　　　　　　　　　　　"},
  {"code": "7850020", "name": "成功分部　　　　　　　　　　　　　　　　"},
  {"code": "7850031", "name": "長安分部　　　　　　　　　　　　　　　　"},
  {"code": "7850053", "name": "長榮分部　　　　　　　　　　　　　　　　"}
  ],
  "786": [
  {"code": "7860010", "name": "五股區農會　　　　　　　　　　　　　　　"},
  {"code": "7860021", "name": "興珍分部　　　　　　　　　　　　　　　　"},
  {"code": "7860032", "name": "成州分部　　　　　　　　　　　　　　　　"},
  {"code": "7860043", "name": "德泰分部　　　　　　　　　　　　　　　　"},
  {"code": "7860054", "name": "五福分部　　　　　　　　　　　　　　　　"},
  {"code": "7860065", "name": "德音分部　　　　　　　　　　　　　　　　"},
  {"code": "7860076", "name": "成德分部　　　　　　　　　　　　　　　　"},
  {"code": "7860087", "name": "成功分部　　　　　　　　　　　　　　　　"}
  ],
  "787": [
  {"code": "7870011", "name": "林口區農會　　　　　　　　　　　　　　　"},
  {"code": "7870022", "name": "南勢分部　　　　　　　　　　　　　　　　"}
  ],
  "788": [
  {"code": "7880012", "name": "泰山區農會　　　　　　　　　　　　　　　"},
  {"code": "7880023", "name": "貴子分部　　　　　　　　　　　　　　　　"},
  {"code": "7880034", "name": "明志分部　　　　　　　　　　　　　　　　"},
  {"code": "7880045", "name": "貴和分部　　　　　　　　　　　　　　　　"},
  {"code": "7880056", "name": "泰友分部　　　　　　　　　　　　　　　　"},
  {"code": "7880067", "name": "泰林分部　　　　　　　　　　　　　　　　"}
  ],
  "789": [
  {"code": "7890013", "name": "坪林區農會　　　　　　　　　　　　　　　"}
  ],
  "790": [
  {"code": "7900017", "name": "八里區農會　　　　　　　　　　　　　　　"},
  {"code": "7900028", "name": "龍形分部　　　　　　　　　　　　　　　　"},
  {"code": "7900039", "name": "埤頭分部　　　　　　　　　　　　　　　　"}
  ],
  "791": [
  {"code": "7910018", "name": "金山地區農會　　　　　　　　　　　　　　"},
  {"code": "7910029", "name": "萬里分部　　　　　　　　　　　　　　　　"},
  {"code": "7910030", "name": "野柳分部　　　　　　　　　　　　　　　　"}
  ],
  "792": [
  {"code": "7920019", "name": "瑞芳地區農會　　　　　　　　　　　　　　"},
  {"code": "7920020", "name": "雙溪分部　　　　　　　　　　　　　　　　"},
  {"code": "7920031", "name": "貢寮分部　　　　　　　　　　　　　　　　"},
  {"code": "7920042", "name": "澳底分部　　　　　　　　　　　　　　　　"},
  {"code": "7920053", "name": "龍興分部　　　　　　　　　　　　　　　　"},
  {"code": "7920064", "name": "四腳亭分部　　　　　　　　　　　　　　　"},
  {"code": "7920075", "name": "福隆分部　　　　　　　　　　　　　　　　"}
  ],
  "793": [
  {"code": "7930010", "name": "新店地區農會　　　　　　　　　　　　　　"},
  {"code": "7930021", "name": "中正分部　　　　　　　　　　　　　　　　"},
  {"code": "7930032", "name": "烏來分部　　　　　　　　　　　　　　　　"},
  {"code": "7930043", "name": "安康分部　　　　　　　　　　　　　　　　"},
  {"code": "7930054", "name": "青潭分部　　　　　　　　　　　　　　　　"},
  {"code": "7930065", "name": "德安分部　　　　　　　　　　　　　　　　"},
  {"code": "7930076", "name": "新和分部　　　　　　　　　　　　　　　　"}
  ],
  "795": [
  {"code": "7950012", "name": "深坑區農會　　　　　　　　　　　　　　　"},
  {"code": "7950023", "name": "萬順分部　　　　　　　　　　　　　　　　"}
  ],
  "796": [
  {"code": "7960013", "name": "石碇區農會　　　　　　　　　　　　　　　"}
  ],
  "797": [
  {"code": "7970014", "name": "平溪區農會　　　　　　　　　　　　　　　"}
  ],
  "798": [
  {"code": "7980015", "name": "石門區農會　　　　　　　　　　　　　　　"},
  {"code": "7980026", "name": "老梅分部　　　　　　　　　　　　　　　　"}
  ],
  "799": [
  {"code": "7990016", "name": "三芝區農會　　　　　　　　　　　　　　　"},
  {"code": "7990027", "name": "北新庄分部　　　　　　　　　　　　　　　"}
  ],
  "803": [
  {"code": "8030010", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "8030021", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "8030032", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "8030043", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "8030054", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "8030065", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8030076", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "8030098", "name": "東台北分行　　　　　　　　　　　　　　　"},
  {"code": "8030102", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "8030113", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "8030124", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "8030135", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "8030157", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "8030168", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "8030179", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "8030180", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "8030205", "name": "九如分行　　　　　　　　　　　　　　　　"},
  {"code": "8030216", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "8030227", "name": "迴龍分行　　　　　　　　　　　　　　　　"},
  {"code": "8030238", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "8030249", "name": "公館分行　　　　　　　　　　　　　　　　"},
  {"code": "8030250", "name": "內壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8030261", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "8030272", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "8030283", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "8030294", "name": "桃鶯分行　　　　　　　　　　　　　　　　"},
  {"code": "8030308", "name": "龍潭分行　　　　　　　　　　　　　　　　"},
  {"code": "8030319", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "8030320", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "8030331", "name": "中山簡易型分行　　　　　　　　　　　　　"},
  {"code": "8030342", "name": "文心分行　　　　　　　　　　　　　　　　"},
  {"code": "8030353", "name": "健行分行　　　　　　　　　　　　　　　　"},
  {"code": "8030364", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "8030375", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8030386", "name": "大園分行　　　　　　　　　　　　　　　　"},
  {"code": "8030397", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "8030401", "name": "中港分行　　　　　　　　　　　　　　　　"},
  {"code": "8030412", "name": "通化簡易型分行　　　　　　　　　　　　　"},
  {"code": "8030423", "name": "士東分行　　　　　　　　　　　　　　　　"},
  {"code": "8030434", "name": "微風簡易型分行　　　　　　　　　　　　　"},
  {"code": "8030445", "name": "長春分行　　　　　　　　　　　　　　　　"},
  {"code": "8030456", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "8030467", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "8030478", "name": "永吉分行　　　　　　　　　　　　　　　　"},
  {"code": "8030489", "name": "文林分行　　　　　　　　　　　　　　　　"},
  {"code": "8030490", "name": "東門分行　　　　　　　　　　　　　　　　"},
  {"code": "8030504", "name": "敦化分行　　　　　　　　　　　　　　　　"},
  {"code": "8030515", "name": "西湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8030526", "name": "北投簡易型分行　　　　　　　　　　　　　"},
  {"code": "8030537", "name": "北三重分行　　　　　　　　　　　　　　　"},
  {"code": "8030548", "name": "後埔分行　　　　　　　　　　　　　　　　"},
  {"code": "8030559", "name": "北中和簡易型分行　　　　　　　　　　　　"},
  {"code": "8030560", "name": "富國分行　　　　　　　　　　　　　　　　"},
  {"code": "8030571", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "8030582", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "8030593", "name": "北桃園分行　　　　　　　　　　　　　　　"},
  {"code": "8030607", "name": "北中壢分行　　　　　　　　　　　　　　　"},
  {"code": "8030618", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "8030629", "name": "民權分行　　　　　　　　　　　　　　　　"},
  {"code": "8030630", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "8030641", "name": "興中分行　　　　　　　　　　　　　　　　"},
  {"code": "8030652", "name": "北屯分行　　　　　　　　　　　　　　　　"},
  {"code": "8030685", "name": "府城分行　　　　　　　　　　　　　　　　"},
  {"code": "8030696", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "8030700", "name": "富強分行　　　　　　　　　　　　　　　　"},
  {"code": "8030711", "name": "開元分行　　　　　　　　　　　　　　　　"},
  {"code": "8030722", "name": "南台南分行　　　　　　　　　　　　　　　"},
  {"code": "8030733", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "8030744", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "8030755", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "8030766", "name": "五甲分行　　　　　　　　　　　　　　　　"},
  {"code": "8030777", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "8030788", "name": "和平分行　　　　　　　　　　　　　　　　"},
  {"code": "8030799", "name": "永春分行　　　　　　　　　　　　　　　　"},
  {"code": "8030803", "name": "田心分行　　　　　　　　　　　　　　　　"},
  {"code": "8030814", "name": "安康分行　　　　　　　　　　　　　　　　"},
  {"code": "8030825", "name": "大竹分行　　　　　　　　　　　　　　　　"},
  {"code": "8030836", "name": "龜山分行　　　　　　　　　　　　　　　　"},
  {"code": "8030847", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "8030858", "name": "五股分行　　　　　　　　　　　　　　　　"},
  {"code": "8030869", "name": "高榮分行　　　　　　　　　　　　　　　　"},
  {"code": "8030870", "name": "大業分行　　　　　　　　　　　　　　　　"},
  {"code": "8030881", "name": "蘆竹分行　　　　　　　　　　　　　　　　"},
  {"code": "8030892", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "8030906", "name": "南桃園分行　　　　　　　　　　　　　　　"},
  {"code": "8030917", "name": "集賢分行　　　　　　　　　　　　　　　　"},
  {"code": "8030928", "name": "三峽分行　　　　　　　　　　　　　　　　"},
  {"code": "8030939", "name": "東湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8030940", "name": "淡水簡易型分行　　　　　　　　　　　　　"},
  {"code": "8030951", "name": "金城分行　　　　　　　　　　　　　　　　"}
  ],
  "805": [
  {"code": "8050012", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "8050023", "name": "台北城中分行　　　　　　　　　　　　　　"},
  {"code": "8050034", "name": "台北逸仙分行　　　　　　　　　　　　　　"},
  {"code": "8050045", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "8050056", "name": "台中公益分行　　　　　　　　　　　　　　"},
  {"code": "8050067", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "8050078", "name": "高雄五福分行　　　　　　　　　　　　　　"},
  {"code": "8050090", "name": "板橋南雅分行　　　　　　　　　　　　　　"},
  {"code": "8050104", "name": "新竹巨城分行　　　　　　　　　　　　　　"},
  {"code": "8050115", "name": "高雄中正分行　　　　　　　　　　　　　　"},
  {"code": "8050148", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "8050159", "name": "台北松江分行　　　　　　　　　　　　　　"},
  {"code": "8050160", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "8050171", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8050193", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "8050207", "name": "台北東門分行　　　　　　　　　　　　　　"},
  {"code": "8050218", "name": "高雄文化中心分行　　　　　　　　　　　　"},
  {"code": "8050229", "name": "台中文心分行　　　　　　　　　　　　　　"},
  {"code": "8050230", "name": "新竹科學園區分行　　　　　　　　　　　　"},
  {"code": "8050241", "name": "桃園大興分行　　　　　　　　　　　　　　"},
  {"code": "8050252", "name": "台北南門分行　　　　　　　　　　　　　　"},
  {"code": "8050263", "name": "台北新莊分行　　　　　　　　　　　　　　"},
  {"code": "8050274", "name": "台北松山分行　　　　　　　　　　　　　　"},
  {"code": "8050285", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "8050296", "name": "台北重慶分行　　　　　　　　　　　　　　"},
  {"code": "8050300", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "8050311", "name": "台北忠孝分行　　　　　　　　　　　　　　"},
  {"code": "8050322", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "8050333", "name": "板橋文化分行　　　　　　　　　　　　　　"},
  {"code": "8050344", "name": "台中自由分行　　　　　　　　　　　　　　"},
  {"code": "8050355", "name": "新莊富國分行　　　　　　　　　　　　　　"},
  {"code": "8050366", "name": "台北永吉分行　　　　　　　　　　　　　　"},
  {"code": "8050388", "name": "桃園大有分行　　　　　　　　　　　　　　"},
  {"code": "8050399", "name": "台北金湖簡易型分行　　　　　　　　　　　"},
  {"code": "8050403", "name": "台北農安簡易型分行　　　　　　　　　　　"},
  {"code": "8050414", "name": "台北中山分行　　　　　　　　　　　　　　"},
  {"code": "8050425", "name": "台北古亭分行　　　　　　　　　　　　　　"},
  {"code": "8050436", "name": "台北信義分行　　　　　　　　　　　　　　"},
  {"code": "8050458", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "8050469", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "8050470", "name": "板橋中正分行　　　　　　　　　　　　　　"},
  {"code": "8050481", "name": "新竹經國分行　　　　　　　　　　　　　　"},
  {"code": "8050492", "name": "台中大雅分行　　　　　　　　　　　　　　"},
  {"code": "8050506", "name": "台中朝富分行　　　　　　　　　　　　　　"},
  {"code": "8050517", "name": "南投分行　　　　　　　　　　　　　　　　"},
  {"code": "8050528", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "8050540", "name": "高雄博愛分行　　　　　　　　　　　　　　"},
  {"code": "8050562", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "8050573", "name": "崇德分行　　　　　　　　　　　　　　　　"},
  {"code": "8050584", "name": "板橋大遠百分行　　　　　　　　　　　　　"},
  {"code": "8050595", "name": "台北敦南分行　　　　　　　　　　　　　　"},
  {"code": "8050609", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "8050610", "name": "台北南京東路分行　　　　　　　　　　　　"},
  {"code": "8050621", "name": "台北大稻埕分行　　　　　　　　　　　　　"},
  {"code": "8050632", "name": "石牌分行　　　　　　　　　　　　　　　　"},
  {"code": "8050654", "name": "台北復興簡易型分行　　　　　　　　　　　"}
  ],
  "806": [
  {"code": "8060013", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "8060024", "name": "文心分行　　　　　　　　　　　　　　　　"},
  {"code": "8060035", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "8060046", "name": "沙鹿分行　　　　　　　　　　　　　　　　"},
  {"code": "8060057", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "8060068", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "8060079", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "8060080", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "8060091", "name": "平鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "8060105", "name": "草屯分行　　　　　　　　　　　　　　　　"},
  {"code": "8060116", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "8060150", "name": "景美分行　　　　　　　　　　　　　　　　"},
  {"code": "8060161", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "8060172", "name": "鹿港分行　　　　　　　　　　　　　　　　"},
  {"code": "8060183", "name": "斗信分行　　　　　　　　　　　　　　　　"},
  {"code": "8060194", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "8060219", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "8060220", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "8060231", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "8060242", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "8060253", "name": "博愛分行　　　　　　　　　　　　　　　　"},
  {"code": "8060264", "name": "苗栗分行　　　　　　　　　　　　　　　　"},
  {"code": "8060275", "name": "崇德分行　　　　　　　　　　　　　　　　"},
  {"code": "8060286", "name": "北斗分行　　　　　　　　　　　　　　　　"},
  {"code": "8060297", "name": "佳里分行　　　　　　　　　　　　　　　　"},
  {"code": "8060301", "name": "大甲分行　　　　　　　　　　　　　　　　"},
  {"code": "8060312", "name": "虎尾分行　　　　　　　　　　　　　　　　"},
  {"code": "8060334", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "8060345", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "8060367", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "8060378", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "8060389", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8060404", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "8060415", "name": "城中分行　　　　　　　　　　　　　　　　"},
  {"code": "8060426", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "8060448", "name": "斗南分行　　　　　　　　　　　　　　　　"},
  {"code": "8060482", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "8060493", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "8060518", "name": "三多分行　　　　　　　　　　　　　　　　"},
  {"code": "8060529", "name": "東信分行　　　　　　　　　　　　　　　　"},
  {"code": "8060585", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8060596", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "8060600", "name": "金門分行　　　　　　　　　　　　　　　　"},
  {"code": "8060611", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "8060622", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "8060633", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "8060688", "name": "府城分行　　　　　　　　　　　　　　　　"},
  {"code": "8060699", "name": "府東分行　　　　　　　　　　　　　　　　"},
  {"code": "8060806", "name": "開元分行　　　　　　　　　　　　　　　　"},
  {"code": "8060828", "name": "安和分行　　　　　　　　　　　　　　　　"},
  {"code": "8060839", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "8060840", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "8060851", "name": "竹科分行　　　　　　　　　　　　　　　　"},
  {"code": "8060862", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "8060873", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "8060884", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "8060895", "name": "中山北路分行　　　　　　　　　　　　　　"},
  {"code": "8060909", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "8060910", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "8060932", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "8060943", "name": "桃興分行　　　　　　　　　　　　　　　　"},
  {"code": "8060954", "name": "中港分行　　　　　　　　　　　　　　　　"},
  {"code": "8060965", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "8060976", "name": "承德分行　　　　　　　　　　　　　　　　"},
  {"code": "8060987", "name": "太平分行　　　　　　　　　　　　　　　　"},
  {"code": "8060998", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "8061009", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "8061021", "name": "大同分行　　　　　　　　　　　　　　　　"},
  {"code": "8061032", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "8061043", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "8061076", "name": "北三重分行　　　　　　　　　　　　　　　"},
  {"code": "8061087", "name": "上新莊分行　　　　　　　　　　　　　　　"},
  {"code": "8061102", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "8061191", "name": "大統分行　　　　　　　　　　　　　　　　"},
  {"code": "8061205", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "8061216", "name": "北投分行　　　　　　　　　　　　　　　　"},
  {"code": "8061227", "name": "延平分行　　　　　　　　　　　　　　　　"},
  {"code": "8061238", "name": "文德分行　　　　　　　　　　　　　　　　"},
  {"code": "8061250", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "8061261", "name": "埔墘分行　　　　　　　　　　　　　　　　"},
  {"code": "8061272", "name": "公館分行　　　　　　　　　　　　　　　　"},
  {"code": "8061283", "name": "新店中正分行　　　　　　　　　　　　　　"},
  {"code": "8061308", "name": "西門分行　　　　　　　　　　　　　　　　"},
  {"code": "8061319", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "8061320", "name": "光復分行　　　　　　　　　　　　　　　　"},
  {"code": "8061331", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "8061342", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "8061353", "name": "敦化分行　　　　　　　　　　　　　　　　"},
  {"code": "8061364", "name": "屏榮分行　　　　　　　　　　　　　　　　"},
  {"code": "8061375", "name": "前鎮中山分行　　　　　　　　　　　　　　"},
  {"code": "8061386", "name": "高鳳分行　　　　　　　　　　　　　　　　"},
  {"code": "8061397", "name": "北府分行　　　　　　　　　　　　　　　　"},
  {"code": "8061401", "name": "南嘉義分行　　　　　　　　　　　　　　　"},
  {"code": "8061412", "name": "東台北分行　　　　　　　　　　　　　　　"},
  {"code": "8061423", "name": "南新莊分行　　　　　　　　　　　　　　　"},
  {"code": "8061434", "name": "新壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8061445", "name": "水湳分行　　　　　　　　　　　　　　　　"},
  {"code": "8061456", "name": "大昌分行　　　　　　　　　　　　　　　　"},
  {"code": "8061467", "name": "華山分行　　　　　　　　　　　　　　　　"},
  {"code": "8061478", "name": "東板橋分行　　　　　　　　　　　　　　　"},
  {"code": "8061489", "name": "沙鹿中山分行　　　　　　　　　　　　　　"},
  {"code": "8061490", "name": "十全分行　　　　　　　　　　　　　　　　"},
  {"code": "8061504", "name": "延吉分行　　　　　　　　　　　　　　　　"},
  {"code": "8061526", "name": "成功分行　　　　　　　　　　　　　　　　"},
  {"code": "8061548", "name": "右昌分行　　　　　　　　　　　　　　　　"},
  {"code": "8061559", "name": "前金分行　　　　　　　　　　　　　　　　"},
  {"code": "8061560", "name": "五甲分行　　　　　　　　　　　　　　　　"},
  {"code": "8061571", "name": "連城分行　　　　　　　　　　　　　　　　"},
  {"code": "8061582", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "8061593", "name": "大和平分行　　　　　　　　　　　　　　　"},
  {"code": "8061607", "name": "金華分行　　　　　　　　　　　　　　　　"},
  {"code": "8061618", "name": "瑞光分行　　　　　　　　　　　　　　　　"},
  {"code": "8061629", "name": "灣裡分行　　　　　　　　　　　　　　　　"},
  {"code": "8061630", "name": "安南分行　　　　　　　　　　　　　　　　"},
  {"code": "8061641", "name": "江翠分行　　　　　　　　　　　　　　　　"},
  {"code": "8061652", "name": "長庚分行　　　　　　　　　　　　　　　　"},
  {"code": "8061674", "name": "世貿分行　　　　　　　　　　　　　　　　"},
  {"code": "8061685", "name": "東新竹分行　　　　　　　　　　　　　　　"},
  {"code": "8061696", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "8061700", "name": "忠誠分行　　　　　　　　　　　　　　　　"},
  {"code": "8061722", "name": "澄清分行　　　　　　　　　　　　　　　　"},
  {"code": "8061733", "name": "秀朗分行　　　　　　　　　　　　　　　　"},
  {"code": "8061744", "name": "小港分行　　　　　　　　　　　　　　　　"},
  {"code": "8061755", "name": "北桃園分行　　　　　　　　　　　　　　　"},
  {"code": "8061766", "name": "永春分行　　　　　　　　　　　　　　　　"},
  {"code": "8061777", "name": "圓山分行　　　　　　　　　　　　　　　　"},
  {"code": "8061788", "name": "豐仁分行　　　　　　　　　　　　　　　　"},
  {"code": "8061799", "name": "彰興分行　　　　　　　　　　　　　　　　"},
  {"code": "8061814", "name": "大里德芳分行　　　　　　　　　　　　　　"},
  {"code": "8061825", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "8061836", "name": "旗津分行　　　　　　　　　　　　　　　　"},
  {"code": "8061858", "name": "鼓山分行　　　　　　　　　　　　　　　　"},
  {"code": "8061869", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "8061870", "name": "明誠分行　　　　　　　　　　　　　　　　"},
  {"code": "8061881", "name": "中正分行　　　　　　　　　　　　　　　　"},
  {"code": "8061892", "name": "石牌分行　　　　　　　　　　　　　　　　"},
  {"code": "8061928", "name": "南門分行　　　　　　　　　　　　　　　　"},
  {"code": "8061939", "name": "新板分行　　　　　　　　　　　　　　　　"},
  {"code": "8061940", "name": "北新分行　　　　　　　　　　　　　　　　"},
  {"code": "8061951", "name": "南屯分行　　　　　　　　　　　　　　　　"},
  {"code": "8061962", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "8061973", "name": "東門分行　　　　　　　　　　　　　　　　"},
  {"code": "8061984", "name": "金城分行　　　　　　　　　　　　　　　　"},
  {"code": "8061995", "name": "民族分行　　　　　　　　　　　　　　　　"},
  {"code": "8062006", "name": "頭份分行　　　　　　　　　　　　　　　　"},
  {"code": "8062017", "name": "萬華分行　　　　　　　　　　　　　　　　"},
  {"code": "8062028", "name": "敦安分行　　　　　　　　　　　　　　　　"},
  {"code": "8062039", "name": "環東分行　　　　　　　　　　　　　　　　"}
  ],
  "807": [
  {"code": "8070014", "name": "世貿分行　　　　　　　　　　　　　　　　"},
  {"code": "8070025", "name": "敦北分行　　　　　　　　　　　　　　　　"},
  {"code": "8070036", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "8070047", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "8070058", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "8070069", "name": "西松分行　　　　　　　　　　　　　　　　"},
  {"code": "8070070", "name": "板新分行　　　　　　　　　　　　　　　　"},
  {"code": "8070092", "name": "敦南分行　　　　　　　　　　　　　　　　"},
  {"code": "8070106", "name": "新泰分行　　　　　　　　　　　　　　　　"},
  {"code": "8070117", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "8070128", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "8070139", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "8070151", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "8070162", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "8070173", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "8070184", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "8070195", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "8070210", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "8070221", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "8070232", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "8070243", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8070254", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "8070276", "name": "北新分行　　　　　　　　　　　　　　　　"},
  {"code": "8070287", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "8070298", "name": "北桃園分行　　　　　　　　　　　　　　　"},
  {"code": "8070302", "name": "學府分行　　　　　　　　　　　　　　　　"},
  {"code": "8070313", "name": "南高雄分行　　　　　　　　　　　　　　　"},
  {"code": "8070324", "name": "光華分行　　　　　　　　　　　　　　　　"},
  {"code": "8070335", "name": "東門分行　　　　　　　　　　　　　　　　"},
  {"code": "8070346", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "8070357", "name": "東板橋分行　　　　　　　　　　　　　　　"},
  {"code": "8070368", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "8070379", "name": "竹南分行　　　　　　　　　　　　　　　　"},
  {"code": "8070380", "name": "南台中分行　　　　　　　　　　　　　　　"},
  {"code": "8070391", "name": "竹北自強分行　　　　　　　　　　　　　　"},
  {"code": "8070405", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "8070416", "name": "中科分行　　　　　　　　　　　　　　　　"},
  {"code": "8070427", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "8070438", "name": "金門分行　　　　　　　　　　　　　　　　"},
  {"code": "8070449", "name": "興大分行　　　　　　　　　　　　　　　　"},
  {"code": "8070450", "name": "中崙分行　　　　　　　　　　　　　　　　"},
  {"code": "8070461", "name": "西湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8070472", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "8070483", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "8071011", "name": "忠孝東路分行　　　　　　　　　　　　　　"},
  {"code": "8071033", "name": "建成分行　　　　　　　　　　　　　　　　"},
  {"code": "8071044", "name": "西門分行　　　　　　　　　　　　　　　　"},
  {"code": "8071055", "name": "萬華分行　　　　　　　　　　　　　　　　"},
  {"code": "8071066", "name": "興隆分行　　　　　　　　　　　　　　　　"},
  {"code": "8071077", "name": "南門分行　　　　　　　　　　　　　　　　"},
  {"code": "8071088", "name": "長安分行　　　　　　　　　　　　　　　　"},
  {"code": "8071099", "name": "延平分行　　　　　　　　　　　　　　　　"},
  {"code": "8071103", "name": "北投分行　　　　　　　　　　　　　　　　"},
  {"code": "8071114", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "8071125", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "8071136", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "8071158", "name": "雙園分行　　　　　　　　　　　　　　　　"},
  {"code": "8071169", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "8071170", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "8071181", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "8071192", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "8071206", "name": "宜蘭分行　　　　　　　　　　　　　　　　"},
  {"code": "8071217", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "8071228", "name": "景美分行　　　　　　　　　　　　　　　　"},
  {"code": "8071239", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "8071251", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "8071262", "name": "城中分行　　　　　　　　　　　　　　　　"},
  {"code": "8071273", "name": "光復分行　　　　　　　　　　　　　　　　"},
  {"code": "8071284", "name": "正義分行　　　　　　　　　　　　　　　　"},
  {"code": "8071295", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "8071310", "name": "士東分行　　　　　　　　　　　　　　　　"},
  {"code": "8071321", "name": "中港分行　　　　　　　　　　　　　　　　"},
  {"code": "8071332", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "8071343", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8071354", "name": "社子分行　　　　　　　　　　　　　　　　"},
  {"code": "8071365", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "8071376", "name": "永春分行　　　　　　　　　　　　　　　　"},
  {"code": "8071387", "name": "南三重分行　　　　　　　　　　　　　　　"},
  {"code": "8071398", "name": "積穗分行　　　　　　　　　　　　　　　　"},
  {"code": "8071402", "name": "鶯歌分行　　　　　　　　　　　　　　　　"},
  {"code": "8071413", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "8071435", "name": "西盛分行　　　　　　　　　　　　　　　　"},
  {"code": "8071446", "name": "板橋忠孝分行　　　　　　　　　　　　　　"},
  {"code": "8071457", "name": "思源分行　　　　　　　　　　　　　　　　"},
  {"code": "8071468", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "8071479", "name": "三興分行　　　　　　　　　　　　　　　　"},
  {"code": "8071480", "name": "龍江分行　　　　　　　　　　　　　　　　"},
  {"code": "8071491", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "8071505", "name": "五股分行　　　　　　　　　　　　　　　　"},
  {"code": "8071538", "name": "松德分行　　　　　　　　　　　　　　　　"},
  {"code": "8071549", "name": "東湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8071550", "name": "華江分行　　　　　　　　　　　　　　　　"},
  {"code": "8071561", "name": "北三重分行　　　　　　　　　　　　　　　"},
  {"code": "8071572", "name": "蘭雅分行　　　　　　　　　　　　　　　　"},
  {"code": "8071583", "name": "德惠分行　　　　　　　　　　　　　　　　"},
  {"code": "8071594", "name": "迴龍分行　　　　　　　　　　　　　　　　"},
  {"code": "8071608", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "8071620", "name": "和平分行　　　　　　　　　　　　　　　　"},
  {"code": "8071642", "name": "重新分行　　　　　　　　　　　　　　　　"},
  {"code": "8071653", "name": "中興分行　　　　　　　　　　　　　　　　"},
  {"code": "8071664", "name": "海山分行　　　　　　　　　　　　　　　　"},
  {"code": "8071697", "name": "南蘆洲分行　　　　　　　　　　　　　　　"},
  {"code": "8071701", "name": "江子翠分行　　　　　　　　　　　　　　　"},
  {"code": "8071712", "name": "民安分行　　　　　　　　　　　　　　　　"},
  {"code": "8071723", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "8071734", "name": "林口忠孝分行　　　　　　　　　　　　　　"},
  {"code": "8071745", "name": "板橋民族分行　　　　　　　　　　　　　　"},
  {"code": "8071756", "name": "泰山分行　　　　　　　　　　　　　　　　"},
  {"code": "8071767", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "8071778", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "8071789", "name": "深坑分行　　　　　　　　　　　　　　　　"},
  {"code": "8071790", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "8071804", "name": "北台南分行　　　　　　　　　　　　　　　"},
  {"code": "8071815", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "8071826", "name": "成大分行　　　　　　　　　　　　　　　　"},
  {"code": "8071837", "name": "濟南路分行　　　　　　　　　　　　　　　"},
  {"code": "8071859", "name": "南桃園分行　　　　　　　　　　　　　　　"},
  {"code": "8071860", "name": "竹科分行　　　　　　　　　　　　　　　　"},
  {"code": "8071871", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "8071882", "name": "楊梅分行　　　　　　　　　　　　　　　　"},
  {"code": "8071893", "name": "內壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8071907", "name": "重慶北路分行　　　　　　　　　　　　　　"},
  {"code": "8071929", "name": "大園分行　　　　　　　　　　　　　　　　"},
  {"code": "8071930", "name": "竹北光明分行　　　　　　　　　　　　　　"},
  {"code": "8071963", "name": "竹圍分行　　　　　　　　　　　　　　　　"}
  ],
  "808": [
  {"code": "8080015", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "8080026", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "8080048", "name": "城東分行　　　　　　　　　　　　　　　　"},
  {"code": "8080059", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "8080060", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "8080071", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "8080082", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "8080118", "name": "基隆路分行　　　　　　　　　　　　　　　"},
  {"code": "8080129", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "8080130", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8080141", "name": "文心分行　　　　　　　　　　　　　　　　"},
  {"code": "8080152", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "8080163", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "8080174", "name": "埔墘分行　　　　　　　　　　　　　　　　"},
  {"code": "8080185", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "8080196", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "8080211", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "8080222", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "8080233", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "8080244", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "8080255", "name": "三和分行　　　　　　　　　　　　　　　　"},
  {"code": "8080266", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "8080277", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "8080288", "name": "大墩分行　　　　　　　　　　　　　　　　"},
  {"code": "8080299", "name": "七賢分行　　　　　　　　　　　　　　　　"},
  {"code": "8080303", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "8080314", "name": "敦南分行　　　　　　　　　　　　　　　　"},
  {"code": "8080325", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "8080336", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "8080347", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "8080358", "name": "大雅分行　　　　　　　　　　　　　　　　"},
  {"code": "8080369", "name": "楊梅分行　　　　　　　　　　　　　　　　"},
  {"code": "8080370", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "8080381", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "8080392", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "8080406", "name": "長春分行　　　　　　　　　　　　　　　　"},
  {"code": "8080417", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "8080428", "name": "佳里分行　　　　　　　　　　　　　　　　"},
  {"code": "8080439", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "8080440", "name": "竹南分行　　　　　　　　　　　　　　　　"},
  {"code": "8080451", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "8080462", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8080473", "name": "壢新分行　　　　　　　　　　　　　　　　"},
  {"code": "8080484", "name": "板新分行　　　　　　　　　　　　　　　　"},
  {"code": "8080495", "name": "光華分行　　　　　　　　　　　　　　　　"},
  {"code": "8080509", "name": "東嘉義分行　　　　　　　　　　　　　　　"},
  {"code": "8080510", "name": "成功分行　　　　　　　　　　　　　　　　"},
  {"code": "8080521", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "8080532", "name": "城中分行　　　　　　　　　　　　　　　　"},
  {"code": "8080543", "name": "五股分行　　　　　　　　　　　　　　　　"},
  {"code": "8080554", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "8080565", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "8080576", "name": "和平分行　　　　　　　　　　　　　　　　"},
  {"code": "8080587", "name": "新板特區分行　　　　　　　　　　　　　　"},
  {"code": "8080598", "name": "民權分行　　　　　　　　　　　　　　　　"},
  {"code": "8080602", "name": "泰山分行　　　　　　　　　　　　　　　　"},
  {"code": "8080613", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "8080624", "name": "台大分行　　　　　　　　　　　　　　　　"},
  {"code": "8080635", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "8080646", "name": "楠梓分行　　　　　　　　　　　　　　　　"},
  {"code": "8080657", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "8080668", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "8080679", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "8080680", "name": "南屯分行　　　　　　　　　　　　　　　　"},
  {"code": "8080691", "name": "木柵分行　　　　　　　　　　　　　　　　"},
  {"code": "8080705", "name": "大昌分行　　　　　　　　　　　　　　　　"},
  {"code": "8080716", "name": "台東分行　　　　　　　　　　　　　　　　"},
  {"code": "8080727", "name": "澄清分行　　　　　　　　　　　　　　　　"},
  {"code": "8080738", "name": "小港分行　　　　　　　　　　　　　　　　"},
  {"code": "8080749", "name": "北新莊分行　　　　　　　　　　　　　　　"},
  {"code": "8080750", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "8080761", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "8080772", "name": "集賢分行　　　　　　　　　　　　　　　　"},
  {"code": "8080783", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "8080794", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "8080808", "name": "連城分行　　　　　　　　　　　　　　　　"},
  {"code": "8080819", "name": "林園分行　　　　　　　　　　　　　　　　"},
  {"code": "8080820", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "8080831", "name": "後庄分行　　　　　　　　　　　　　　　　"},
  {"code": "8080842", "name": "南桃園分行　　　　　　　　　　　　　　　"},
  {"code": "8080853", "name": "東三重分行　　　　　　　　　　　　　　　"},
  {"code": "8080864", "name": "北投分行　　　　　　　　　　　　　　　　"},
  {"code": "8080875", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "8080886", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "8080897", "name": "東湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8080901", "name": "北新分行　　　　　　　　　　　　　　　　"},
  {"code": "8080912", "name": "中崙分行　　　　　　　　　　　　　　　　"},
  {"code": "8080923", "name": "建成分行　　　　　　　　　　　　　　　　"},
  {"code": "8080934", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "8080945", "name": "二重分行　　　　　　　　　　　　　　　　"},
  {"code": "8080956", "name": "台北分行　　　　　　　　　　　　　　　　"},
  {"code": "8080967", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "8080978", "name": "東港分行　　　　　　　　　　　　　　　　"},
  {"code": "8080989", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "8080990", "name": "草屯分行　　　　　　　　　　　　　　　　"},
  {"code": "8081001", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "8081012", "name": "迴龍分行　　　　　　　　　　　　　　　　"},
  {"code": "8081023", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "8081034", "name": "澎湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8081045", "name": "三峽分行　　　　　　　　　　　　　　　　"},
  {"code": "8081056", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "8081067", "name": "金華分行　　　　　　　　　　　　　　　　"},
  {"code": "8081078", "name": "光復分行　　　　　　　　　　　　　　　　"},
  {"code": "8081089", "name": "新湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8081090", "name": "桃鶯分行　　　　　　　　　　　　　　　　"},
  {"code": "8081104", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "8081115", "name": "永安分行　　　　　　　　　　　　　　　　"},
  {"code": "8081126", "name": "新豐分行　　　　　　　　　　　　　　　　"},
  {"code": "8081137", "name": "仁德分行　　　　　　　　　　　　　　　　"},
  {"code": "8081148", "name": "泰和分行　　　　　　　　　　　　　　　　"},
  {"code": "8081159", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "8081160", "name": "南勢角分行　　　　　　　　　　　　　　　"},
  {"code": "8081171", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "8081182", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "8081193", "name": "東門分行　　　　　　　　　　　　　　　　"},
  {"code": "8081207", "name": "南土城分行　　　　　　　　　　　　　　　"},
  {"code": "8081218", "name": "朴子分行　　　　　　　　　　　　　　　　"},
  {"code": "8081229", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "8081230", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "8081241", "name": "新樹分行　　　　　　　　　　　　　　　　"},
  {"code": "8081252", "name": "中工分行　　　　　　　　　　　　　　　　"},
  {"code": "8081263", "name": "瑞光分行　　　　　　　　　　　　　　　　"},
  {"code": "8081274", "name": "鹽行分行　　　　　　　　　　　　　　　　"},
  {"code": "8081285", "name": "頭份分行　　　　　　　　　　　　　　　　"},
  {"code": "8081296", "name": "後龍分行　　　　　　　　　　　　　　　　"},
  {"code": "8081300", "name": "五權分行　　　　　　　　　　　　　　　　"},
  {"code": "8081311", "name": "南永康分行　　　　　　　　　　　　　　　"},
  {"code": "8081322", "name": "藝文分行　　　　　　　　　　　　　　　　"},
  {"code": "8081333", "name": "中原分行　　　　　　　　　　　　　　　　"},
  {"code": "8081344", "name": "竹科分行　　　　　　　　　　　　　　　　"},
  {"code": "8081355", "name": "太平分行　　　　　　　　　　　　　　　　"},
  {"code": "8081366", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "8081377", "name": "六家分行　　　　　　　　　　　　　　　　"},
  {"code": "8081388", "name": "北屯分行　　　　　　　　　　　　　　　　"},
  {"code": "8081399", "name": "烏日分行　　　　　　　　　　　　　　　　"},
  {"code": "8081403", "name": "安南分行　　　　　　　　　　　　　　　　"},
  {"code": "8081425", "name": "沙鹿分行　　　　　　　　　　　　　　　　"},
  {"code": "8081436", "name": "東林口分行　　　　　　　　　　　　　　　"},
  {"code": "8081458", "name": "南山廣場分行　　　　　　　　　　　　　　"}
  ],
  "809": [
  {"code": "8090016", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "8090027", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "8090038", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "8090049", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "8090050", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "8090061", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "8090072", "name": "城東分行　　　　　　　　　　　　　　　　"},
  {"code": "8090094", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "8090108", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "8090119", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "8090120", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8090131", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "8090153", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "8090164", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "8090175", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "8090197", "name": "敦南分行　　　　　　　　　　　　　　　　"},
  {"code": "8090201", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "8090212", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "8090223", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "8090234", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "8090245", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "8090256", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "8090267", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "8090278", "name": "赤崁分行　　　　　　　　　　　　　　　　"},
  {"code": "8090289", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "8090304", "name": "東門分行　　　　　　　　　　　　　　　　"},
  {"code": "8090315", "name": "北門分行　　　　　　　　　　　　　　　　"},
  {"code": "8090326", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "8090337", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "8090348", "name": "歸仁分行　　　　　　　　　　　　　　　　"},
  {"code": "8090359", "name": "海東分行　　　　　　　　　　　　　　　　"},
  {"code": "8090371", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "8090382", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "8090393", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "8090407", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "8090429", "name": "苗栗分行　　　　　　　　　　　　　　　　"},
  {"code": "8090452", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "8090463", "name": "繼光分行　　　　　　　　　　　　　　　　"},
  {"code": "8090474", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "8090485", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "8090511", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "8090522", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "8090577", "name": "風城分行　　　　　　　　　　　　　　　　"},
  {"code": "8090588", "name": "南大分行　　　　　　　　　　　　　　　　"},
  {"code": "8090599", "name": "竹科分行　　　　　　　　　　　　　　　　"},
  {"code": "8090625", "name": "台東分行　　　　　　　　　　　　　　　　"},
  {"code": "8090669", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "8090670", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "8090681", "name": "高美館分行　　　　　　　　　　　　　　　"},
  {"code": "8090692", "name": "市政分行　　　　　　　　　　　　　　　　"},
  {"code": "8090706", "name": "藝文分行　　　　　　　　　　　　　　　　"},
  {"code": "8090717", "name": "瑞光分行　　　　　　　　　　　　　　　　"},
  {"code": "8090728", "name": "民生分行　　　　　　　　　　　　　　　　"}
  ],
  "810": [
  {"code": "8100021", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "8100043", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "8100054", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "8100065", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "8100098", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "8100102", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "8100113", "name": "華山分行　　　　　　　　　　　　　　　　"},
  {"code": "8100124", "name": "太平分行　　　　　　　　　　　　　　　　"},
  {"code": "8100135", "name": "中清分行　　　　　　　　　　　　　　　　"},
  {"code": "8100157", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "8100168", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "8100179", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "8100180", "name": "中港分行　　　　　　　　　　　　　　　　"},
  {"code": "8100205", "name": "左營分行　　　　　　　　　　　　　　　　"},
  {"code": "8100216", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "8100227", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "8100250", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "8100261", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "8100272", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "8100283", "name": "楠梓分行　　　　　　　　　　　　　　　　"},
  {"code": "8100294", "name": "民權分行　　　　　　　　　　　　　　　　"},
  {"code": "8100308", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "8100319", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "8100320", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "8100331", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "8100342", "name": "東新竹分行　　　　　　　　　　　　　　　"},
  {"code": "8100364", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "8100375", "name": "莒光分行　　　　　　　　　　　　　　　　"},
  {"code": "8100386", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8100397", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "8100401", "name": "大同分行　　　　　　　　　　　　　　　　"},
  {"code": "8100412", "name": "敦南分行　　　　　　　　　　　　　　　　"},
  {"code": "8100423", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8100456", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "8100467", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "8100478", "name": "松仁分行　　　　　　　　　　　　　　　　"},
  {"code": "8100489", "name": "新站分行　　　　　　　　　　　　　　　　"},
  {"code": "8100490", "name": "中正分行　　　　　　　　　　　　　　　　"},
  {"code": "8100504", "name": "中興分行　　　　　　　　　　　　　　　　"},
  {"code": "8100559", "name": "四維分行　　　　　　　　　　　　　　　　"}
  ],
  "812": [
  {"code": "8120012", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "8120023", "name": "敦南分行　　　　　　　　　　　　　　　　"},
  {"code": "8120045", "name": "新生分行　　　　　　　　　　　　　　　　"},
  {"code": "8120056", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "8120067", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "8120078", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "8120089", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "8120090", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "8120104", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "8120115", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "8120126", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8120137", "name": "信託部　　　　　　　　　　　　　　　　　"},
  {"code": "8120159", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "8120160", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "8120171", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "8120182", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "8120207", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "8120218", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "8120229", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "8120230", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "8120241", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "8120252", "name": "七賢分行　　　　　　　　　　　　　　　　"},
  {"code": "8120263", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "8120274", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "8120285", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "8120296", "name": "永福分行　　　　　　　　　　　　　　　　"},
  {"code": "8120300", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "8120311", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "8120322", "name": "龍潭分行　　　　　　　　　　　　　　　　"},
  {"code": "8120333", "name": "崇德分行　　　　　　　　　　　　　　　　"},
  {"code": "8120344", "name": "金華分行　　　　　　　　　　　　　　　　"},
  {"code": "8120355", "name": "後甲分行　　　　　　　　　　　　　　　　"},
  {"code": "8120366", "name": "海佃分行　　　　　　　　　　　　　　　　"},
  {"code": "8120377", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "8120388", "name": "五甲分行　　　　　　　　　　　　　　　　"},
  {"code": "8120399", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "8120403", "name": "古亭分行　　　　　　　　　　　　　　　　"},
  {"code": "8120414", "name": "建橋分行　　　　　　　　　　　　　　　　"},
  {"code": "8120436", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "8120447", "name": "太平分行　　　　　　　　　　　　　　　　"},
  {"code": "8120458", "name": "和平分行　　　　　　　　　　　　　　　　"},
  {"code": "8120469", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "8120470", "name": "南新莊分行　　　　　　　　　　　　　　　"},
  {"code": "8120481", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8120492", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "8120517", "name": "逢甲分行　　　　　　　　　　　　　　　　"},
  {"code": "8120528", "name": "竹科分行　　　　　　　　　　　　　　　　"},
  {"code": "8120540", "name": "南屯分行　　　　　　　　　　　　　　　　"},
  {"code": "8120551", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "8120562", "name": "南門分行　　　　　　　　　　　　　　　　"},
  {"code": "8120610", "name": "西門分行　　　　　　　　　　　　　　　　"},
  {"code": "8120621", "name": "敦北分行　　　　　　　　　　　　　　　　"},
  {"code": "8120632", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "8120643", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "8120654", "name": "板南分行　　　　　　　　　　　　　　　　"},
  {"code": "8120665", "name": "民權分行　　　　　　　　　　　　　　　　"},
  {"code": "8120676", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "8120687", "name": "建北分行　　　　　　　　　　　　　　　　"},
  {"code": "8120698", "name": "三和分行　　　　　　　　　　　　　　　　"},
  {"code": "8120702", "name": "北新店分行　　　　　　　　　　　　　　　"},
  {"code": "8120713", "name": "府城分行　　　　　　　　　　　　　　　　"},
  {"code": "8120724", "name": "東高雄分行　　　　　　　　　　　　　　　"},
  {"code": "8120735", "name": "基隆路分行　　　　　　　　　　　　　　　"},
  {"code": "8120746", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "8120757", "name": "北桃園分行　　　　　　　　　　　　　　　"},
  {"code": "8120768", "name": "大墩分行　　　　　　　　　　　　　　　　"},
  {"code": "8120779", "name": "延平分行　　　　　　　　　　　　　　　　"},
  {"code": "8120780", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "8120791", "name": "景平分行　　　　　　　　　　　　　　　　"},
  {"code": "8120805", "name": "文心分行　　　　　　　　　　　　　　　　"},
  {"code": "8120816", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "8120827", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "8120838", "name": "大雅分行　　　　　　　　　　　　　　　　"},
  {"code": "8120849", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "8120850", "name": "成功分行　　　　　　　　　　　　　　　　"},
  {"code": "8120861", "name": "石牌分行　　　　　　　　　　　　　　　　"},
  {"code": "8120872", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "8120883", "name": "南松山分行　　　　　　　　　　　　　　　"},
  {"code": "8120894", "name": "淡水分行　　　　　　　　　　　　　　　　"},
  {"code": "8120908", "name": "東基隆分行　　　　　　　　　　　　　　　"},
  {"code": "8120919", "name": "新板分行　　　　　　　　　　　　　　　　"},
  {"code": "8120920", "name": "北師分行　　　　　　　　　　　　　　　　"},
  {"code": "8120931", "name": "永華分行　　　　　　　　　　　　　　　　"},
  {"code": "8120942", "name": "江翠分行　　　　　　　　　　　　　　　　"},
  {"code": "8120975", "name": "松德分行　　　　　　　　　　　　　　　　"},
  {"code": "8120986", "name": "北大分行　　　　　　　　　　　　　　　　"},
  {"code": "8120997", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "8121008", "name": "關東橋分行　　　　　　　　　　　　　　　"},
  {"code": "8121019", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "8121020", "name": "南寮分行　　　　　　　　　　　　　　　　"},
  {"code": "8121031", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "8121042", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "8121053", "name": "市府分行　　　　　　　　　　　　　　　　"},
  {"code": "8121064", "name": "右昌分行　　　　　　　　　　　　　　　　"},
  {"code": "8121075", "name": "沙鹿分行　　　　　　　　　　　　　　　　"},
  {"code": "8121086", "name": "竹南分行　　　　　　　　　　　　　　　　"},
  {"code": "8121097", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "8121101", "name": "東湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8121112", "name": "文山分行　　　　　　　　　　　　　　　　"},
  {"code": "8121123", "name": "副都心分行　　　　　　　　　　　　　　　"},
  {"code": "8121134", "name": "景美分行　　　　　　　　　　　　　　　　"},
  {"code": "8121145", "name": "雄科分行　　　　　　　　　　　　　　　　"}
  ],
  "815": [
  {"code": "8150015", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "8150026", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "8150037", "name": "延平分行　　　　　　　　　　　　　　　　"},
  {"code": "8150048", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8150059", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "8150060", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "8150071", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "8150093", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "8150107", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "8150118", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8150129", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "8150130", "name": "松南分行　　　　　　　　　　　　　　　　"},
  {"code": "8150141", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "8150163", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "8150174", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "8150185", "name": "苓雅分行　　　　　　　　　　　　　　　　"},
  {"code": "8150196", "name": "前金分行　　　　　　　　　　　　　　　　"},
  {"code": "8150211", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "8150222", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "8150233", "name": "北台中分行　　　　　　　　　　　　　　　"},
  {"code": "8150244", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "8150255", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "8150266", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "8150277", "name": "北桃園分行　　　　　　　　　　　　　　　"},
  {"code": "8150288", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "8150299", "name": "敦化分行　　　　　　　　　　　　　　　　"},
  {"code": "8150303", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "8150314", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "8150325", "name": "頭份分行　　　　　　　　　　　　　　　　"},
  {"code": "8150336", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "8150347", "name": "光復分行　　　　　　　　　　　　　　　　"},
  {"code": "8150358", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "8150369", "name": "虎尾分行　　　　　　　　　　　　　　　　"},
  {"code": "8150370", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "8150381", "name": "南門分行　　　　　　　　　　　　　　　　"},
  {"code": "8150392", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "8150406", "name": "敦北分行　　　　　　　　　　　　　　　　"},
  {"code": "8150417", "name": "南京分行　　　　　　　　　　　　　　　　"},
  {"code": "8150428", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "8150439", "name": "安平分行　　　　　　　　　　　　　　　　"},
  {"code": "8150451", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "8150462", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "8150473", "name": "南港分行　　　　　　　　　　　　　　　　"},
  {"code": "8150484", "name": "蘆洲分行　　　　　　　　　　　　　　　　"}
  ],
  "816": [
  {"code": "8160016", "name": "長安東路分行　　　　　　　　　　　　　　"},
  {"code": "8160027", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "8160038", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "8160049", "name": "新生分行　　　　　　　　　　　　　　　　"},
  {"code": "8160050", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "8160061", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "8160072", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "8160083", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "8160094", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "8160108", "name": "興隆分行　　　　　　　　　　　　　　　　"},
  {"code": "8160119", "name": "延平分行　　　　　　　　　　　　　　　　"},
  {"code": "8160120", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8160131", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "8160142", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "8160153", "name": "前金分行　　　　　　　　　　　　　　　　"},
  {"code": "8160164", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "8160186", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "8160197", "name": "松江分行　　　　　　　　　　　　　　　　"},
  {"code": "8160201", "name": "中崙分行　　　　　　　　　　　　　　　　"},
  {"code": "8160212", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "8160223", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "8160245", "name": "沙鹿分行　　　　　　　　　　　　　　　　"},
  {"code": "8160256", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "8160267", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "8160278", "name": "建國分行　　　　　　　　　　　　　　　　"},
  {"code": "8160289", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "8160290", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "8160304", "name": "和平分行　　　　　　　　　　　　　　　　"},
  {"code": "8160315", "name": "成功分行　　　　　　　　　　　　　　　　"},
  {"code": "8160326", "name": "通化分行　　　　　　　　　　　　　　　　"},
  {"code": "8160337", "name": "南門分行　　　　　　　　　　　　　　　　"},
  {"code": "8160348", "name": "汀州分行　　　　　　　　　　　　　　　　"},
  {"code": "8160359", "name": "農安分行　　　　　　　　　　　　　　　　"},
  {"code": "8160360", "name": "景美分行　　　　　　　　　　　　　　　　"},
  {"code": "8160371", "name": "民權分行　　　　　　　　　　　　　　　　"},
  {"code": "8160382", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "8160393", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8160407", "name": "台北一０一分行　　　　　　　　　　　　　"},
  {"code": "8160418", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "8160429", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "8160430", "name": "西壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8160441", "name": "北桃園簡易型分行　　　　　　　　　　　　"},
  {"code": "8160452", "name": "幸福分行　　　　　　　　　　　　　　　　"},
  {"code": "8160463", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "8160474", "name": "龍潭簡易型分行　　　　　　　　　　　　　"},
  {"code": "8160500", "name": "石牌分行　　　　　　　　　　　　　　　　"},
  {"code": "8160511", "name": "八德簡易型分行　　　　　　　　　　　　　"},
  {"code": "8160522", "name": "竹北簡易型分行　　　　　　　　　　　　　"},
  {"code": "8160533", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "8160566", "name": "大里分行　　　　　　　　　　　　　　　　"}
  ],
  "822": [
  {"code": "8220015", "name": "敦北分行　　　　　　　　　　　　　　　　"},
  {"code": "8220026", "name": "台中分行　　　　　　　　　　　　　　　　"},
  {"code": "8220037", "name": "高雄分行　　　　　　　　　　　　　　　　"},
  {"code": "8220059", "name": "台南分行　　　　　　　　　　　　　　　　"},
  {"code": "8220060", "name": "三重分行　　　　　　　　　　　　　　　　"},
  {"code": "8220071", "name": "城東分行　　　　　　　　　　　　　　　　"},
  {"code": "8220082", "name": "嘉義分行　　　　　　　　　　　　　　　　"},
  {"code": "8220093", "name": "中崙分行　　　　　　　　　　　　　　　　"},
  {"code": "8220107", "name": "城中分行　　　　　　　　　　　　　　　　"},
  {"code": "8220118", "name": "三民分行　　　　　　　　　　　　　　　　"},
  {"code": "8220129", "name": "中壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8220130", "name": "雙和分行　　　　　　　　　　　　　　　　"},
  {"code": "8220141", "name": "中山分行　　　　　　　　　　　　　　　　"},
  {"code": "8220152", "name": "仁愛分行　　　　　　　　　　　　　　　　"},
  {"code": "8220163", "name": "敦南分行　　　　　　　　　　　　　　　　"},
  {"code": "8220174", "name": "板橋分行　　　　　　　　　　　　　　　　"},
  {"code": "8220185", "name": "忠孝分行　　　　　　　　　　　　　　　　"},
  {"code": "8220196", "name": "新興分行　　　　　　　　　　　　　　　　"},
  {"code": "8220200", "name": "南京東路分行　　　　　　　　　　　　　　"},
  {"code": "8220222", "name": "西台南分行　　　　　　　　　　　　　　　"},
  {"code": "8220255", "name": "松山分行　　　　　　　　　　　　　　　　"},
  {"code": "8220266", "name": "新莊分行　　　　　　　　　　　　　　　　"},
  {"code": "8220277", "name": "桃園分行　　　　　　　　　　　　　　　　"},
  {"code": "8220288", "name": "中港分行　　　　　　　　　　　　　　　　"},
  {"code": "8220299", "name": "新竹分行　　　　　　　　　　　　　　　　"},
  {"code": "8220303", "name": "蘆洲分行　　　　　　　　　　　　　　　　"},
  {"code": "8220314", "name": "新店分行　　　　　　　　　　　　　　　　"},
  {"code": "8220325", "name": "員林分行　　　　　　　　　　　　　　　　"},
  {"code": "8220336", "name": "東新竹分行　　　　　　　　　　　　　　　"},
  {"code": "8220347", "name": "公館分行　　　　　　　　　　　　　　　　"},
  {"code": "8220358", "name": "永康分行　　　　　　　　　　　　　　　　"},
  {"code": "8220369", "name": "土城分行　　　　　　　　　　　　　　　　"},
  {"code": "8220370", "name": "頭份分行　　　　　　　　　　　　　　　　"},
  {"code": "8220381", "name": "基隆分行　　　　　　　　　　　　　　　　"},
  {"code": "8220392", "name": "豐原分行　　　　　　　　　　　　　　　　"},
  {"code": "8220406", "name": "天母分行　　　　　　　　　　　　　　　　"},
  {"code": "8220417", "name": "板新分行　　　　　　　　　　　　　　　　"},
  {"code": "8220428", "name": "彰化分行　　　　　　　　　　　　　　　　"},
  {"code": "8220439", "name": "東高雄分行　　　　　　　　　　　　　　　"},
  {"code": "8220440", "name": "中華分行　　　　　　　　　　　　　　　　"},
  {"code": "8220451", "name": "內湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8220462", "name": "斗六分行　　　　　　　　　　　　　　　　"},
  {"code": "8220473", "name": "文心分行　　　　　　　　　　　　　　　　"},
  {"code": "8220484", "name": "重陽分行　　　　　　　　　　　　　　　　"},
  {"code": "8220495", "name": "永吉分行　　　　　　　　　　　　　　　　"},
  {"code": "8220509", "name": "前鎮分行　　　　　　　　　　　　　　　　"},
  {"code": "8220510", "name": "南崁分行　　　　　　　　　　　　　　　　"},
  {"code": "8220521", "name": "永和分行　　　　　　　　　　　　　　　　"},
  {"code": "8220532", "name": "公益分行　　　　　　　　　　　　　　　　"},
  {"code": "8220543", "name": "市府分行　　　　　　　　　　　　　　　　"},
  {"code": "8220554", "name": "六家庄分行　　　　　　　　　　　　　　　"},
  {"code": "8220565", "name": "右昌分行　　　　　　　　　　　　　　　　"},
  {"code": "8220576", "name": "江翠分行　　　　　　　　　　　　　　　　"},
  {"code": "8220587", "name": "東湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8220598", "name": "中原分行　　　　　　　　　　　　　　　　"},
  {"code": "8220602", "name": "大安分行　　　　　　　　　　　　　　　　"},
  {"code": "8220613", "name": "北高雄分行　　　　　　　　　　　　　　　"},
  {"code": "8220624", "name": "承德分行　　　　　　　　　　　　　　　　"},
  {"code": "8220635", "name": "復興分行　　　　　　　　　　　　　　　　"},
  {"code": "8220646", "name": "石牌分行　　　　　　　　　　　　　　　　"},
  {"code": "8220657", "name": "城北分行　　　　　　　　　　　　　　　　"},
  {"code": "8220668", "name": "萬華分行　　　　　　　　　　　　　　　　"},
  {"code": "8220679", "name": "西松分行　　　　　　　　　　　　　　　　"},
  {"code": "8220680", "name": "北投分行　　　　　　　　　　　　　　　　"},
  {"code": "8220691", "name": "安和分行　　　　　　　　　　　　　　　　"},
  {"code": "8220705", "name": "西湖分行　　　　　　　　　　　　　　　　"},
  {"code": "8220716", "name": "瑞光分行　　　　　　　　　　　　　　　　"},
  {"code": "8220727", "name": "宜蘭分行　　　　　　　　　　　　　　　　"},
  {"code": "8220738", "name": "民生分行　　　　　　　　　　　　　　　　"},
  {"code": "8220749", "name": "中和分行　　　　　　　　　　　　　　　　"},
  {"code": "8220750", "name": "重新分行　　　　　　　　　　　　　　　　"},
  {"code": "8220761", "name": "丹鳳分行　　　　　　　　　　　　　　　　"},
  {"code": "8220772", "name": "北新店分行　　　　　　　　　　　　　　　"},
  {"code": "8220783", "name": "汐止分行　　　　　　　　　　　　　　　　"},
  {"code": "8220794", "name": "金城分行　　　　　　　　　　　　　　　　"},
  {"code": "8220808", "name": "樹林分行　　　　　　　　　　　　　　　　"},
  {"code": "8220819", "name": "南勢角分行　　　　　　　　　　　　　　　"},
  {"code": "8220820", "name": "北新莊分行　　　　　　　　　　　　　　　"},
  {"code": "8220853", "name": "南桃園分行　　　　　　　　　　　　　　　"},
  {"code": "8220864", "name": "北桃園分行　　　　　　　　　　　　　　　"},
  {"code": "8220875", "name": "竹科分行　　　　　　　　　　　　　　　　"},
  {"code": "8220901", "name": "營業部　　　　　　　　　　　　　　　　　"},
  {"code": "8221012", "name": "八德分行　　　　　　　　　　　　　　　　"},
  {"code": "8221023", "name": "林口分行　　　　　　　　　　　　　　　　"},
  {"code": "8221034", "name": "竹北分行　　　　　　　　　　　　　　　　"},
  {"code": "8221045", "name": "南屯分行　　　　　　　　　　　　　　　　"},
  {"code": "8221056", "name": "大里分行　　　　　　　　　　　　　　　　"},
  {"code": "8221067", "name": "洲際分行　　　　　　　　　　　　　　　　"},
  {"code": "8221078", "name": "南投分行　　　　　　　　　　　　　　　　"},
  {"code": "8221090", "name": "仁德分行　　　　　　　　　　　　　　　　"},
  {"code": "8221104", "name": "中台南分行　　　　　　　　　　　　　　　"},
  {"code": "8221115", "name": "東台南分行　　　　　　　　　　　　　　　"},
  {"code": "8221126", "name": "台東分行　　　　　　　　　　　　　　　　"},
  {"code": "8221137", "name": "南台南分行　　　　　　　　　　　　　　　"},
  {"code": "8221148", "name": "新營分行　　　　　　　　　　　　　　　　"},
  {"code": "8221159", "name": "科博館分行　　　　　　　　　　　　　　　"},
  {"code": "8221160", "name": "西屯分行　　　　　　　　　　　　　　　　"},
  {"code": "8221171", "name": "民族分行　　　　　　　　　　　　　　　　"},
  {"code": "8221182", "name": "南高雄分行　　　　　　　　　　　　　　　"},
  {"code": "8221193", "name": "九如分行　　　　　　　　　　　　　　　　"},
  {"code": "8221207", "name": "屏東分行　　　　　　　　　　　　　　　　"},
  {"code": "8221218", "name": "復北分行　　　　　　　　　　　　　　　　"},
  {"code": "8221229", "name": "鳳山分行　　　　　　　　　　　　　　　　"},
  {"code": "8221230", "name": "五甲分行　　　　　　　　　　　　　　　　"},
  {"code": "8221241", "name": "延吉分行　　　　　　　　　　　　　　　　"},
  {"code": "8221252", "name": "信義分行　　　　　　　　　　　　　　　　"},
  {"code": "8221263", "name": "青年分行　　　　　　　　　　　　　　　　"},
  {"code": "8221274", "name": "岡山分行　　　　　　　　　　　　　　　　"},
  {"code": "8221285", "name": "士林分行　　　　　　　　　　　　　　　　"},
  {"code": "8221296", "name": "東民生分行　　　　　　　　　　　　　　　"},
  {"code": "8221300", "name": "文山分行　　　　　　　　　　　　　　　　"},
  {"code": "8222101", "name": "淡水分行　　　　　　　　　　　　　　　　"},
  {"code": "8222112", "name": "民安分行　　　　　　　　　　　　　　　　"},
  {"code": "8222123", "name": "二重埔簡易型分行　　　　　　　　　　　　"},
  {"code": "8222134", "name": "富錦分行　　　　　　　　　　　　　　　　"},
  {"code": "8222145", "name": "站前分行　　　　　　　　　　　　　　　　"},
  {"code": "8222156", "name": "惠中分行　　　　　　　　　　　　　　　　"},
  {"code": "8222167", "name": "東蘆洲分行　　　　　　　　　　　　　　　"},
  {"code": "8222178", "name": "木柵分行　　　　　　　　　　　　　　　　"},
  {"code": "8222189", "name": "東花蓮分行　　　　　　　　　　　　　　　"},
  {"code": "8222190", "name": "寶山分行　　　　　　　　　　　　　　　　"},
  {"code": "8222204", "name": "藝文分行　　　　　　　　　　　　　　　　"},
  {"code": "8222215", "name": "東門分行　　　　　　　　　　　　　　　　"},
  {"code": "8222226", "name": "新板特區分行　　　　　　　　　　　　　　"},
  {"code": "8222237", "name": "三和分行　　　　　　　　　　　　　　　　"},
  {"code": "8222248", "name": "劍潭分行　　　　　　　　　　　　　　　　"},
  {"code": "8222259", "name": "北蘆洲分行　　　　　　　　　　　　　　　"},
  {"code": "8222260", "name": "寶強分行　　　　　　　　　　　　　　　　"},
  {"code": "8222271", "name": "華山分行　　　　　　　　　　　　　　　　"},
  {"code": "8222282", "name": "龍江分行　　　　　　　　　　　　　　　　"},
  {"code": "8222293", "name": "成功分行　　　　　　　　　　　　　　　　"},
  {"code": "8223108", "name": "市政分行　　　　　　　　　　　　　　　　"},
  {"code": "8223119", "name": "大直分行　　　　　　　　　　　　　　　　"},
  {"code": "8223120", "name": "景美分行　　　　　　　　　　　　　　　　"},
  {"code": "8223131", "name": "內壢分行　　　　　　　　　　　　　　　　"},
  {"code": "8223142", "name": "重慶分行　　　　　　　　　　　　　　　　"},
  {"code": "8223153", "name": "長安分行　　　　　　　　　　　　　　　　"},
  {"code": "8223164", "name": "羅東分行　　　　　　　　　　　　　　　　"},
  {"code": "8223175", "name": "南中壢分行　　　　　　　　　　　　　　　"},
  {"code": "8223186", "name": "板和分行　　　　　　　　　　　　　　　　"},
  {"code": "8223197", "name": "花蓮分行　　　　　　　　　　　　　　　　"},
  {"code": "8223201", "name": "北天母分行　　　　　　　　　　　　　　　"},
  {"code": "8223212", "name": "民權西路分行　　　　　　　　　　　　　　"},
  {"code": "8223223", "name": "佳里分行　　　　　　　　　　　　　　　　"},
  {"code": "8223234", "name": "博愛分行　　　　　　　　　　　　　　　　"},
  {"code": "8223245", "name": "鹽行分行　　　　　　　　　　　　　　　　"},
  {"code": "8223267", "name": "光復分行　　　　　　　　　　　　　　　　"},
  {"code": "8223278", "name": "埔墘簡易型分行　　　　　　　　　　　　　"},
  {"code": "8223289", "name": "黎明分行　　　　　　　　　　　　　　　　"},
  {"code": "8223290", "name": "新富分行　　　　　　　　　　　　　　　　"},
  {"code": "8223603", "name": "三峽分行　　　　　　　　　　　　　　　　"},
  {"code": "8223614", "name": "東林口分行　　　　　　　　　　　　　　　"}
  ],
  "860": [
  {"code": "8600015", "name": "中埔鄉農會　　　　　　　　　　　　　　　"},
  {"code": "8600026", "name": "同仁分部　　　　　　　　　　　　　　　　"},
  {"code": "8600037", "name": "隆興分部　　　　　　　　　　　　　　　　"},
  {"code": "8600048", "name": "金蘭分部　　　　　　　　　　　　　　　　"},
  {"code": "8600059", "name": "和睦分部　　　　　　　　　　　　　　　　"},
  {"code": "8600060", "name": "和美分部　　　　　　　　　　　　　　　　"},
  {"code": "8600071", "name": "和興分部　　　　　　　　　　　　　　　　"},
  {"code": "8600093", "name": "沄水分部　　　　　　　　　　　　　　　　"}
  ],
  "866": [
  {"code": "8660011", "name": "阿里山鄉農會　　　　　　　　　　　　　　"},
  {"code": "8660022", "name": "中山分部　　　　　　　　　　　　　　　　"},
  {"code": "8660033", "name": "達邦分部　　　　　　　　　　　　　　　　"}
  ],
  "868": [
  {"code": "8680013", "name": "東勢區農會　　　　　　　　　　　　　　　"}
  ],
  "869": [
  {"code": "8690014", "name": "清水區農會　　　　　　　　　　　　　　　"},
  {"code": "8690025", "name": "臨江分部　　　　　　　　　　　　　　　　"},
  {"code": "8690036", "name": "南社分部　　　　　　　　　　　　　　　　"}
  ],
  "870": [
  {"code": "8700018", "name": "梧棲區農會　　　　　　　　　　　　　　　"},
  {"code": "8700029", "name": "興農分部　　　　　　　　　　　　　　　　"},
  {"code": "8700030", "name": "安寧分部　　　　　　　　　　　　　　　　"},
  {"code": "8700041", "name": "大莊分部　　　　　　　　　　　　　　　　"},
  {"code": "8700052", "name": "南簡分部　　　　　　　　　　　　　　　　"}
  ],
  "871": [
  {"code": "8710019", "name": "大甲區農會　　　　　　　　　　　　　　　"},
  {"code": "8710020", "name": "日南分部　　　　　　　　　　　　　　　　"},
  {"code": "8710031", "name": "順天分部　　　　　　　　　　　　　　　　"},
  {"code": "8710042", "name": "西岐分部　　　　　　　　　　　　　　　　"},
  {"code": "8710053", "name": "幼獅社區分部　　　　　　　　　　　　　　"},
  {"code": "8710064", "name": "庄美分部　　　　　　　　　　　　　　　　"}
  ],
  "872": [
  {"code": "8720010", "name": "沙鹿區農會　　　　　　　　　　　　　　　"},
  {"code": "8720021", "name": "北勢分部　　　　　　　　　　　　　　　　"},
  {"code": "8720032", "name": "鹿峰分部　　　　　　　　　　　　　　　　"},
  {"code": "8720043", "name": "西明分部　　　　　　　　　　　　　　　　"},
  {"code": "8720054", "name": "公館分部　　　　　　　　　　　　　　　　"}
  ],
  "874": [
  {"code": "8740012", "name": "霧峰區農會　　　　　　　　　　　　　　　"},
  {"code": "8740023", "name": "萬豐分部　　　　　　　　　　　　　　　　"},
  {"code": "8740034", "name": "北柳分部　　　　　　　　　　　　　　　　"},
  {"code": "8740045", "name": "吉峰分部　　　　　　　　　　　　　　　　"},
  {"code": "8740056", "name": "舊正分部　　　　　　　　　　　　　　　　"},
  {"code": "8740067", "name": "吉峰路分部　　　　　　　　　　　　　　　"}
  ],
  "875": [
  {"code": "8750013", "name": "太平區農會　　　　　　　　　　　　　　　"},
  {"code": "8750024", "name": "新光分部　　　　　　　　　　　　　　　　"},
  {"code": "8750035", "name": "頭汴分部　　　　　　　　　　　　　　　　"},
  {"code": "8750046", "name": "光隆分部　　　　　　　　　　　　　　　　"},
  {"code": "8750057", "name": "中山分部　　　　　　　　　　　　　　　　"},
  {"code": "8750068", "name": "東平分部　　　　　　　　　　　　　　　　"},
  {"code": "8750079", "name": "坪林分部　　　　　　　　　　　　　　　　"},
  {"code": "8750080", "name": "新興分部　　　　　　　　　　　　　　　　"}
  ],
  "876": [
  {"code": "8760014", "name": "烏日區農會　　　　　　　　　　　　　　　"},
  {"code": "8760025", "name": "溪埧分部　　　　　　　　　　　　　　　　"},
  {"code": "8760036", "name": "九德分部　　　　　　　　　　　　　　　　"},
  {"code": "8760047", "name": "成功分部　　　　　　　　　　　　　　　　"}
  ],
  "877": [
  {"code": "8770015", "name": "后里區農會　　　　　　　　　　　　　　　"},
  {"code": "8770026", "name": "公館分部　　　　　　　　　　　　　　　　"},
  {"code": "8770037", "name": "義里分部　　　　　　　　　　　　　　　　"},
  {"code": "8770048", "name": "眉山分部　　　　　　　　　　　　　　　　"}
  ],
  "878": [
  {"code": "8780016", "name": "大雅區農會　　　　　　　　　　　　　　　"},
  {"code": "8780027", "name": "橫山分部　　　　　　　　　　　　　　　　"},
  {"code": "8780038", "name": "上楓分部　　　　　　　　　　　　　　　　"},
  {"code": "8780049", "name": "馬岡分部　　　　　　　　　　　　　　　　"},
  {"code": "8780050", "name": "忠義分部　　　　　　　　　　　　　　　　"}
  ],
  "879": [
  {"code": "8790017", "name": "潭子區農會　　　　　　　　　　　　　　　"},
  {"code": "8790028", "name": "頭家分部　　　　　　　　　　　　　　　　"},
  {"code": "8790039", "name": "東寶分部　　　　　　　　　　　　　　　　"},
  {"code": "8790040", "name": "栗林分部　　　　　　　　　　　　　　　　"},
  {"code": "8790051", "name": "甘蔗分部　　　　　　　　　　　　　　　　"}
  ],
  "880": [
  {"code": "8800011", "name": "石岡區農會　　　　　　　　　　　　　　　"},
  {"code": "8800022", "name": "和盛分部　　　　　　　　　　　　　　　　"}
  ],
  "881": [
  {"code": "8810012", "name": "新社區農會　　　　　　　　　　　　　　　"},
  {"code": "8810023", "name": "福興分部　　　　　　　　　　　　　　　　"},
  {"code": "8810034", "name": "中興嶺分部　　　　　　　　　　　　　　　"}
  ],
  "882": [
  {"code": "8820013", "name": "大肚區農會　　　　　　　　　　　　　　　"},
  {"code": "8820024", "name": "福山分部　　　　　　　　　　　　　　　　"},
  {"code": "8820035", "name": "成功分部　　　　　　　　　　　　　　　　"},
  {"code": "8820046", "name": "蔗部分部　　　　　　　　　　　　　　　　"},
  {"code": "8820057", "name": "王田分部　　　　　　　　　　　　　　　　"}
  ],
  "883": [
  {"code": "8830014", "name": "外埔區農會　　　　　　　　　　　　　　　"},
  {"code": "8830025", "name": "土城分部　　　　　　　　　　　　　　　　"},
  {"code": "8830036", "name": "大東分部　　　　　　　　　　　　　　　　"}
  ],
  "884": [
  {"code": "8840015", "name": "大安區農會　　　　　　　　　　　　　　　"},
  {"code": "8840026", "name": "海墘分部　　　　　　　　　　　　　　　　"},
  {"code": "8840037", "name": "松雅分部　　　　　　　　　　　　　　　　"}
  ],
  "885": [
  {"code": "8850016", "name": "龍井區農會　　　　　　　　　　　　　　　"},
  {"code": "8850027", "name": "龍泉分部　　　　　　　　　　　　　　　　"},
  {"code": "8850038", "name": "龍津分部　　　　　　　　　　　　　　　　"},
  {"code": "8850049", "name": "新庄分部　　　　　　　　　　　　　　　　"},
  {"code": "8850050", "name": "國際分部　　　　　　　　　　　　　　　　"}
  ],
  "886": [
  {"code": "8860017", "name": "和平區農會　　　　　　　　　　　　　　　"},
  {"code": "8860028", "name": "梨山分部　　　　　　　　　　　　　　　　"},
  {"code": "8860039", "name": "雙崎分部　　　　　　　　　　　　　　　　"}
  ],
  "891": [
  {"code": "8910015", "name": "花蓮市農會　　　　　　　　　　　　　　　"},
  {"code": "8910026", "name": "花商分部　　　　　　　　　　　　　　　　"},
  {"code": "8910037", "name": "自強分部　　　　　　　　　　　　　　　　"},
  {"code": "8910048", "name": "美崙分部　　　　　　　　　　　　　　　　"}
  ],
  "895": [
  {"code": "8950019", "name": "瑞穗鄉農會　　　　　　　　　　　　　　　"},
  {"code": "8950020", "name": "富源分部　　　　　　　　　　　　　　　　"}
  ],
  "896": [
  {"code": "8960010", "name": "玉溪地區農會　　　　　　　　　　　　　　"},
  {"code": "8960021", "name": "松浦分部　　　　　　　　　　　　　　　　"}
  ],
  "897": [
  {"code": "8970011", "name": "鳳榮地區農會　　　　　　　　　　　　　　"},
  {"code": "8970022", "name": "萬榮分部　　　　　　　　　　　　　　　　"},
  {"code": "8970033", "name": "林榮分部　　　　　　　　　　　　　　　　"}
  ],
  "898": [
  {"code": "8980012", "name": "光豐地區農會　　　　　　　　　　　　　　"},
  {"code": "8980023", "name": "豐濱分部　　　　　　　　　　　　　　　　"},
  {"code": "8980034", "name": "大富分部　　　　　　　　　　　　　　　　"}
  ],
  "901": [
  {"code": "9010015", "name": "大里區農會　　　　　　　　　　　　　　　"},
  {"code": "9010026", "name": "內新分部　　　　　　　　　　　　　　　　"},
  {"code": "9010037", "name": "草湖分部　　　　　　　　　　　　　　　　"},
  {"code": "9010048", "name": "健民分部　　　　　　　　　　　　　　　　"},
  {"code": "9010059", "name": "東榮分部　　　　　　　　　　　　　　　　"},
  {"code": "9010060", "name": "金城分部　　　　　　　　　　　　　　　　"},
  {"code": "9010071", "name": "十九甲分部　　　　　　　　　　　　　　　"},
  {"code": "9010093", "name": "仁化分部　　　　　　　　　　　　　　　　"},
  {"code": "9010107", "name": "國光分部　　　　　　　　　　　　　　　　"},
  {"code": "9010118", "name": "成功分部　　　　　　　　　　　　　　　　"},
  {"code": "9010129", "name": "立新分部　　　　　　　　　　　　　　　　"}
  ],
  "902": [
  {"code": "9020016", "name": "苗栗市農會　　　　　　　　　　　　　　　"},
  {"code": "9020027", "name": "南苗分部　　　　　　　　　　　　　　　　"},
  {"code": "9020038", "name": "北苗分部　　　　　　　　　　　　　　　　"},
  {"code": "9020049", "name": "嘉盛分部　　　　　　　　　　　　　　　　"}
  ],
  "903": [
  {"code": "9030017", "name": "汐止區農會　　　　　　　　　　　　　　　"},
  {"code": "9030028", "name": "社后分部　　　　　　　　　　　　　　　　"},
  {"code": "9030039", "name": "橫科分部　　　　　　　　　　　　　　　　"},
  {"code": "9030040", "name": "白雲分部　　　　　　　　　　　　　　　　"},
  {"code": "9030051", "name": "大新分部　　　　　　　　　　　　　　　　"},
  {"code": "9030062", "name": "中興分部　　　　　　　　　　　　　　　　"},
  {"code": "9030073", "name": "中正分部　　　　　　　　　　　　　　　　"},
  {"code": "9030084", "name": "樟樹分部　　　　　　　　　　　　　　　　"},
  {"code": "9030095", "name": "大同分部　　　　　　　　　　　　　　　　"}
  ],
  "904": [
  {"code": "9040018", "name": "新莊區農會信用部　　　　　　　　　　　　"},
  {"code": "9040029", "name": "丹鳳分部　　　　　　　　　　　　　　　　"},
  {"code": "9040030", "name": "頭前分部　　　　　　　　　　　　　　　　"},
  {"code": "9040063", "name": "西盛分部　　　　　　　　　　　　　　　　"},
  {"code": "9040074", "name": "中港分部　　　　　　　　　　　　　　　　"},
  {"code": "9040085", "name": "後港分部　　　　　　　　　　　　　　　　"},
  {"code": "9040096", "name": "營盤分部　　　　　　　　　　　　　　　　"},
  {"code": "9040100", "name": "瓊林分部　　　　　　　　　　　　　　　　"},
  {"code": "9040111", "name": "思源分部　　　　　　　　　　　　　　　　"},
  {"code": "9040122", "name": "新泰分部　　　　　　　　　　　　　　　　"}
  ],
  "906": [
  {"code": "9060010", "name": "頭份市農會　　　　　　　　　　　　　　　"},
  {"code": "9060021", "name": "上街分部　　　　　　　　　　　　　　　　"},
  {"code": "9060032", "name": "珊湖分部　　　　　　　　　　　　　　　　"},
  {"code": "9060043", "name": "尖山分部　　　　　　　　　　　　　　　　"},
  {"code": "9060054", "name": "中山分部　　　　　　　　　　　　　　　　"}
  ],
  "907": [
  {"code": "9070011", "name": "竹南鎮農會　　　　　　　　　　　　　　　"},
  {"code": "9070022", "name": "中港分部　　　　　　　　　　　　　　　　"},
  {"code": "9070033", "name": "大埔分部　　　　　　　　　　　　　　　　"},
  {"code": "9070044", "name": "龍鳳分部　　　　　　　　　　　　　　　　"}
  ],
  "908": [
  {"code": "9080012", "name": "通霄鎮農會　　　　　　　　　　　　　　　"},
  {"code": "9080023", "name": "白沙屯分部　　　　　　　　　　　　　　　"}
  ],
  "909": [
  {"code": "9090013", "name": "苑裡鎮農會　　　　　　　　　　　　　　　"},
  {"code": "9090024", "name": "山腳分部　　　　　　　　　　　　　　　　"},
  {"code": "9090035", "name": "社苓分部　　　　　　　　　　　　　　　　"}
  ],
  "912": [
  {"code": "9120019", "name": "冬山鄉農會信用部　　　　　　　　　　　　"},
  {"code": "9120020", "name": "羅東分部　　　　　　　　　　　　　　　　"},
  {"code": "9120031", "name": "順安分部　　　　　　　　　　　　　　　　"},
  {"code": "9120042", "name": "廣興分部　　　　　　　　　　　　　　　　"},
  {"code": "9120053", "name": "群英分部　　　　　　　　　　　　　　　　"}
  ],
  "913": [
  {"code": "9130010", "name": "後龍鎮農會　　　　　　　　　　　　　　　"},
  {"code": "9130021", "name": "新港分部　　　　　　　　　　　　　　　　"}
  ],
  "914": [
  {"code": "9140011", "name": "卓蘭鎮農會　　　　　　　　　　　　　　　"}
  ],
  "915": [
  {"code": "9150012", "name": "西湖鄉農會　　　　　　　　　　　　　　　"},
  {"code": "9150023", "name": "五湖分部　　　　　　　　　　　　　　　　"}
  ],
  "916": [
  {"code": "9160013", "name": "草屯鎮農會　　　　　　　　　　　　　　　"},
  {"code": "9160024", "name": "雙冬分部　　　　　　　　　　　　　　　　"},
  {"code": "9160035", "name": "南埔分部　　　　　　　　　　　　　　　　"},
  {"code": "9160057", "name": "芬草分部　　　　　　　　　　　　　　　　"},
  {"code": "9160068", "name": "虎山分部　　　　　　　　　　　　　　　　"},
  {"code": "9160079", "name": "北勢分部　　　　　　　　　　　　　　　　"},
  {"code": "9160080", "name": "新庄分部　　　　　　　　　　　　　　　　"},
  {"code": "9160091", "name": "富寮分部　　　　　　　　　　　　　　　　"}
  ],
  "917": [
  {"code": "9170014", "name": "公館鄉農會　　　　　　　　　　　　　　　"},
  {"code": "9170025", "name": "鶴岡分部　　　　　　　　　　　　　　　　"},
  {"code": "9170036", "name": "福基分部　　　　　　　　　　　　　　　　"},
  {"code": "9170047", "name": "五谷分部　　　　　　　　　　　　　　　　"}
  ],
  "918": [
  {"code": "9180015", "name": "銅鑼鄉農會　　　　　　　　　　　　　　　"},
  {"code": "9180026", "name": "中平分部　　　　　　　　　　　　　　　　"},
  {"code": "9180037", "name": "新盛隆分部　　　　　　　　　　　　　　　"}
  ],
  "919": [
  {"code": "9190016", "name": "三義鄉農會　　　　　　　　　　　　　　　"},
  {"code": "9190027", "name": "鯉魚分部　　　　　　　　　　　　　　　　"}
  ],
  "920": [
  {"code": "9200010", "name": "造橋鄉農會　　　　　　　　　　　　　　　"},
  {"code": "9200021", "name": "朝陽分部　　　　　　　　　　　　　　　　"},
  {"code": "9200032", "name": "大西分部　　　　　　　　　　　　　　　　"},
  {"code": "9200043", "name": "龍昇分部　　　　　　　　　　　　　　　　"},
  {"code": "9200054", "name": "豐湖分部　　　　　　　　　　　　　　　　"}
  ],
  "921": [
  {"code": "9210011", "name": "南庄鄉農會　　　　　　　　　　　　　　　"},
  {"code": "9210022", "name": "田美分部　　　　　　　　　　　　　　　　"},
  {"code": "9210033", "name": "南富分部　　　　　　　　　　　　　　　　"}
  ],
  "922": [
  {"code": "9220012", "name": "臺南地區農會信用部　　　　　　　　　　　"},
  {"code": "9220023", "name": "成功分部　　　　　　　　　　　　　　　　"},
  {"code": "9220034", "name": "聯合分部　　　　　　　　　　　　　　　　"},
  {"code": "9220056", "name": "安順分部　　　　　　　　　　　　　　　　"},
  {"code": "9220067", "name": "和順分部　　　　　　　　　　　　　　　　"},
  {"code": "9220078", "name": "土城分部　　　　　　　　　　　　　　　　"},
  {"code": "9220089", "name": "灣裡分部　　　　　　　　　　　　　　　　"}
  ],
  "923": [
  {"code": "9230013", "name": "獅潭鄉農會　　　　　　　　　　　　　　　"},
  {"code": "9230024", "name": "汶水分部　　　　　　　　　　　　　　　　"}
  ],
  "924": [
  {"code": "9240014", "name": "頭屋鄉農會　　　　　　　　　　　　　　　"},
  {"code": "9240025", "name": "明德分部　　　　　　　　　　　　　　　　"}
  ],
  "925": [
  {"code": "9250015", "name": "三灣鄉農會　　　　　　　　　　　　　　　"}
  ],
  "926": [
  {"code": "9260016", "name": "大湖地區農會　　　　　　　　　　　　　　"},
  {"code": "9260027", "name": "清安分部　　　　　　　　　　　　　　　　"},
  {"code": "9260038", "name": "新開分部　　　　　　　　　　　　　　　　"},
  {"code": "9260049", "name": "南湖分部　　　　　　　　　　　　　　　　"},
  {"code": "9260050", "name": "大湖分部　　　　　　　　　　　　　　　　"}
  ],
  "928": [
  {"code": "9280018", "name": "板橋區農會信用部　　　　　　　　　　　　"},
  {"code": "9280029", "name": "後埔分部　　　　　　　　　　　　　　　　"},
  {"code": "9280030", "name": "埔墘分部　　　　　　　　　　　　　　　　"},
  {"code": "9280041", "name": "社後分部　　　　　　　　　　　　　　　　"},
  {"code": "9280052", "name": "江翠分部　　　　　　　　　　　　　　　　"},
  {"code": "9280063", "name": "溪崑分部　　　　　　　　　　　　　　　　"},
  {"code": "9280074", "name": "浮洲分部　　　　　　　　　　　　　　　　"},
  {"code": "9280111", "name": "新埔分部　　　　　　　　　　　　　　　　"},
  {"code": "9280122", "name": "文化分部　　　　　　　　　　　　　　　　"}
  ],
  "929": [
  {"code": "9290019", "name": "關西鎮農會　　　　　　　　　　　　　　　"},
  {"code": "9290020", "name": "石光分部　　　　　　　　　　　　　　　　"},
  {"code": "9290031", "name": "錦山分部　　　　　　　　　　　　　　　　"}
  ],
  "930": [
  {"code": "9300013", "name": "新埔鎮農會　　　　　　　　　　　　　　　"},
  {"code": "9300024", "name": "照門分部　　　　　　　　　　　　　　　　"},
  {"code": "9300035", "name": "田新分部　　　　　　　　　　　　　　　　"}
  ],
  "931": [
  {"code": "9310014", "name": "竹北市農會　　　　　　　　　　　　　　　"},
  {"code": "9310025", "name": "六家分部　　　　　　　　　　　　　　　　"},
  {"code": "9310036", "name": "豐田分部　　　　　　　　　　　　　　　　"},
  {"code": "9310047", "name": "鳳岡分部　　　　　　　　　　　　　　　　"},
  {"code": "9310058", "name": "高鐵分部　　　　　　　　　　　　　　　　"}
  ],
  "932": [
  {"code": "9320015", "name": "湖口鄉農會　　　　　　　　　　　　　　　"},
  {"code": "9320026", "name": "中興分部　　　　　　　　　　　　　　　　"},
  {"code": "9320037", "name": "客家樓分部　　　　　　　　　　　　　　　"}
  ],
  "933": [
  {"code": "9330016", "name": "芎林鄉農會　　　　　　　　　　　　　　　"},
  {"code": "9330027", "name": "秀湖分部　　　　　　　　　　　　　　　　"},
  {"code": "9330038", "name": "石潭分部　　　　　　　　　　　　　　　　"},
  {"code": "9330049", "name": "上山分部　　　　　　　　　　　　　　　　"}
  ],
  "934": [
  {"code": "9340017", "name": "寶山鄉農會　　　　　　　　　　　　　　　"},
  {"code": "9340028", "name": "新城分部　　　　　　　　　　　　　　　　"},
  {"code": "9340039", "name": "寶山分部　　　　　　　　　　　　　　　　"}
  ],
  "935": [
  {"code": "9350018", "name": "峨眉鄉農會　　　　　　　　　　　　　　　"},
  {"code": "9350029", "name": "富興分部　　　　　　　　　　　　　　　　"}
  ],
  "936": [
  {"code": "9360019", "name": "北埔鄉農會　　　　　　　　　　　　　　　"}
  ],
  "937": [
  {"code": "9370010", "name": "竹東地區農會　　　　　　　　　　　　　　"},
  {"code": "9370021", "name": "竹中分部　　　　　　　　　　　　　　　　"},
  {"code": "9370032", "name": "二重分部　　　　　　　　　　　　　　　　"},
  {"code": "9370043", "name": "東寧分部　　　　　　　　　　　　　　　　"},
  {"code": "9370054", "name": "五峰分部　　　　　　　　　　　　　　　　"}
  ],
  "938": [
  {"code": "9380011", "name": "橫山地區農會　　　　　　　　　　　　　　"},
  {"code": "9380022", "name": "橫山分部　　　　　　　　　　　　　　　　"},
  {"code": "9380033", "name": "尖石分部　　　　　　　　　　　　　　　　"}
  ],
  "939": [
  {"code": "9390012", "name": "新豐鄉農會　　　　　　　　　　　　　　　"}
  ],
  "940": [
  {"code": "9400016", "name": "新竹市農會信用部　　　　　　　　　　　　"},
  {"code": "9400027", "name": "三姓橋分部　　　　　　　　　　　　　　　"},
  {"code": "9400038", "name": "內湖分部　　　　　　　　　　　　　　　　"},
  {"code": "9400049", "name": "民權分部　　　　　　　　　　　　　　　　"},
  {"code": "9400050", "name": "樹林頭分部　　　　　　　　　　　　　　　"},
  {"code": "9400061", "name": "光復分部　　　　　　　　　　　　　　　　"},
  {"code": "9400072", "name": "新興分部　　　　　　　　　　　　　　　　"},
  {"code": "9400083", "name": "虎林分部　　　　　　　　　　　　　　　　"},
  {"code": "9400094", "name": "光華分部　　　　　　　　　　　　　　　　"}
  ],
  "952": [
  {"code": "9520103", "name": "小港區農會　　　　　　　　　　　　　　　"}
  ],
  "953": [
  {"code": "9530012", "name": "田尾鄉農會　　　　　　　　　　　　　　　"},
  {"code": "9530023", "name": "溪畔分部　　　　　　　　　　　　　　　　"},
  {"code": "9530034", "name": "福田分部　　　　　　　　　　　　　　　　"},
  {"code": "9530045", "name": "海豐分部　　　　　　　　　　　　　　　　"}
  ],
  "984": [
  {"code": "9840012", "name": "北投區農會　　　　　　　　　　　　　　　"},
  {"code": "9840023", "name": "石牌分部　　　　　　　　　　　　　　　　"},
  {"code": "9840034", "name": "關渡分部　　　　　　　　　　　　　　　　"},
  {"code": "9840056", "name": "立農分部　　　　　　　　　　　　　　　　"},
  {"code": "9840067", "name": "大屯分部　　　　　　　　　　　　　　　　"},
  {"code": "9840078", "name": "福興分部　　　　　　　　　　　　　　　　"}
  ],
  "985": [
  {"code": "9850013", "name": "士林區農會　　　　　　　　　　　　　　　"},
  {"code": "9850024", "name": "文林分部　　　　　　　　　　　　　　　　"},
  {"code": "9850035", "name": "社子分部　　　　　　　　　　　　　　　　"},
  {"code": "9850046", "name": "天母分部　　　　　　　　　　　　　　　　"},
  {"code": "9850068", "name": "陽明山分部　　　　　　　　　　　　　　　"},
  {"code": "9850079", "name": "延平分部　　　　　　　　　　　　　　　　"}
  ],
  "986": [
  {"code": "9860014", "name": "內湖區農會　　　　　　　　　　　　　　　"},
  {"code": "9860025", "name": "潭美分部　　　　　　　　　　　　　　　　"},
  {"code": "9860036", "name": "東湖分部　　　　　　　　　　　　　　　　"},
  {"code": "9860047", "name": "西湖分部　　　　　　　　　　　　　　　　"},
  {"code": "9860058", "name": "民權分部　　　　　　　　　　　　　　　　"}
  ],
  "987": [
  {"code": "9870015", "name": "南港區農會　　　　　　　　　　　　　　　"},
  {"code": "9870026", "name": "中研分部　　　　　　　　　　　　　　　　"}
  ],
  "988": [
  {"code": "9880016", "name": "木柵區農會　　　　　　　　　　　　　　　"},
  {"code": "9880027", "name": "木新分部　　　　　　　　　　　　　　　　"}
  ],
  "989": [
  {"code": "9890017", "name": "景美區農會　　　　　　　　　　　　　　　"}
  ],
  "995": [
  {"code": "9950016", "name": "關貿網路股份有限公司　　　　　　　　　　"}
  ],
  "996": [
  {"code": "9960017", "name": "財政部國庫署　　　　　　　　　　　　　　"},
  {"code": "9960028", "name": "中部辦公室　　　　　　　　　　　　　　　"}
  ]
};

/**
 * 台灣縣市資料
 */
export const RocCountyInfo = [
    "基隆市",
    "台北市",
    "新北市",
    "桃園市",
    "新竹市",
    "新竹縣",
    "苗栗縣",
    "台中市",
    "彰化縣",
    "南投縣",
    "雲林縣",
    "嘉義市",
    "嘉義縣",
    "台南市",
    "高雄市",
    "屏東縣",
    "台東縣",
    "花蓮縣",
    "宜蘭縣",
    "澎湖縣",
    "金門縣",
    "連江縣",
    // "南海諸島"
];

/**
 * 台灣郵遞區號資料
 */
export const RocZipcode = {
  "基隆市": {
      "仁愛區": "200",
      "信義區": "201",
      "中正區": "202",
      "中山區": "203",
      "安樂區": "204",
      "暖暖區": "205",
      "七堵區": "206"
  },
  "台北市": {
      "中正區": "100",
      "大同區": "103",
      "中山區": "104",
      "松山區": "105",
      "大安區": "106",
      "萬華區": "108",
      "信義區": "110",
      "士林區": "111",
      "北投區": "112",
      "內湖區": "114",
      "南港區": "115",
      "文山區": "116"
  },
  "新北市": {
      "萬里區": "207",
      "金山區": "208",
      "板橋區": "220",
      "汐止區": "221",
      "深坑區": "222",
      "石碇區": "223",
      "瑞芳區": "224",
      "平溪區": "226",
      "雙溪區": "227",
      "貢寮區": "228",
      "新店區": "231",
      "坪林區": "232",
      "烏來區": "233",
      "永和區": "234",
      "中和區": "235",
      "土城區": "236",
      "三峽區": "237",
      "樹林區": "238",
      "鶯歌區": "239",
      "三重區": "241",
      "新莊區": "242",
      "泰山區": "243",
      "林口區": "244",
      "蘆洲區": "247",
      "五股區": "248",
      "八里區": "249",
      "淡水區": "251",
      "三芝區": "252",
      "石門區": "253"
  },
  "宜蘭縣": {
      "宜蘭市": "260",
      "頭城鎮": "261",
      "礁溪鄉": "262",
      "壯圍鄉": "263",
      "員山鄉": "264",
      "羅東鎮": "265",
      "三星鄉": "266",
      "大同鄉": "267",
      "五結鄉": "268",
      "冬山鄉": "269",
      "蘇澳鎮": "270",
      "南澳鄉": "272",
      "釣魚台列嶼": "290"
  },
  "新竹市": {
      "東區": "300",
      "北區": "300",
      "香山區": "300"
  },
  "新竹縣": {
      "竹北市": "302",
      "湖口鄉": "303",
      "新豐鄉": "304",
      "新埔鎮": "305",
      "關西鎮": "306",
      "芎林鄉": "307",
      "寶山鄉": "308",
      "竹東鎮": "310",
      "五峰鄉": "311",
      "橫山鄉": "312",
      "尖石鄉": "313",
      "北埔鄉": "314",
      "峨嵋鄉": "315"
  },
  "桃園市": {
      "中壢區": "320",
      "平鎮區": "324",
      "龍潭區": "325",
      "楊梅區": "326",
      "新屋區": "327",
      "觀音區": "328",
      "桃園區": "330",
      "龜山區": "333",
      "八德區": "334",
      "大溪區": "335",
      "復興區": "336",
      "大園區": "337",
      "蘆竹區": "338"
  },
  "苗栗縣": {
      "竹南鎮": "350",
      "頭份市": "351",
      "三灣鄉": "352",
      "南庄鄉": "353",
      "獅潭鄉": "354",
      "後龍鎮": "356",
      "通霄鎮": "357",
      "苑裡鎮": "358",
      "苗栗市": "360",
      "造橋鄉": "361",
      "頭屋鄉": "362",
      "公館鄉": "363",
      "大湖鄉": "364",
      "泰安鄉": "365",
      "銅鑼鄉": "366",
      "三義鄉": "367",
      "西湖鄉": "368",
      "卓蘭鎮": "369"
  },
  "台中市": {
      "中區": "400",
      "東區": "401",
      "南區": "402",
      "西區": "403",
      "北區": "404",
      "北屯區": "406",
      "西屯區": "407",
      "南屯區": "408",
      "太平區": "411",
      "大里區": "412",
      "霧峰區": "413",
      "烏日區": "414",
      "豐原區": "420",
      "后里區": "421",
      "石岡區": "422",
      "東勢區": "423",
      "和平區": "424",
      "新社區": "426",
      "潭子區": "427",
      "大雅區": "428",
      "神岡區": "429",
      "大肚區": "432",
      "沙鹿區": "433",
      "龍井區": "434",
      "梧棲區": "435",
      "清水區": "436",
      "大甲區": "437",
      "外埔區": "438",
      "大安區": "439"
  },
  "彰化縣": {
      "彰化市": "500",
      "芬園鄉": "502",
      "花壇鄉": "503",
      "秀水鄉": "504",
      "鹿港鎮": "505",
      "福興鄉": "506",
      "線西鄉": "507",
      "和美鎮": "508",
      "伸港鄉": "509",
      "員林市": "510",
      "社頭鄉": "511",
      "永靖鄉": "512",
      "埔心鄉": "513",
      "溪湖鎮": "514",
      "大村鄉": "515",
      "埔鹽鄉": "516",
      "田中鎮": "520",
      "北斗鎮": "521",
      "田尾鄉": "522",
      "埤頭鄉": "523",
      "溪州鄉": "524",
      "竹塘鄉": "525",
      "二林鎮": "526",
      "大城鄉": "527",
      "芳苑鄉": "528",
      "二水鄉": "530"
  },
  "南投縣": {
      "南投市": "540",
      "中寮鄉": "541",
      "草屯鎮": "542",
      "國姓鄉": "544",
      "埔里鎮": "545",
      "仁愛鄉": "546",
      "名間鄉": "551",
      "集集鎮": "552",
      "水里鄉": "553",
      "魚池鄉": "555",
      "信義鄉": "556",
      "竹山鎮": "557",
      "鹿谷鄉": "558"
  },
  "嘉義市": {
      "東區": "600",
      "西區": "600"
  },
  "嘉義縣": {
      "番路鄉": "602",
      "梅山鄉": "603",
      "竹崎鄉": "604",
      "阿里山": "605",
      "中埔鄉": "606",
      "大埔鄉": "607",
      "水上鄉": "608",
      "鹿草鄉": "611",
      "太保市": "612",
      "朴子市": "613",
      "東石鄉": "614",
      "六腳鄉": "615",
      "新港鄉": "616",
      "民雄鄉": "621",
      "大林鎮": "622",
      "溪口鄉": "623",
      "義竹鄉": "624",
      "布袋鎮": "625"
  },
  "雲林縣": {
      "斗南鎮": "630",
      "大埤鄉": "631",
      "虎尾鎮": "632",
      "土庫鎮": "633",
      "褒忠鄉": "634",
      "東勢鄉": "635",
      "臺西鄉": "636",
      "崙背鄉": "637",
      "麥寮鄉": "638",
      "斗六市": "640",
      "林內鄉": "643",
      "古坑鄉": "646",
      "莿桐鄉": "647",
      "西螺鎮": "648",
      "二崙鄉": "649",
      "北港鎮": "651",
      "水林鄉": "652",
      "口湖鄉": "653",
      "四湖鄉": "654",
      "元長鄉": "655"
  },
  "台南市": {
      "中西區": "700",
      "東區": "701",
      "南區": "702",
      "北區": "704",
      "安平區": "708",
      "安南區": "709",
      "永康區": "710",
      "歸仁區": "711",
      "新化區": "712",
      "左鎮區": "713",
      "玉井區": "714",
      "楠西區": "715",
      "南化區": "716",
      "仁德區": "717",
      "關廟區": "718",
      "龍崎區": "719",
      "官田區": "720",
      "麻豆區": "721",
      "佳里區": "722",
      "西港區": "723",
      "七股區": "724",
      "將軍區": "725",
      "學甲區": "726",
      "北門區": "727",
      "新營區": "730",
      "後壁區": "731",
      "白河區": "732",
      "東山區": "733",
      "六甲區": "734",
      "下營區": "735",
      "柳營區": "736",
      "鹽水區": "737",
      "善化區": "741",
      "大內區": "742",
      "山上區": "743",
      "新市區": "744",
      "安定區": "745"
  },
  "高雄市": {
      "新興區": "800",
      "前金區": "801",
      "苓雅區": "802",
      "鹽埕區": "803",
      "鼓山區": "804",
      "旗津區": "805",
      "前鎮區": "806",
      "三民區": "807",
      "楠梓區": "811",
      "小港區": "812",
      "左營區": "813",
      "仁武區": "814",
      "大社區": "815",
      "岡山區": "820",
      "路竹區": "821",
      "阿蓮區": "822",
      "田寮鄉": "823",
      "燕巢區": "824",
      "橋頭區": "825",
      "梓官區": "826",
      "彌陀區": "827",
      "永安區": "828",
      "湖內鄉": "829",
      "鳳山區": "830",
      "大寮區": "831",
      "林園區": "832",
      "鳥松區": "833",
      "大樹區": "840",
      "旗山區": "842",
      "美濃區": "843",
      "六龜區": "844",
      "內門區": "845",
      "杉林區": "846",
      "甲仙區": "847",
      "桃源區": "848",
      "那瑪夏區": "849",
      "茂林區": "851",
      "茄萣區": "852"
  },
  "屏東縣": {
      "屏東市": "900",
      "三地門": "901",
      "霧臺鄉": "902",
      "瑪家鄉": "903",
      "九如鄉": "904",
      "里港鄉": "905",
      "高樹鄉": "906",
      "鹽埔鄉": "907",
      "長治鄉": "908",
      "麟洛鄉": "909",
      "竹田鄉": "911",
      "內埔鄉": "912",
      "萬丹鄉": "913",
      "潮州鎮": "920",
      "泰武鄉": "921",
      "來義鄉": "922",
      "萬巒鄉": "923",
      "崁頂鄉": "924",
      "新埤鄉": "925",
      "南州鄉": "926",
      "林邊鄉": "927",
      "東港鎮": "928",
      "琉球鄉": "929",
      "佳冬鄉": "931",
      "新園鄉": "932",
      "枋寮鄉": "940",
      "枋山鄉": "941",
      "春日鄉": "942",
      "獅子鄉": "943",
      "車城鄉": "944",
      "牡丹鄉": "945",
      "恆春鎮": "946",
      "滿州鄉": "947"
  },
  "台東縣": {
      "臺東市": "950",
      "綠島鄉": "951",
      "蘭嶼鄉": "952",
      "延平鄉": "953",
      "卑南鄉": "954",
      "鹿野鄉": "955",
      "關山鎮": "956",
      "海端鄉": "957",
      "池上鄉": "958",
      "東河鄉": "959",
      "成功鎮": "961",
      "長濱鄉": "962",
      "太麻里鄉": "963",
      "金峰鄉": "964",
      "大武鄉": "965",
      "達仁鄉": "966"
  },
  "花蓮縣": {
      "花蓮市": "970",
      "新城鄉": "971",
      "秀林鄉": "972",
      "吉安鄉": "973",
      "壽豐鄉": "974",
      "鳳林鎮": "975",
      "光復鄉": "976",
      "豐濱鄉": "977",
      "瑞穗鄉": "978",
      "萬榮鄉": "979",
      "玉里鎮": "981",
      "卓溪鄉": "982",
      "富里鄉": "983"
  },
  "金門縣": {
      "金沙鎮": "890",
      "金湖鎮": "891",
      "金寧鄉": "892",
      "金城鎮": "893",
      "烈嶼鄉": "894",
      "烏坵鄉": "896"
  },
  "連江縣": {
      "南竿鄉": "209",
      "北竿鄉": "210",
      "莒光鄉": "211",
      "東引鄉": "212"
  },
  "澎湖縣": {
      "馬公市": "880",
      "西嶼鄉": "881",
      "望安鄉": "882",
      "七美鄉": "883",
      "白沙鄉": "884",
      "湖西鄉": "885"
  },
  "南海諸島": {
      "東沙": "817",
      "南沙": "819"
  }
};



// WEBPACK FOOTER //
// ./src/models/HELPERS/utilitiesData.js